export const TIETKHI_DATEFORMAT = 'D/M/YYYY HH:mm'
export const TIETKHI_DATE_TIME_FORMAT = 'D/M/YYYY HH:mm'
export const TIETKHI_DATE_FORMAT = 'D/M/YYYY'

export const TIETKHI_MONTH = {
  '1t': 'Tiểu hàn',
  '1k': 'Đại hàn',
  '2t': 'Lập xuân',
  '2k': 'Vũ thủy',
  '3t': 'Kinh trập',
  '3k': 'Xuân phân',
  '4t': 'Thanh minh',
  '4k': 'Cốc vũ',
  '5t': 'Lập hạ',
  '5k': 'Tiểu mãn',
  '6t': 'Mang chủng',
  '6k': 'Hạ chí',
  '7t': 'Tiểu thử',
  '7k': 'Đại thử',
  '8t': 'Lập thu',
  '8k': 'Xử thử',
  '9t': 'Bạch lộ',
  '9k': 'Thu phân',
  '10t': 'Hàn lộ',
  '10k': 'Sương giáng',
  '11t': 'Lập đông',
  '11k': 'Tiểu tuyết',
  '12t': 'Đại tuyết',
  '12k': 'Đông chí'
}

export const TIETKHI_YEAR = {
  '1t1900': '6/1/1900 01:11',
  '1k1900': '20/1/1900 18:39',
  '2t1900': '4/2/1900 12:58',
  '2k1900': '19/2/1900 09:08',
  '3t1900': '6/3/1900 07:29',
  '3k1900': '21/3/1900 08:46',
  '4t1900': '5/4/1900 12:59',
  '4k1900': '20/4/1900 20:34',
  '5t1900': '6/5/1900 07:02',
  '5k1900': '21/5/1900 20:24',
  '6t1900': '6/6/1900 11:46',
  '6k1900': '22/6/1900 04:47',
  '7t1900': '7/7/1900 22:17',
  '7k1900': '23/7/1900 15:43',
  '8t1900': '8/8/1900 07:57',
  '8k1900': '23/8/1900 22:27',
  '9t1900': '8/9/1900 10:23',
  '9k1900': '23/9/1900 19:27',
  '10t1900': '9/10/1900 01:20',
  '10k1900': '24/10/1900 04:02',
  '11t1900': '8/11/1900 03:47',
  '11k1900': '23/11/1900 00:55',
  '12t1900': '7/12/1900 20:03',
  '12k1900': '22/12/1900 13:48',
  '1t1901': '6/1/1901 07:00',
  '1k1901': '21/1/1901 00:23',
  '2t1901': '4/2/1901 18:47',
  '2k1901': '19/2/1901 14:52',
  '3t1901': '6/3/1901 13:18',
  '3k1901': '21/3/1901 14:30',
  '4t1901': '5/4/1901 18:51',
  '4k1901': '21/4/1901 02:20',
  '5t1901': '6/5/1901 12:57',
  '5k1901': '22/5/1901 02:11',
  '6t1901': '6/6/1901 17:43',
  '6k1901': '22/6/1901 10:35',
  '7t1901': '8/7/1901 04:14',
  '7k1901': '23/7/1901 21:31',
  '8t1901': '8/8/1901 13:53',
  '8k1901': '24/8/1901 04:14',
  '9t1901': '8/9/1901 16:17',
  '9k1901': '24/9/1901 01:16',
  '10t1901': '9/10/1901 07:13',
  '10k1901': '24/10/1901 09:53',
  '11t1901': '8/11/1901 09:41',
  '11k1901': '23/11/1901 06:48',
  '12t1901': '8/12/1901 01:59',
  '12k1901': '22/12/1901 19:43',
  '1t1902': '6/1/1902 12:58',
  '1k1902': '21/1/1902 06:19',
  '2t1902': '5/2/1902 00:45',
  '2k1902': '19/2/1902 20:46',
  '3t1902': '6/3/1902 19:14',
  '3k1902': '21/3/1902 20:23',
  '4t1902': '6/4/1902 00:44',
  '4k1902': '21/4/1902 08:11',
  '5t1902': '6/5/1902 18:46',
  '5k1902': '22/5/1902 08:00',
  '6t1902': '6/6/1902 23:27',
  '6k1902': '22/6/1902 16:22',
  '7t1902': '8/7/1902 09:53',
  '7k1902': '24/7/1902 03:17',
  '8t1902': '8/8/1902 19:29',
  '8k1902': '24/8/1902 10:00',
  '9t1902': '8/9/1902 21:53',
  '9k1902': '24/9/1902 07:02',
  '10t1902': '9/10/1902 12:52',
  '10k1902': '24/10/1902 15:42',
  '11t1902': '8/11/1902 15:25',
  '11k1902': '23/11/1902 12:42',
  '12t1902': '8/12/1902 07:48',
  '12k1902': '23/12/1902 01:42',
  '1t1903': '6/1/1903 18:50',
  '1k1903': '21/1/1903 12:20',
  '2t1903': '5/2/1903 06:38',
  '2k1903': '20/2/1903 02:48',
  '3t1903': '7/3/1903 01:06',
  '3k1903': '22/3/1903 02:22',
  '4t1903': '6/4/1903 06:33',
  '4k1903': '21/4/1903 14:05',
  '5t1903': '7/5/1903 00:32',
  '5k1903': '22/5/1903 13:52',
  '6t1903': '7/6/1903 05:14',
  '6k1903': '22/6/1903 22:12',
  '7t1903': '8/7/1903 15:43',
  '7k1903': '24/7/1903 09:06',
  '8t1903': '9/8/1903 01:23',
  '8k1903': '24/8/1903 15:48',
  '9t1903': '9/9/1903 03:49',
  '9k1903': '24/9/1903 12:50',
  '10t1903': '9/10/1903 18:49',
  '10k1903': '24/10/1903 21:30',
  '11t1903': '8/11/1903 21:20',
  '11k1903': '23/11/1903 18:28',
  '12t1903': '8/12/1903 13:42',
  '12k1903': '23/12/1903 07:27',
  '1t1904': '7/1/1904 00:44',
  '1k1904': '21/1/1904 18:05',
  '2t1904': '5/2/1904 12:31',
  '2k1904': '20/2/1904 08:32',
  '3t1904': '6/3/1904 06:58',
  '3k1904': '21/3/1904 08:05',
  '4t1904': '5/4/1904 12:26',
  '4k1904': '20/4/1904 19:49',
  '5t1904': '6/5/1904 06:25',
  '5k1904': '21/5/1904 19:36',
  '6t1904': '6/6/1904 11:08',
  '6k1904': '22/6/1904 03:58',
  '7t1904': '7/7/1904 21:38',
  '7k1904': '23/7/1904 14:56',
  '8t1904': '8/8/1904 07:19',
  '8k1904': '23/8/1904 21:43',
  '9t1904': '8/9/1904 09:45',
  '9k1904': '23/9/1904 18:47',
  '10t1904': '9/10/1904 00:42',
  '10k1904': '24/10/1904 03:26',
  '11t1904': '8/11/1904 03:12',
  '11k1904': '23/11/1904 00:23',
  '12t1904': '7/12/1904 19:32',
  '12k1904': '22/12/1904 13:21',
  '1t1905': '6/1/1905 06:34',
  '1k1905': '20/1/1905 23:59',
  '2t1905': '4/2/1905 18:23',
  '2k1905': '19/2/1905 14:28',
  '3t1905': '6/3/1905 12:52',
  '3k1905': '21/3/1905 14:04',
  '4t1905': '5/4/1905 18:21',
  '4k1905': '21/4/1905 01:51',
  '5t1905': '6/5/1905 12:21',
  '5k1905': '22/5/1905 01:38',
  '6t1905': '6/6/1905 17:00',
  '6k1905': '22/6/1905 09:58',
  '7t1905': '8/7/1905 03:27',
  '7k1905': '23/7/1905 20:52',
  '8t1905': '8/8/1905 13:04',
  '8k1905': '24/8/1905 03:35',
  '9t1905': '8/9/1905 15:29',
  '9k1905': '24/9/1905 00:37',
  '10t1905': '9/10/1905 06:26',
  '10k1905': '24/10/1905 09:15',
  '11t1905': '8/11/1905 08:57',
  '11k1905': '23/11/1905 06:12',
  '12t1905': '8/12/1905 01:18',
  '12k1905': '22/12/1905 19:10',
  '1t1906': '6/1/1906 12:20',
  '1k1906': '21/1/1906 05:50',
  '2t1906': '5/2/1906 00:11',
  '2k1906': '19/2/1906 20:21',
  '3t1906': '6/3/1906 18:43',
  '3k1906': '21/3/1906 20:00',
  '4t1906': '6/4/1906 00:14',
  '4k1906': '21/4/1906 07:46',
  '5t1906': '6/5/1906 18:15',
  '5k1906': '22/5/1906 07:32',
  '6t1906': '6/6/1906 22:56',
  '6k1906': '22/6/1906 15:48',
  '7t1906': '8/7/1906 09:22',
  '7k1906': '24/7/1906 02:39',
  '8t1906': '8/8/1906 18:58',
  '8k1906': '24/8/1906 09:20',
  '9t1906': '8/9/1906 21:23',
  '9k1906': '24/9/1906 06:21',
  '10t1906': '9/10/1906 12:21',
  '10k1906': '24/10/1906 15:01',
  '11t1906': '8/11/1906 14:53',
  '11k1906': '23/11/1906 12:00',
  '12t1906': '8/12/1906 07:16',
  '12k1906': '23/12/1906 01:00',
  '1t1907': '6/1/1907 18:18',
  '1k1907': '21/1/1907 11:37',
  '2t1907': '5/2/1907 06:05',
  '2k1907': '20/2/1907 02:05',
  '3t1907': '7/3/1907 00:34',
  '3k1907': '22/3/1907 01:39',
  '4t1907': '6/4/1907 06:01',
  '4k1907': '21/4/1907 13:24',
  '5t1907': '7/5/1907 00:00',
  '5k1907': '22/5/1907 13:10',
  '6t1907': '7/6/1907 04:39',
  '6k1907': '22/6/1907 21:29',
  '7t1907': '8/7/1907 15:06',
  '7k1907': '24/7/1907 08:24',
  '8t1907': '9/8/1907 00:42',
  '8k1907': '24/8/1907 15:10',
  '9t1907': '9/9/1907 03:08',
  '9k1907': '24/9/1907 12:15',
  '10t1907': '9/10/1907 18:09',
  '10k1907': '24/10/1907 20:58',
  '11t1907': '8/11/1907 20:43',
  '11k1907': '23/11/1907 17:58',
  '12t1907': '8/12/1907 13:06',
  '12k1907': '23/12/1907 06:58',
  '1t1908': '7/1/1908 00:08',
  '1k1908': '21/1/1908 17:34',
  '2t1908': '5/2/1908 11:54',
  '2k1908': '20/2/1908 08:00',
  '3t1908': '6/3/1908 06:20',
  '3k1908': '21/3/1908 07:34',
  '4t1908': '5/4/1908 11:46',
  '4k1908': '20/4/1908 19:18',
  '5t1908': '6/5/1908 05:45',
  '5k1908': '21/5/1908 19:05',
  '6t1908': '6/6/1908 10:25',
  '6k1908': '22/6/1908 03:25',
  '7t1908': '7/7/1908 20:54',
  '7k1908': '23/7/1908 14:21',
  '8t1908': '8/8/1908 06:33',
  '8k1908': '23/8/1908 21:03',
  '9t1908': '8/9/1908 08:59',
  '9k1908': '23/9/1908 18:05',
  '10t1908': '8/10/1908 23:57',
  '10k1908': '24/10/1908 02:43',
  '11t1908': '8/11/1908 02:28',
  '11k1908': '22/11/1908 23:41',
  '12t1908': '7/12/1908 18:50',
  '12k1908': '22/12/1908 12:40',
  '1t1909': '6/1/1909 05:52',
  '1k1909': '20/1/1909 23:17',
  '2t1909': '4/2/1909 17:39',
  '2k1909': '19/2/1909 13:45',
  '3t1909': '6/3/1909 12:07',
  '3k1909': '21/3/1909 13:19',
  '4t1909': '5/4/1909 17:36',
  '4k1909': '21/4/1909 01:04',
  '5t1909': '6/5/1909 11:37',
  '5k1909': '22/5/1909 00:51',
  '6t1909': '6/6/1909 16:20',
  '6k1909': '22/6/1909 09:12',
  '7t1909': '8/7/1909 02:50',
  '7k1909': '23/7/1909 20:07',
  '8t1909': '8/8/1909 12:29',
  '8k1909': '24/8/1909 02:50',
  '9t1909': '8/9/1909 14:53',
  '9k1909': '23/9/1909 23:51',
  '10t1909': '9/10/1909 05:50',
  '10k1909': '24/10/1909 08:29',
  '11t1909': '8/11/1909 08:20',
  '11k1909': '23/11/1909 05:27',
  '12t1909': '8/12/1909 00:41',
  '12k1909': '22/12/1909 18:26',
  '1t1910': '6/1/1910 11:44',
  '1k1910': '21/1/1910 05:05',
  '2t1910': '4/2/1910 23:34',
  '2k1910': '19/2/1910 19:35',
  '3t1910': '6/3/1910 18:03',
  '3k1910': '21/3/1910 19:09',
  '4t1910': '5/4/1910 23:29',
  '4k1910': '21/4/1910 06:52',
  '5t1910': '6/5/1910 17:26',
  '5k1910': '22/5/1910 06:37',
  '6t1910': '6/6/1910 22:03',
  '6k1910': '22/6/1910 14:55',
  '7t1910': '8/7/1910 08:27',
  '7k1910': '24/7/1910 01:49',
  '8t1910': '8/8/1910 18:04',
  '8k1910': '24/8/1910 08:34',
  '9t1910': '8/9/1910 20:29',
  '9k1910': '24/9/1910 05:37',
  '10t1910': '9/10/1910 11:28',
  '10k1910': '24/10/1910 14:18',
  '11t1910': '8/11/1910 14:00',
  '11k1910': '23/11/1910 11:17',
  '12t1910': '8/12/1910 06:23',
  '12k1910': '23/12/1910 00:18',
  '1t1911': '6/1/1911 17:27',
  '1k1911': '21/1/1911 10:58',
  '2t1911': '5/2/1911 05:17',
  '2k1911': '20/2/1911 01:27',
  '3t1911': '6/3/1911 23:45',
  '3k1911': '22/3/1911 00:54',
  '4t1911': '6/4/1911 05:05',
  '4k1911': '21/4/1911 12:36',
  '5t1911': '6/5/1911 23:00',
  '5k1911': '22/5/1911 12:19',
  '6t1911': '7/6/1911 03:38',
  '6k1911': '22/6/1911 20:36',
  '7t1911': '8/7/1911 14:05',
  '7k1911': '24/7/1911 07:29',
  '8t1911': '8/8/1911 23:45',
  '8k1911': '24/8/1911 14:13',
  '9t1911': '9/9/1911 02:13',
  '9k1911': '24/9/1911 11:18',
  '10t1911': '9/10/1911 17:15',
  '10k1911': '24/10/1911 19:58',
  '11t1911': '8/11/1911 19:47',
  '11k1911': '23/11/1911 16:56',
  '12t1911': '8/12/1911 12:08',
  '12k1911': '23/12/1911 05:53',
  '1t1912': '6/1/1912 23:08',
  '1k1912': '21/1/1912 16:29',
  '2t1912': '5/2/1912 10:54',
  '2k1912': '20/2/1912 06:56',
  '3t1912': '6/3/1912 05:21',
  '3k1912': '21/3/1912 06:29',
  '4t1912': '5/4/1912 10:48',
  '4k1912': '20/4/1912 18:12',
  '5t1912': '6/5/1912 05:47',
  '5k1912': '21/5/1912 18:57',
  '6t1912': '6/6/1912 10:28',
  '6k1912': '22/6/1912 03:17',
  '7t1912': '7/7/1912 20:57',
  '7k1912': '23/7/1912 14:14',
  '8t1912': '8/8/1912 06:37',
  '8k1912': '23/8/1912 21:01',
  '9t1912': '8/9/1912 09:06',
  '9k1912': '23/9/1912 18:08',
  '10t1912': '9/10/1912 00:07',
  '10k1912': '24/10/1912 02:50',
  '11t1912': '8/11/1912 02:39',
  '11k1912': '22/11/1912 23:48',
  '12t1912': '7/12/1912 18:59',
  '12k1912': '22/12/1912 12:45',
  '1t1913': '6/1/1913 05:58',
  '1k1913': '20/1/1913 23:19',
  '2t1913': '4/2/1913 17:43',
  '2k1913': '19/2/1913 13:44',
  '3t1913': '6/3/1913 12:09',
  '3k1913': '21/3/1913 13:18',
  '4t1913': '5/4/1913 17:36',
  '4k1913': '21/4/1913 01:03',
  '5t1913': '6/5/1913 11:35',
  '5k1913': '22/5/1913 00:50',
  '6t1913': '6/6/1913 16:14',
  '6k1913': '22/6/1913 09:10',
  '7t1913': '8/7/1913 02:39',
  '7k1913': '23/7/1913 20:04',
  '8t1913': '8/8/1913 12:16',
  '8k1913': '24/8/1913 02:48',
  '9t1913': '8/9/1913 14:42',
  '9k1913': '23/9/1913 23:53',
  '10t1913': '9/10/1913 05:44',
  '10k1913': '24/10/1913 08:35',
  '11t1913': '8/11/1913 08:18',
  '11k1913': '23/11/1913 05:35',
  '12t1913': '8/12/1913 00:41',
  '12k1913': '22/12/1913 18:35',
  '1t1914': '6/1/1914 11:43',
  '1k1914': '21/1/1914 05:12',
  '2t1914': '4/2/1914 23:29',
  '2k1914': '19/2/1914 19:38',
  '3t1914': '6/3/1914 17:56',
  '3k1914': '21/3/1914 19:11',
  '4t1914': '5/4/1914 23:22',
  '4k1914': '21/4/1914 06:53',
  '5t1914': '6/5/1914 17:20',
  '5k1914': '22/5/1914 06:38',
  '6t1914': '6/6/1914 22:00',
  '6k1914': '22/6/1914 14:55',
  '7t1914': '8/7/1914 08:27',
  '7k1914': '24/7/1914 01:47',
  '8t1914': '8/8/1914 18:05',
  '8k1914': '24/8/1914 08:30',
  '9t1914': '8/9/1914 20:33',
  '9k1914': '24/9/1914 05:34',
  '10t1914': '9/10/1914 11:35',
  '10k1914': '24/10/1914 14:17',
  '11t1914': '8/11/1914 14:11',
  '11k1914': '23/11/1914 11:20',
  '12t1914': '8/12/1914 06:37',
  '12k1914': '23/12/1914 00:22',
  '1t1915': '6/1/1915 17:40',
  '1k1915': '21/1/1915 11:00',
  '2t1915': '5/2/1915 05:26',
  '2k1915': '20/2/1915 01:23',
  '3t1915': '6/3/1915 23:48',
  '3k1915': '22/3/1915 00:51',
  '4t1915': '6/4/1915 05:09',
  '4k1915': '21/4/1915 12:29',
  '5t1915': '6/5/1915 23:03',
  '5k1915': '22/5/1915 12:10',
  '6t1915': '7/6/1915 03:40',
  '6k1915': '22/6/1915 20:29',
  '7t1915': '8/7/1915 14:08',
  '7k1915': '24/7/1915 07:26',
  '8t1915': '8/8/1915 23:48',
  '8k1915': '24/8/1915 14:15',
  '9t1915': '9/9/1915 02:17',
  '9k1915': '24/9/1915 11:24',
  '10t1915': '9/10/1915 17:21',
  '10k1915': '24/10/1915 20:10',
  '11t1915': '8/11/1915 19:58',
  '11k1915': '23/11/1915 17:14',
  '12t1915': '8/12/1915 12:24',
  '12k1915': '23/12/1915 06:16',
  '1t1916': '6/1/1916 23:28',
  '1k1916': '21/1/1916 16:54',
  '2t1916': '5/2/1916 11:14',
  '2k1916': '20/2/1916 07:18',
  '3t1916': '6/3/1916 05:37',
  '3k1916': '21/3/1916 06:47',
  '4t1916': '5/4/1916 10:58',
  '4k1916': '20/4/1916 18:25',
  '5t1916': '6/5/1916 04:50',
  '5k1916': '21/5/1916 18:06',
  '6t1916': '6/6/1916 09:26',
  '6k1916': '22/6/1916 02:24',
  '7t1916': '7/7/1916 19:54',
  '7k1916': '23/7/1916 13:21',
  '8t1916': '8/8/1916 05:35',
  '8k1916': '23/8/1916 20:09',
  '9t1916': '8/9/1916 08:05',
  '9k1916': '23/9/1916 17:15',
  '10t1916': '8/10/1916 23:08',
  '10k1916': '24/10/1916 01:57',
  '11t1916': '8/11/1916 01:42',
  '11k1916': '22/11/1916 22:58',
  '12t1916': '7/12/1916 18:06',
  '12k1916': '22/12/1916 11:59',
  '1t1917': '6/1/1917 05:10',
  '1k1917': '20/1/1917 22:37',
  '2t1917': '4/2/1917 16:58',
  '2k1917': '19/2/1917 13:05',
  '3t1917': '6/3/1917 11:25',
  '3k1917': '21/3/1917 12:37',
  '4t1917': '5/4/1917 16:50',
  '4k1917': '21/4/1917 00:17',
  '5t1917': '6/5/1917 10:46',
  '5k1917': '21/5/1917 23:59',
  '6t1917': '6/6/1917 15:23',
  '6k1917': '22/6/1917 08:14',
  '7t1917': '8/7/1917 01:50',
  '7k1917': '23/7/1917 19:08',
  '8t1917': '8/8/1917 11:30',
  '8k1917': '24/8/1917 01:54',
  '9t1917': '8/9/1917 13:59',
  '9k1917': '23/9/1917 23:00',
  '10t1917': '9/10/1917 05:02',
  '10k1917': '24/10/1917 07:44',
  '11t1917': '8/11/1917 07:37',
  '11k1917': '23/11/1917 04:45',
  '12t1917': '8/12/1917 00:01',
  '12k1917': '22/12/1917 17:46',
  '1t1918': '6/1/1918 11:04',
  '1k1918': '21/1/1918 04:25',
  '2t1918': '4/2/1918 22:53',
  '2k1918': '19/2/1918 18:53',
  '3t1918': '6/3/1918 17:21',
  '3k1918': '21/3/1918 18:26',
  '4t1918': '5/4/1918 22:45',
  '4k1918': '21/4/1918 06:05',
  '5t1918': '6/5/1918 16:38',
  '5k1918': '22/5/1918 05:46',
  '6t1918': '6/6/1918 21:11',
  '6k1918': '22/6/1918 14:00',
  '7t1918': '8/7/1918 07:32',
  '7k1918': '24/7/1918 00:51',
  '8t1918': '8/8/1918 17:08',
  '8k1918': '24/8/1918 07:37',
  '9t1918': '8/9/1918 19:36',
  '9k1918': '24/9/1918 04:46',
  '10t1918': '9/10/1918 10:40',
  '10k1918': '24/10/1918 13:33',
  '11t1918': '8/11/1918 13:19',
  '11k1918': '23/11/1918 10:38',
  '12t1918': '8/12/1918 05:47',
  '12k1918': '22/12/1918 23:42',
  '1t1919': '6/1/1919 16:52',
  '1k1919': '21/1/1919 10:21',
  '2t1919': '5/2/1919 04:39',
  '2k1919': '20/2/1919 00:48',
  '3t1919': '6/3/1919 23:06',
  '3k1919': '22/3/1919 00:19',
  '4t1919': '6/4/1919 04:29',
  '4k1919': '21/4/1919 11:59',
  '5t1919': '6/5/1919 22:22',
  '5k1919': '22/5/1919 11:39',
  '6t1919': '7/6/1919 02:57',
  '6k1919': '22/6/1919 19:54',
  '7t1919': '8/7/1919 13:21',
  '7k1919': '24/7/1919 06:45',
  '8t1919': '8/8/1919 22:58',
  '8k1919': '24/8/1919 13:28',
  '9t1919': '9/9/1919 01:28',
  '9k1919': '24/9/1919 10:35',
  '10t1919': '9/10/1919 16:33',
  '10k1919': '24/10/1919 19:21',
  '11t1919': '8/11/1919 19:12',
  '11k1919': '23/11/1919 16:25',
  '12t1919': '8/12/1919 11:38',
  '12k1919': '23/12/1919 05:27',
  '1t1920': '6/1/1920 22:41',
  '1k1920': '21/1/1920 16:04',
  '2t1920': '5/2/1920 10:27',
  '2k1920': '20/2/1920 06:29',
  '3t1920': '6/3/1920 04:51',
  '3k1920': '21/3/1920 05:59',
  '4t1920': '5/4/1920 10:15',
  '4k1920': '20/4/1920 17:39',
  '5t1920': '6/5/1920 04:11',
  '5k1920': '21/5/1920 17:22',
  '6t1920': '6/6/1920 08:50',
  '6k1920': '22/6/1920 01:40',
  '7t1920': '7/7/1920 19:19',
  '7k1920': '23/7/1920 12:35',
  '8t1920': '8/8/1920 04:58',
  '8k1920': '23/8/1920 19:21',
  '9t1920': '8/9/1920 07:27',
  '9k1920': '23/9/1920 16:28',
  '10t1920': '8/10/1920 22:29',
  '10k1920': '24/10/1920 01:13',
  '11t1920': '8/11/1920 01:05',
  '11k1920': '22/11/1920 22:15',
  '12t1920': '7/12/1920 17:30',
  '12k1920': '22/12/1920 11:17',
  '1t1921': '6/1/1921 04:34',
  '1k1921': '20/1/1921 21:55',
  '2t1921': '4/2/1921 16:20',
  '2k1921': '19/2/1921 12:20',
  '3t1921': '6/3/1921 10:45',
  '3k1921': '21/3/1921 11:51',
  '4t1921': '5/4/1921 16:09',
  '4k1921': '20/4/1921 23:32',
  '5t1921': '6/5/1921 10:04',
  '5k1921': '21/5/1921 23:17',
  '6t1921': '6/6/1921 14:42',
  '6k1921': '22/6/1921 07:36',
  '7t1921': '8/7/1921 01:07',
  '7k1921': '23/7/1921 18:30',
  '8t1921': '8/8/1921 10:44',
  '8k1921': '24/8/1921 01:15',
  '9t1921': '8/9/1921 13:10',
  '9k1921': '23/9/1921 22:20',
  '10t1921': '9/10/1921 04:11',
  '10k1921': '24/10/1921 07:02',
  '11t1921': '8/11/1921 06:46',
  '11k1921': '23/11/1921 04:05',
  '12t1921': '7/12/1921 23:12',
  '12k1921': '22/12/1921 17:07',
  '1t1922': '6/1/1922 10:17',
  '1k1922': '21/1/1922 03:48',
  '2t1922': '4/2/1922 22:06',
  '2k1922': '19/2/1922 18:16',
  '3t1922': '6/3/1922 16:34',
  '3k1922': '21/3/1922 17:49',
  '4t1922': '5/4/1922 21:58',
  '4k1922': '21/4/1922 05:29',
  '5t1922': '6/5/1922 15:53',
  '5k1922': '22/5/1922 05:10',
  '6t1922': '6/6/1922 20:30',
  '6k1922': '22/6/1922 13:27',
  '7t1922': '8/7/1922 06:58',
  '7k1922': '24/7/1922 00:20',
  '8t1922': '8/8/1922 16:37',
  '8k1922': '24/8/1922 07:04',
  '9t1922': '8/9/1922 19:06',
  '9k1922': '24/9/1922 04:10',
  '10t1922': '9/10/1922 10:10',
  '10k1922': '24/10/1922 12:53',
  '11t1922': '8/11/1922 12:45',
  '11k1922': '23/11/1922 09:55',
  '12t1922': '8/12/1922 05:11',
  '12k1922': '22/12/1922 22:57',
  '1t1923': '6/1/1923 16:14',
  '1k1923': '21/1/1923 09:35',
  '2t1923': '5/2/1923 04:00',
  '2k1923': '20/2/1923 00:00',
  '3t1923': '6/3/1923 22:25',
  '3k1923': '21/3/1923 23:29',
  '4t1923': '6/4/1923 03:46',
  '4k1923': '21/4/1923 11:06',
  '5t1923': '6/5/1923 21:38',
  '5k1923': '22/5/1923 10:45',
  '6t1923': '7/6/1923 02:14',
  '6k1923': '22/6/1923 19:03',
  '7t1923': '8/7/1923 12:42',
  '7k1923': '24/7/1923 06:01',
  '8t1923': '8/8/1923 22:25',
  '8k1923': '24/8/1923 12:52',
  '9t1923': '9/9/1923 00:57',
  '9k1923': '24/9/1923 10:04',
  '10t1923': '9/10/1923 16:03',
  '10k1923': '24/10/1923 18:51',
  '11t1923': '8/11/1923 18:40',
  '11k1923': '23/11/1923 15:54',
  '12t1923': '8/12/1923 11:05',
  '12k1923': '23/12/1923 04:53',
  '1t1924': '6/1/1924 22:06',
  '1k1924': '21/1/1924 15:28',
  '2t1924': '5/2/1924 09:50',
  '2k1924': '20/2/1924 05:51',
  '3t1924': '6/3/1924 04:12',
  '3k1924': '21/3/1924 05:20',
  '4t1924': '5/4/1924 09:33',
  '4k1924': '20/4/1924 16:59',
  '5t1924': '6/5/1924 03:26',
  '5k1924': '21/5/1924 16:40',
  '6t1924': '6/6/1924 08:02',
  '6k1924': '22/6/1924 00:59',
  '7t1924': '7/7/1924 18:29',
  '7k1924': '23/7/1924 11:58',
  '8t1924': '8/8/1924 04:12',
  '8k1924': '23/8/1924 18:48',
  '9t1924': '8/9/1924 06:46',
  '9k1924': '23/9/1924 15:58',
  '10t1924': '8/10/1924 21:52',
  '10k1924': '24/10/1924 00:44',
  '11t1924': '8/11/1924 00:29',
  '11k1924': '22/11/1924 21:46',
  '12t1924': '7/12/1924 16:53',
  '12k1924': '22/12/1924 10:45',
  '1t1925': '6/1/1925 03:53',
  '1k1925': '20/1/1925 21:20',
  '2t1925': '4/2/1925 15:37',
  '2k1925': '19/2/1925 11:43',
  '3t1925': '6/3/1925 10:00',
  '3k1925': '21/3/1925 11:12',
  '4t1925': '5/4/1925 15:23',
  '4k1925': '20/4/1925 22:51',
  '5t1925': '6/5/1925 09:18',
  '5k1925': '21/5/1925 22:33',
  '6t1925': '6/6/1925 13:56',
  '6k1925': '22/6/1925 06:50',
  '7t1925': '8/7/1925 00:25',
  '7k1925': '23/7/1925 17:45',
  '8t1925': '8/8/1925 10:07',
  '8k1925': '24/8/1925 00:33',
  '9t1925': '8/9/1925 12:40',
  '9k1925': '23/9/1925 21:43',
  '10t1925': '9/10/1925 03:47',
  '10k1925': '24/10/1925 06:31',
  '11t1925': '8/11/1925 06:26',
  '11k1925': '23/11/1925 03:35',
  '12t1925': '7/12/1925 22:52',
  '12k1925': '22/12/1925 16:37',
  '1t1926': '6/1/1926 09:54',
  '1k1926': '21/1/1926 03:13',
  '2t1926': '4/2/1926 21:38',
  '2k1926': '19/2/1926 17:35',
  '3t1926': '6/3/1926 16:00',
  '3k1926': '21/3/1926 17:01',
  '4t1926': '5/4/1926 21:18',
  '4k1926': '21/4/1926 04:36',
  '5t1926': '6/5/1926 15:08',
  '5k1926': '22/5/1926 04:15',
  '6t1926': '6/6/1926 19:42',
  '6k1926': '22/6/1926 12:30',
  '7t1926': '8/7/1926 06:06',
  '7k1926': '23/7/1926 23:25',
  '8t1926': '8/8/1926 15:44',
  '8k1926': '24/8/1926 06:14',
  '9t1926': '8/9/1926 18:16',
  '9k1926': '24/9/1926 03:27',
  '10t1926': '9/10/1926 09:25',
  '10k1926': '24/10/1926 12:18',
  '11t1926': '8/11/1926 12:08',
  '11k1926': '23/11/1926 09:28',
  '12t1926': '8/12/1926 04:39',
  '12k1926': '22/12/1926 22:33',
  '1t1927': '6/1/1927 15:45',
  '1k1927': '21/1/1927 09:12',
  '2t1927': '5/2/1927 03:30',
  '2k1927': '19/2/1927 23:34',
  '3t1927': '6/3/1927 21:50',
  '3k1927': '21/3/1927 22:59',
  '4t1927': '6/4/1927 03:06',
  '4k1927': '21/4/1927 10:32',
  '5t1927': '6/5/1927 20:53',
  '5k1927': '22/5/1927 10:08',
  '6t1927': '7/6/1927 01:25',
  '6k1927': '22/6/1927 18:22',
  '7t1927': '8/7/1927 11:50',
  '7k1927': '24/7/1927 05:17',
  '8t1927': '8/8/1927 21:31',
  '8k1927': '24/8/1927 12:05',
  '9t1927': '9/9/1927 00:06',
  '9k1927': '24/9/1927 09:17',
  '10t1927': '9/10/1927 15:15',
  '10k1927': '24/10/1927 18:07',
  '11t1927': '8/11/1927 17:57',
  '11k1927': '23/11/1927 15:14',
  '12t1927': '8/12/1927 10:26',
  '12k1927': '23/12/1927 04:19',
  '1t1928': '6/1/1928 21:31',
  '1k1928': '21/1/1928 14:57',
  '2t1928': '5/2/1928 09:16',
  '2k1928': '20/2/1928 05:19',
  '3t1928': '6/3/1928 03:37',
  '3k1928': '21/3/1928 04:44',
  '4t1928': '5/4/1928 08:55',
  '4k1928': '20/4/1928 16:17',
  '5t1928': '6/5/1928 02:44',
  '5k1928': '21/5/1928 15:52',
  '6t1928': '6/6/1928 07:17',
  '6k1928': '22/6/1928 00:06',
  '7t1928': '7/7/1928 17:44',
  '7k1928': '23/7/1928 11:02',
  '8t1928': '8/8/1928 03:28',
  '8k1928': '23/8/1928 17:53',
  '9t1928': '8/9/1928 06:02',
  '9k1928': '23/9/1928 15:06',
  '10t1928': '8/10/1928 21:10',
  '10k1928': '23/10/1928 23:55',
  '11t1928': '7/11/1928 23:50',
  '11k1928': '22/11/1928 21:00',
  '12t1928': '7/12/1928 16:17',
  '12k1928': '22/12/1928 10:04',
  '1t1929': '6/1/1929 03:22',
  '1k1929': '20/1/1929 20:42',
  '2t1929': '4/2/1929 15:09',
  '2k1929': '19/2/1929 11:07',
  '3t1929': '6/3/1929 09:32',
  '3k1929': '21/3/1929 10:35',
  '4t1929': '5/4/1929 14:51',
  '4k1929': '20/4/1929 22:10',
  '5t1929': '6/5/1929 08:40',
  '5k1929': '21/5/1929 21:48',
  '6t1929': '6/6/1929 13:11',
  '6k1929': '22/6/1929 06:01',
  '7t1929': '7/7/1929 23:32',
  '7k1929': '23/7/1929 16:53',
  '8t1929': '8/8/1929 09:09',
  '8k1929': '23/8/1929 23:41',
  '9t1929': '8/9/1929 11:40',
  '9k1929': '23/9/1929 20:52',
  '10t1929': '9/10/1929 02:47',
  '10k1929': '24/10/1929 05:41',
  '11t1929': '8/11/1929 05:28',
  '11k1929': '23/11/1929 02:48',
  '12t1929': '7/12/1929 21:56',
  '12k1929': '22/12/1929 15:53',
  '1t1930': '6/1/1930 09:03',
  '1k1930': '21/1/1930 02:33',
  '2t1930': '4/2/1930 20:51',
  '2k1930': '19/2/1930 17:00',
  '3t1930': '6/3/1930 15:17',
  '3k1930': '21/3/1930 16:30',
  '4t1930': '5/4/1930 20:37',
  '4k1930': '21/4/1930 04:06',
  '5t1930': '6/5/1930 14:27',
  '5k1930': '22/5/1930 03:42',
  '6t1930': '6/6/1930 18:58',
  '6k1930': '22/6/1930 11:53',
  '7t1930': '8/7/1930 05:20',
  '7k1930': '23/7/1930 22:42',
  '8t1930': '8/8/1930 14:57',
  '8k1930': '24/8/1930 05:26',
  '9t1930': '8/9/1930 17:28',
  '9k1930': '24/9/1930 02:36',
  '10t1930': '9/10/1930 08:38',
  '10k1930': '24/10/1930 11:26',
  '11t1930': '8/11/1930 11:20',
  '11k1930': '23/11/1930 08:35',
  '12t1930': '8/12/1930 03:51',
  '12k1930': '22/12/1930 21:40',
  '1t1931': '6/1/1931 14:56',
  '1k1931': '21/1/1931 08:18',
  '2t1931': '5/2/1931 02:41',
  '2k1931': '19/2/1931 22:40',
  '3t1931': '6/3/1931 21:02',
  '3k1931': '21/3/1931 22:06',
  '4t1931': '6/4/1931 02:20',
  '4k1931': '21/4/1931 09:40',
  '5t1931': '6/5/1931 19:10',
  '5k1931': '22/5/1931 08:15',
  '6t1931': '6/6/1931 23:42',
  '6k1931': '22/6/1931 16:28',
  '7t1931': '8/7/1931 10:06',
  '7k1931': '24/7/1931 03:21',
  '8t1931': '8/8/1931 19:45',
  '8k1931': '24/8/1931 10:10',
  '9t1931': '8/9/1931 22:17',
  '9k1931': '24/9/1931 07:23',
  '10t1931': '9/10/1931 13:27',
  '10k1931': '24/10/1931 16:16',
  '11t1931': '8/11/1931 16:10',
  '11k1931': '23/11/1931 13:25',
  '12t1931': '8/12/1931 08:40',
  '12k1931': '23/12/1931 02:30',
  '1t1932': '6/1/1932 19:45',
  '1k1932': '21/1/1932 13:07',
  '2t1932': '5/2/1932 07:29',
  '2k1932': '20/2/1932 03:28',
  '3t1932': '6/3/1932 01:49',
  '3k1932': '21/3/1932 02:54',
  '4t1932': '5/4/1932 07:06',
  '4k1932': '20/4/1932 14:28',
  '5t1932': '6/5/1932 00:55',
  '5k1932': '21/5/1932 14:07',
  '6t1932': '6/6/1932 05:28',
  '6k1932': '21/6/1932 22:23',
  '7t1932': '7/7/1932 15:52',
  '7k1932': '23/7/1932 09:18',
  '8t1932': '8/8/1932 01:32',
  '8k1932': '23/8/1932 16:06',
  '9t1932': '8/9/1932 04:03',
  '9k1932': '23/9/1932 13:16',
  '10t1932': '8/10/1932 19:10',
  '10k1932': '23/10/1932 22:04',
  '11t1932': '7/11/1932 21:50',
  '11k1932': '22/11/1932 19:10',
  '12t1932': '7/12/1932 14:18',
  '12k1932': '22/12/1932 08:14',
  '1t1933': '6/1/1933 01:23',
  '1k1933': '20/1/1933 18:53',
  '2t1933': '4/2/1933 13:09',
  '2k1933': '19/2/1933 09:16',
  '3t1933': '6/3/1933 07:31',
  '3k1933': '21/3/1933 08:43',
  '4t1933': '5/4/1933 12:51',
  '4k1933': '20/4/1933 20:18',
  '5t1933': '6/5/1933 06:42',
  '5k1933': '21/5/1933 19:57',
  '6t1933': '6/6/1933 11:17',
  '6k1933': '22/6/1933 04:12',
  '7t1933': '7/7/1933 21:44',
  '7k1933': '23/7/1933 15:05',
  '8t1933': '8/8/1933 07:26',
  '8k1933': '23/8/1933 21:52',
  '9t1933': '8/9/1933 09:58',
  '9k1933': '23/9/1933 19:01',
  '10t1933': '9/10/1933 01:04',
  '10k1933': '24/10/1933 03:48',
  '11t1933': '8/11/1933 03:43',
  '11k1933': '23/11/1933 00:53',
  '12t1933': '7/12/1933 20:11',
  '12k1933': '22/12/1933 13:58',
  '1t1934': '6/1/1934 07:17',
  '1k1934': '21/1/1934 00:37',
  '2t1934': '4/2/1934 19:04',
  '2k1934': '19/2/1934 15:02',
  '3t1934': '6/3/1934 13:26',
  '3k1934': '21/3/1934 14:28',
  '4t1934': '5/4/1934 18:44',
  '4k1934': '21/4/1934 02:00',
  '5t1934': '6/5/1934 12:31',
  '5k1934': '22/5/1934 01:35',
  '6t1934': '6/6/1934 17:01',
  '6k1934': '22/6/1934 09:48',
  '7t1934': '8/7/1934 03:25',
  '7k1934': '23/7/1934 20:42',
  '8t1934': '8/8/1934 13:04',
  '8k1934': '24/8/1934 03:32',
  '9t1934': '8/9/1934 15:36',
  '9k1934': '24/9/1934 00:45',
  '10t1934': '9/10/1934 06:45',
  '10k1934': '24/10/1934 09:36',
  '11t1934': '8/11/1934 09:27',
  '11k1934': '23/11/1934 06:44',
  '12t1934': '8/12/1934 01:57',
  '12k1934': '22/12/1934 19:49',
  '1t1935': '6/1/1935 13:02',
  '1k1935': '21/1/1935 06:28',
  '2t1935': '5/2/1935 00:49',
  '2k1935': '19/2/1935 20:52',
  '3t1935': '6/3/1935 19:10',
  '3k1935': '21/3/1935 20:18',
  '4t1935': '6/4/1935 00:26',
  '4k1935': '21/4/1935 07:50',
  '5t1935': '6/5/1935 18:12',
  '5k1935': '22/5/1935 07:25',
  '6t1935': '6/6/1935 22:42',
  '6k1935': '22/6/1935 15:38',
  '7t1935': '8/7/1935 09:06',
  '7k1935': '24/7/1935 02:33',
  '8t1935': '8/8/1935 18:48',
  '8k1935': '24/8/1935 09:24',
  '9t1935': '8/9/1935 21:24',
  '9k1935': '24/9/1935 06:38',
  '10t1935': '9/10/1935 12:36',
  '10k1935': '24/10/1935 15:29',
  '11t1935': '8/11/1935 15:18',
  '11k1935': '23/11/1935 12:35',
  '12t1935': '8/12/1935 07:45',
  '12k1935': '23/12/1935 01:37',
  '1t1936': '6/1/1936 18:47',
  '1k1936': '21/1/1936 12:12',
  '2t1936': '5/2/1936 06:29',
  '2k1936': '20/2/1936 02:33',
  '3t1936': '6/3/1936 00:49',
  '3k1936': '21/3/1936 01:58',
  '4t1936': '5/4/1936 06:07',
  '4k1936': '20/4/1936 13:31',
  '5t1936': '5/5/1936 23:57',
  '5k1936': '21/5/1936 13:07',
  '6t1936': '6/6/1936 04:31',
  '6k1936': '21/6/1936 21:22',
  '7t1936': '7/7/1936 14:58',
  '7k1936': '23/7/1936 08:18',
  '8t1936': '8/8/1936 00:43',
  '8k1936': '23/8/1936 15:11',
  '9t1936': '8/9/1936 03:21',
  '9k1936': '23/9/1936 12:26',
  '10t1936': '8/10/1936 18:32',
  '10k1936': '23/10/1936 21:18',
  '11t1936': '7/11/1936 21:15',
  '11k1936': '22/11/1936 18:25',
  '12t1936': '7/12/1936 13:42',
  '12k1936': '22/12/1936 07:27',
  '1t1937': '6/1/1937 00:44',
  '1k1937': '20/1/1937 18:01',
  '2t1937': '4/2/1937 12:26',
  '2k1937': '19/2/1937 08:21',
  '3t1937': '6/3/1937 06:44',
  '3k1937': '21/3/1937 07:45',
  '4t1937': '5/4/1937 12:01',
  '4k1937': '20/4/1937 19:19',
  '5t1937': '6/5/1937 05:51',
  '5k1937': '21/5/1937 18:57',
  '6t1937': '6/6/1937 10:23',
  '6k1937': '22/6/1937 03:12',
  '7t1937': '7/7/1937 20:46',
  '7k1937': '23/7/1937 14:07',
  '8t1937': '8/8/1937 06:25',
  '8k1937': '23/8/1937 20:58',
  '9t1937': '8/9/1937 08:59',
  '9k1937': '23/9/1937 18:13',
  '10t1937': '9/10/1937 00:11',
  '10k1937': '24/10/1937 03:07',
  '11t1937': '8/11/1937 02:55',
  '11k1937': '23/11/1937 00:17',
  '12t1937': '7/12/1937 19:26',
  '12k1937': '22/12/1937 13:22',
  '1t1938': '6/1/1938 06:31',
  '1k1938': '20/1/1938 23:59',
  '2t1938': '4/2/1938 18:15',
  '2k1938': '19/2/1938 14:20',
  '3t1938': '6/3/1938 12:34',
  '3k1938': '21/3/1938 13:43',
  '4t1938': '5/4/1938 17:49',
  '4k1938': '21/4/1938 01:15',
  '5t1938': '6/5/1938 11:35',
  '5k1938': '22/5/1938 00:50',
  '6t1938': '6/6/1938 16:07',
  '6k1938': '22/6/1938 09:04',
  '7t1938': '8/7/1938 02:31',
  '7k1938': '23/7/1938 19:57',
  '8t1938': '8/8/1938 12:13',
  '8k1938': '24/8/1938 02:46',
  '9t1938': '8/9/1938 14:48',
  '9k1938': '24/9/1938 00:00',
  '10t1938': '9/10/1938 06:01',
  '10k1938': '24/10/1938 08:54',
  '11t1938': '8/11/1938 08:48',
  '11k1938': '23/11/1938 06:06',
  '12t1938': '8/12/1938 01:22',
  '12k1938': '22/12/1938 19:13',
  '1t1939': '6/1/1939 12:28',
  '1k1939': '21/1/1939 05:51',
  '2t1939': '5/2/1939 00:11',
  '2k1939': '19/2/1939 20:09',
  '3t1939': '6/3/1939 18:26',
  '3k1939': '21/3/1939 19:28',
  '4t1939': '5/4/1939 23:37',
  '4k1939': '21/4/1939 06:55',
  '5t1939': '6/5/1939 17:21',
  '5k1939': '22/5/1939 06:27',
  '6t1939': '6/6/1939 21:52',
  '6k1939': '22/6/1939 14:39',
  '7t1939': '8/7/1939 08:18',
  '7k1939': '24/7/1939 01:37',
  '8t1939': '8/8/1939 18:04',
  '8k1939': '24/8/1939 08:31',
  '9t1939': '8/9/1939 20:42',
  '9k1939': '24/9/1939 05:49',
  '10t1939': '9/10/1939 11:57',
  '10k1939': '24/10/1939 14:46',
  '11t1939': '8/11/1939 14:44',
  '11k1939': '23/11/1939 11:59',
  '12t1939': '8/12/1939 07:17',
  '12k1939': '23/12/1939 01:06',
  '1t1940': '6/1/1940 18:24',
  '1k1940': '21/1/1940 11:44',
  '2t1940': '5/2/1940 06:08',
  '2k1940': '20/2/1940 02:04',
  '3t1940': '6/3/1940 00:24',
  '3k1940': '21/3/1940 01:24',
  '4t1940': '5/4/1940 05:35',
  '4k1940': '20/4/1940 12:51',
  '5t1940': '5/5/1940 23:16',
  '5k1940': '21/5/1940 12:23',
  '6t1940': '6/6/1940 03:44',
  '6k1940': '21/6/1940 20:36',
  '7t1940': '7/7/1940 14:08',
  '7k1940': '23/7/1940 07:34',
  '8t1940': '7/8/1940 23:52',
  '8k1940': '23/8/1940 14:29',
  '9t1940': '8/9/1940 02:29',
  '9k1940': '23/9/1940 11:46',
  '10t1940': '8/10/1940 17:42',
  '10k1940': '23/10/1940 20:39',
  '11t1940': '7/11/1940 20:27',
  '11k1940': '22/11/1940 17:49',
  '12t1940': '7/12/1940 12:58',
  '12k1940': '22/12/1940 06:55',
  '1t1941': '6/1/1941 00:04',
  '1k1941': '20/1/1941 17:34',
  '2t1941': '4/2/1941 11:50',
  '2k1941': '19/2/1941 07:56',
  '3t1941': '6/3/1941 06:10',
  '3k1941': '21/3/1941 07:20',
  '4t1941': '5/4/1941 11:25',
  '4k1941': '20/4/1941 18:50',
  '5t1941': '6/5/1941 05:10',
  '5k1941': '21/5/1941 18:23',
  '6t1941': '6/6/1941 09:39',
  '6k1941': '22/6/1941 02:33',
  '7t1941': '7/7/1941 20:03',
  '7k1941': '23/7/1941 13:26',
  '8t1941': '8/8/1941 05:46',
  '8k1941': '23/8/1941 20:17',
  '9t1941': '8/9/1941 08:24',
  '9k1941': '23/9/1941 17:33',
  '10t1941': '8/10/1941 23:38',
  '10k1941': '24/10/1941 02:27',
  '11t1941': '8/11/1941 02:24',
  '11k1941': '22/11/1941 23:38',
  '12t1941': '7/12/1941 18:56',
  '12k1941': '22/12/1941 12:44',
  '1t1942': '6/1/1942 06:02',
  '1k1942': '20/1/1942 23:24',
  '2t1942': '4/2/1942 17:49',
  '2k1942': '19/2/1942 13:47',
  '3t1942': '6/3/1942 12:09',
  '3k1942': '21/3/1942 13:11',
  '4t1942': '5/4/1942 17:24',
  '4k1942': '21/4/1942 00:39',
  '5t1942': '6/5/1942 11:07',
  '5k1942': '22/5/1942 00:09',
  '6t1942': '6/6/1942 15:33',
  '6k1942': '22/6/1942 08:16',
  '7t1942': '8/7/1942 01:52',
  '7k1942': '23/7/1942 19:07',
  '8t1942': '8/8/1942 11:30',
  '8k1942': '24/8/1942 01:58',
  '9t1942': '8/9/1942 14:06',
  '9k1942': '23/9/1942 23:16',
  '10t1942': '9/10/1942 05:22',
  '10k1942': '24/10/1942 08:15',
  '11t1942': '8/11/1942 08:11',
  '11k1942': '23/11/1942 05:30',
  '12t1942': '8/12/1942 00:47',
  '12k1942': '22/12/1942 18:40',
  '1t1943': '6/1/1943 11:55',
  '1k1943': '21/1/1943 05:19',
  '2t1943': '4/2/1943 23:40',
  '2k1943': '19/2/1943 19:40',
  '3t1943': '6/3/1943 17:59',
  '3k1943': '21/3/1943 19:03',
  '4t1943': '5/4/1943 23:11',
  '4k1943': '21/4/1943 06:32',
  '5t1943': '6/5/1943 16:53',
  '5k1943': '22/5/1943 06:03',
  '6t1943': '6/6/1943 21:19',
  '6k1943': '22/6/1943 14:12',
  '7t1943': '8/7/1943 07:39',
  '7k1943': '24/7/1943 01:05',
  '8t1943': '8/8/1943 17:19',
  '8k1943': '24/8/1943 07:55',
  '9t1943': '8/9/1943 19:55',
  '9k1943': '24/9/1943 05:12',
  '10t1943': '9/10/1943 11:11',
  '10k1943': '24/10/1943 14:08',
  '11t1943': '8/11/1943 13:59',
  '11k1943': '23/11/1943 11:22',
  '12t1943': '8/12/1943 06:33',
  '12k1943': '23/12/1943 00:29',
  '1t1944': '6/1/1944 17:39',
  '1k1944': '21/1/1944 11:07',
  '2t1944': '5/2/1944 05:23',
  '2k1944': '20/2/1944 01:27',
  '3t1944': '5/3/1944 23:40',
  '3k1944': '21/3/1944 00:49',
  '4t1944': '5/4/1944 04:54',
  '4k1944': '20/4/1944 12:18',
  '5t1944': '5/5/1944 22:40',
  '5k1944': '21/5/1944 11:51',
  '6t1944': '6/6/1944 03:11',
  '6k1944': '21/6/1944 20:02',
  '7t1944': '7/7/1944 13:36',
  '7k1944': '23/7/1944 06:56',
  '8t1944': '7/8/1944 23:19',
  '8k1944': '23/8/1944 13:47',
  '9t1944': '8/9/1944 01:56',
  '9k1944': '23/9/1944 11:02',
  '10t1944': '8/10/1944 17:09',
  '10k1944': '23/10/1944 19:56',
  '11t1944': '7/11/1944 19:55',
  '11k1944': '22/11/1944 17:08',
  '12t1944': '7/12/1944 12:28',
  '12k1944': '22/12/1944 06:15',
  '1t1945': '5/1/1945 23:35',
  '1k1945': '20/1/1945 16:54',
  '2t1945': '4/2/1945 11:19',
  '2k1945': '19/2/1945 07:15',
  '3t1945': '6/3/1945 05:38',
  '3k1945': '21/3/1945 06:37',
  '4t1945': '5/4/1945 10:52',
  '4k1945': '20/4/1945 18:07',
  '5t1945': '6/5/1945 04:37',
  '5k1945': '21/5/1945 17:40',
  '6t1945': '6/6/1945 09:05',
  '6k1945': '22/6/1945 01:52',
  '7t1945': '7/7/1945 19:27',
  '7k1945': '23/7/1945 12:45',
  '8t1945': '8/8/1945 05:05',
  '8k1945': '23/8/1945 19:35',
  '9t1945': '8/9/1945 07:38',
  '9k1945': '23/9/1945 16:50',
  '10t1945': '8/10/1945 22:49',
  '10k1945': '24/10/1945 01:44',
  '11t1945': '8/11/1945 01:34',
  '11k1945': '22/11/1945 22:55',
  '12t1945': '7/12/1945 18:08',
  '12k1945': '22/12/1945 12:04',
  '1t1946': '6/1/1946 05:16',
  '1k1946': '20/1/1946 22:45',
  '2t1946': '4/2/1946 17:04',
  '2k1946': '19/2/1946 13:09',
  '3t1946': '6/3/1946 11:25',
  '3k1946': '21/3/1946 12:33',
  '4t1946': '5/4/1946 16:39',
  '4k1946': '21/4/1946 00:02',
  '5t1946': '6/5/1946 10:22',
  '5k1946': '21/5/1946 23:34',
  '6t1946': '6/6/1946 14:49',
  '6k1946': '22/6/1946 07:44',
  '7t1946': '8/7/1946 01:11',
  '7k1946': '23/7/1946 18:37',
  '8t1946': '8/8/1946 10:52',
  '8k1946': '24/8/1946 01:26',
  '9t1946': '8/9/1946 13:27',
  '9k1946': '23/9/1946 22:41',
  '10t1946': '9/10/1946 04:41',
  '10k1946': '24/10/1946 07:35',
  '11t1946': '8/11/1946 07:27',
  '11k1946': '23/11/1946 04:46',
  '12t1946': '8/12/1946 00:00',
  '12k1946': '22/12/1946 17:53',
  '1t1947': '6/1/1947 11:06',
  '1k1947': '21/1/1947 04:32',
  '2t1947': '4/2/1947 22:50',
  '2k1947': '19/2/1947 18:52',
  '3t1947': '6/3/1947 17:08',
  '3k1947': '21/3/1947 18:13',
  '4t1947': '5/4/1947 22:20',
  '4k1947': '21/4/1947 05:39',
  '5t1947': '6/5/1947 16:03',
  '5k1947': '22/5/1947 05:09',
  '6t1947': '6/6/1947 20:31',
  '6k1947': '22/6/1947 13:19',
  '7t1947': '8/7/1947 06:56',
  '7k1947': '24/7/1947 00:14',
  '8t1947': '8/8/1947 16:41',
  '8k1947': '24/8/1947 07:09',
  '9t1947': '8/9/1947 19:21',
  '9k1947': '24/9/1947 04:29',
  '10t1947': '9/10/1947 10:37',
  '10k1947': '24/10/1947 13:26',
  '11t1947': '8/11/1947 13:24',
  '11k1947': '23/11/1947 10:38',
  '12t1947': '8/12/1947 05:56',
  '12k1947': '22/12/1947 23:43',
  '1t1948': '6/1/1948 17:00',
  '1k1948': '21/1/1948 10:18',
  '2t1948': '5/2/1948 04:42',
  '2k1948': '20/2/1948 00:37',
  '3t1948': '5/3/1948 22:58',
  '3k1948': '20/3/1948 23:57',
  '4t1948': '5/4/1948 04:09',
  '4k1948': '20/4/1948 11:25',
  '5t1948': '5/5/1948 21:52',
  '5k1948': '21/5/1948 10:58',
  '6t1948': '6/6/1948 02:20',
  '6k1948': '21/6/1948 19:11',
  '7t1948': '7/7/1948 12:44',
  '7k1948': '23/7/1948 06:08',
  '8t1948': '7/8/1948 22:26',
  '8k1948': '23/8/1948 13:03',
  '9t1948': '8/9/1948 01:05',
  '9k1948': '23/9/1948 10:22',
  '10t1948': '8/10/1948 16:20',
  '10k1948': '23/10/1948 19:18',
  '11t1948': '7/11/1948 19:07',
  '11k1948': '22/11/1948 16:29',
  '12t1948': '7/12/1948 11:38',
  '12k1948': '22/12/1948 05:33',
  '1t1949': '5/1/1949 22:41',
  '1k1949': '20/1/1949 16:09',
  '2t1949': '4/2/1949 10:23',
  '2k1949': '19/2/1949 06:27',
  '3t1949': '6/3/1949 04:39',
  '3k1949': '21/3/1949 05:48',
  '4t1949': '5/4/1949 09:52',
  '4k1949': '20/4/1949 17:17',
  '5t1949': '6/5/1949 03:37',
  '5k1949': '21/5/1949 16:51',
  '6t1949': '6/6/1949 08:07',
  '6k1949': '22/6/1949 01:03',
  '7t1949': '7/7/1949 18:32',
  '7k1949': '23/7/1949 11:57',
  '8t1949': '8/8/1949 04:15',
  '8k1949': '23/8/1949 18:48',
  '9t1949': '8/9/1949 06:54',
  '9k1949': '23/9/1949 16:06',
  '10t1949': '8/10/1949 22:11',
  '10k1949': '24/10/1949 01:03',
  '11t1949': '8/11/1949 01:00',
  '11k1949': '22/11/1949 22:16',
  '12t1949': '7/12/1949 17:33',
  '12k1949': '22/12/1949 11:23',
  '1t1950': '6/1/1950 04:39',
  '1k1950': '20/1/1950 22:00',
  '2t1950': '4/2/1950 16:21',
  '2k1950': '19/2/1950 12:18',
  '3t1950': '6/3/1950 10:35',
  '3k1950': '21/3/1950 11:35',
  '4t1950': '5/4/1950 15:45',
  '4k1950': '20/4/1950 22:59',
  '5t1950': '6/5/1950 09:25',
  '5k1950': '21/5/1950 22:27',
  '6t1950': '6/6/1950 13:51',
  '6k1950': '22/6/1950 06:36',
  '7t1950': '8/7/1950 00:13',
  '7k1950': '23/7/1950 17:30',
  '8t1950': '8/8/1950 09:55',
  '8k1950': '24/8/1950 00:23',
  '9t1950': '8/9/1950 12:34',
  '9k1950': '23/9/1950 21:44',
  '10t1950': '9/10/1950 03:52',
  '10k1950': '24/10/1950 06:45',
  '11t1950': '8/11/1950 06:44',
  '11k1950': '23/11/1950 04:03',
  '12t1950': '7/12/1950 23:22',
  '12k1950': '22/12/1950 17:13',
  '1t1951': '6/1/1951 10:30',
  '1k1951': '21/1/1951 03:52',
  '2t1951': '4/2/1951 22:13',
  '2k1951': '19/2/1951 18:10',
  '3t1951': '6/3/1951 16:27',
  '3k1951': '21/3/1951 17:26',
  '4t1951': '5/4/1951 21:33',
  '4k1951': '21/4/1951 04:48',
  '5t1951': '6/5/1951 15:09',
  '5k1951': '22/5/1951 04:15',
  '6t1951': '6/6/1951 19:33',
  '6k1951': '22/6/1951 12:25',
  '7t1951': '8/7/1951 05:54',
  '7k1951': '23/7/1951 23:21',
  '8t1951': '8/8/1951 15:37',
  '8k1951': '24/8/1951 06:16',
  '9t1951': '8/9/1951 18:18',
  '9k1951': '24/9/1951 03:37',
  '10t1951': '9/10/1951 09:36',
  '10k1951': '24/10/1951 12:36',
  '11t1951': '8/11/1951 12:27',
  '11k1951': '23/11/1951 09:51',
  '12t1951': '8/12/1951 05:02',
  '12k1951': '22/12/1951 23:00',
  '1t1952': '6/1/1952 16:10',
  '1k1952': '21/1/1952 09:38',
  '2t1952': '5/2/1952 03:53',
  '2k1952': '19/2/1952 23:57',
  '3t1952': '5/3/1952 22:07',
  '3k1952': '20/3/1952 23:14',
  '4t1952': '5/4/1952 03:15',
  '4k1952': '20/4/1952 10:37',
  '5t1952': '5/5/1952 20:54',
  '5k1952': '21/5/1952 10:04',
  '6t1952': '6/6/1952 01:20',
  '6k1952': '21/6/1952 18:13',
  '7t1952': '7/7/1952 11:45',
  '7k1952': '23/7/1952 05:07',
  '8t1952': '7/8/1952 21:31',
  '8k1952': '23/8/1952 12:03',
  '9t1952': '8/9/1952 00:14',
  '9k1952': '23/9/1952 09:24',
  '10t1952': '8/10/1952 15:32',
  '10k1952': '23/10/1952 18:22',
  '11t1952': '7/11/1952 18:22',
  '11k1952': '22/11/1952 15:36',
  '12t1952': '7/12/1952 10:56',
  '12k1952': '22/12/1952 04:43',
  '1t1953': '5/1/1953 22:02',
  '1k1953': '20/1/1953 15:21',
  '2t1953': '4/2/1953 09:46',
  '2k1953': '19/2/1953 05:41',
  '3t1953': '6/3/1953 04:02',
  '3k1953': '21/3/1953 05:01',
  '4t1953': '5/4/1953 09:13',
  '4k1953': '20/4/1953 16:25',
  '5t1953': '6/5/1953 02:52',
  '5k1953': '21/5/1953 15:53',
  '6t1953': '6/6/1953 07:16',
  '6k1953': '22/6/1953 00:00',
  '7t1953': '7/7/1953 17:35',
  '7k1953': '23/7/1953 10:52',
  '8t1953': '8/8/1953 03:15',
  '8k1953': '23/8/1953 17:45',
  '9t1953': '8/9/1953 05:53',
  '9k1953': '23/9/1953 15:06',
  '10t1953': '8/10/1953 21:10',
  '10k1953': '24/10/1953 00:06',
  '11t1953': '8/11/1953 00:01',
  '11k1953': '22/11/1953 21:22',
  '12t1953': '7/12/1953 16:37',
  '12k1953': '22/12/1953 10:31',
  '1t1954': '6/1/1954 03:45',
  '1k1954': '20/1/1954 21:11',
  '2t1954': '4/2/1954 15:31',
  '2k1954': '19/2/1954 11:32',
  '3t1954': '6/3/1954 09:49',
  '3k1954': '21/3/1954 10:53',
  '4t1954': '5/4/1954 14:59',
  '4k1954': '20/4/1954 22:20',
  '5t1954': '6/5/1954 08:38',
  '5k1954': '21/5/1954 21:47',
  '6t1954': '6/6/1954 13:01',
  '6k1954': '22/6/1954 05:54',
  '7t1954': '7/7/1954 23:19',
  '7k1954': '23/7/1954 16:45',
  '8t1954': '8/8/1954 08:59',
  '8k1954': '23/8/1954 23:36',
  '9t1954': '8/9/1954 11:38',
  '9k1954': '23/9/1954 20:55',
  '10t1954': '9/10/1954 02:57',
  '10k1954': '24/10/1954 05:56',
  '11t1954': '8/11/1954 05:51',
  '11k1954': '23/11/1954 03:14',
  '12t1954': '7/12/1954 22:29',
  '12k1954': '22/12/1954 16:24',
  '1t1955': '6/1/1955 09:36',
  '1k1955': '21/1/1955 03:02',
  '2t1955': '4/2/1955 21:18',
  '2k1955': '19/2/1955 17:19',
  '3t1955': '6/3/1955 15:31',
  '3k1955': '21/3/1955 16:35',
  '4t1955': '5/4/1955 20:39',
  '4k1955': '21/4/1955 03:58',
  '5t1955': '6/5/1955 14:18',
  '5k1955': '22/5/1955 03:24',
  '6t1955': '6/6/1955 18:43',
  '6k1955': '22/6/1955 11:31',
  '7t1955': '8/7/1955 05:06',
  '7k1955': '23/7/1955 22:25',
  '8t1955': '8/8/1955 14:50',
  '8k1955': '24/8/1955 05:19',
  '9t1955': '8/9/1955 17:32',
  '9k1955': '24/9/1955 02:41',
  '10t1955': '9/10/1955 08:52',
  '10k1955': '24/10/1955 11:43',
  '11t1955': '8/11/1955 11:45',
  '11k1955': '23/11/1955 09:01',
  '12t1955': '8/12/1955 04:23',
  '12k1955': '22/12/1955 22:11',
  '1t1956': '6/1/1956 15:30',
  '1k1956': '21/1/1956 08:48',
  '2t1956': '5/2/1956 03:12',
  '2k1956': '19/2/1956 23:05',
  '3t1956': '5/3/1956 21:24',
  '3k1956': '20/3/1956 22:20',
  '4t1956': '5/4/1956 02:31',
  '4k1956': '20/4/1956 09:43',
  '5t1956': '5/5/1956 20:10',
  '5k1956': '21/5/1956 09:13',
  '6t1956': '6/6/1956 00:36',
  '6k1956': '21/6/1956 17:24',
  '7t1956': '7/7/1956 10:58',
  '7k1956': '23/7/1956 04:20',
  '8t1956': '7/8/1956 20:40',
  '8k1956': '23/8/1956 11:15',
  '9t1956': '7/9/1956 23:19',
  '9k1956': '23/9/1956 08:35',
  '10t1956': '8/10/1956 14:36',
  '10k1956': '23/10/1956 17:34',
  '11t1956': '7/11/1956 17:26',
  '11k1956': '22/11/1956 14:50',
  '12t1956': '7/12/1956 10:02',
  '12k1956': '22/12/1956 04:00',
  '1t1957': '5/1/1957 21:10',
  '1k1957': '20/1/1957 14:39',
  '2t1957': '4/2/1957 08:55',
  '2k1957': '19/2/1957 04:58',
  '3t1957': '6/3/1957 03:10',
  '3k1957': '21/3/1957 04:16',
  '4t1957': '5/4/1957 08:19',
  '4k1957': '20/4/1957 15:41',
  '5t1957': '6/5/1957 01:58',
  '5k1957': '21/5/1957 15:10',
  '6t1957': '6/6/1957 06:25',
  '6k1957': '21/6/1957 23:21',
  '7t1957': '7/7/1957 16:48',
  '7k1957': '23/7/1957 10:15',
  '8t1957': '8/8/1957 02:32',
  '8k1957': '23/8/1957 17:08',
  '9t1957': '8/9/1957 05:12',
  '9k1957': '23/9/1957 14:26',
  '10t1957': '8/10/1957 20:30',
  '10k1957': '23/10/1957 23:24',
  '11t1957': '7/11/1957 23:20',
  '11k1957': '22/11/1957 20:39',
  '12t1957': '7/12/1957 15:56',
  '12k1957': '22/12/1957 09:49',
  '1t1958': '6/1/1958 03:04',
  '1k1958': '20/1/1958 20:29',
  '2t1958': '4/2/1958 14:49',
  '2k1958': '19/2/1958 10:48',
  '3t1958': '6/3/1958 09:05',
  '3k1958': '21/3/1958 10:06',
  '4t1958': '5/4/1958 14:12',
  '4k1958': '20/4/1958 21:27',
  '5t1958': '6/5/1958 07:49',
  '5k1958': '21/5/1958 20:51',
  '6t1958': '6/6/1958 12:12',
  '6k1958': '22/6/1958 04:57',
  '7t1958': '7/7/1958 22:33',
  '7k1958': '23/7/1958 15:50',
  '8t1958': '8/8/1958 08:17',
  '8k1958': '23/8/1958 22:46',
  '9t1958': '8/9/1958 10:59',
  '9k1958': '23/9/1958 20:09',
  '10t1958': '9/10/1958 02:19',
  '10k1958': '24/10/1958 05:11',
  '11t1958': '8/11/1958 05:12',
  '11k1958': '23/11/1958 02:29',
  '12t1958': '7/12/1958 21:50',
  '12k1958': '22/12/1958 15:40',
  '1t1959': '6/1/1959 08:58',
  '1k1959': '21/1/1959 02:19',
  '2t1959': '4/2/1959 20:42',
  '2k1959': '19/2/1959 16:38',
  '3t1959': '6/3/1959 14:57',
  '3k1959': '21/3/1959 15:55',
  '4t1959': '5/4/1959 20:03',
  '4k1959': '21/4/1959 03:17',
  '5t1959': '6/5/1959 13:39',
  '5k1959': '22/5/1959 02:42',
  '6t1959': '6/6/1959 18:00',
  '6k1959': '22/6/1959 10:50',
  '7t1959': '8/7/1959 04:20',
  '7k1959': '23/7/1959 21:45',
  '8t1959': '8/8/1959 14:04',
  '8k1959': '24/8/1959 04:44',
  '9t1959': '8/9/1959 16:48',
  '9k1959': '24/9/1959 02:08',
  '10t1959': '9/10/1959 08:10',
  '10k1959': '24/10/1959 11:11',
  '11t1959': '8/11/1959 11:02',
  '11k1959': '23/11/1959 08:27',
  '12t1959': '8/12/1959 03:37',
  '12k1959': '22/12/1959 21:34',
  '1t1960': '6/1/1960 14:43',
  '1k1960': '21/1/1960 08:10',
  '2t1960': '5/2/1960 02:23',
  '2k1960': '19/2/1960 22:26',
  '3t1960': '5/3/1960 20:36',
  '3k1960': '20/3/1960 21:43',
  '4t1960': '5/4/1960 01:44',
  '4k1960': '20/4/1960 09:06',
  '5t1960': '5/5/1960 19:23',
  '5k1960': '21/5/1960 08:34',
  '6t1960': '5/6/1960 23:49',
  '6k1960': '21/6/1960 16:42',
  '7t1960': '7/7/1960 10:13',
  '7k1960': '23/7/1960 03:37',
  '8t1960': '7/8/1960 20:00',
  '8k1960': '23/8/1960 10:34',
  '9t1960': '7/9/1960 22:45',
  '9k1960': '23/9/1960 07:59',
  '10t1960': '8/10/1960 14:09',
  '10k1960': '23/10/1960 17:02',
  '11t1960': '7/11/1960 17:02',
  '11k1960': '22/11/1960 14:18',
  '12t1960': '7/12/1960 09:38',
  '12k1960': '22/12/1960 03:26',
  '1t1961': '5/1/1961 20:43',
  '1k1961': '20/1/1961 14:01',
  '2t1961': '4/2/1961 08:22',
  '2k1961': '19/2/1961 04:16',
  '3t1961': '6/3/1961 02:35',
  '3k1961': '21/3/1961 03:32',
  '4t1961': '5/4/1961 07:42',
  '4k1961': '20/4/1961 14:55',
  '5t1961': '6/5/1961 01:21',
  '5k1961': '21/5/1961 14:22',
  '6t1961': '6/6/1961 05:46',
  '6k1961': '21/6/1961 22:30',
  '7t1961': '7/7/1961 16:07',
  '7k1961': '23/7/1961 09:24',
  '8t1961': '8/8/1961 01:48',
  '8k1961': '23/8/1961 16:19',
  '9t1961': '8/9/1961 04:29',
  '9k1961': '23/9/1961 13:42',
  '10t1961': '8/10/1961 19:51',
  '10k1961': '23/10/1961 22:47',
  '11t1961': '7/11/1961 22:46',
  '11k1961': '22/11/1961 20:08',
  '12t1961': '7/12/1961 15:26',
  '12k1961': '22/12/1961 09:19',
  '1t1962': '6/1/1962 02:35',
  '1k1962': '20/1/1962 19:58',
  '2t1962': '4/2/1962 14:17',
  '2k1962': '19/2/1962 10:15',
  '3t1962': '6/3/1962 08:30',
  '3k1962': '21/3/1962 09:30',
  '4t1962': '5/4/1962 13:34',
  '4k1962': '20/4/1962 20:51',
  '5t1962': '6/5/1962 07:10',
  '5k1962': '21/5/1962 20:17',
  '6t1962': '6/6/1962 11:31',
  '6k1962': '22/6/1962 04:24',
  '7t1962': '7/7/1962 21:51',
  '7k1962': '23/7/1962 15:18',
  '8t1962': '8/8/1962 07:34',
  '8k1962': '23/8/1962 22:12',
  '9t1962': '8/9/1962 10:15',
  '9k1962': '23/9/1962 19:35',
  '10t1962': '9/10/1962 01:38',
  '10k1962': '24/10/1962 04:40',
  '11t1962': '8/11/1962 04:35',
  '11k1962': '23/11/1962 02:02',
  '12t1962': '7/12/1962 21:17',
  '12k1962': '22/12/1962 15:15',
  '1t1963': '6/1/1963 08:26',
  '1k1963': '21/1/1963 01:54',
  '2t1963': '4/2/1963 20:08',
  '2k1963': '19/2/1963 16:09',
  '3t1963': '6/3/1963 14:17',
  '3k1963': '21/3/1963 15:20',
  '4t1963': '5/4/1963 19:19',
  '4k1963': '21/4/1963 02:36',
  '5t1963': '6/5/1963 12:52',
  '5k1963': '22/5/1963 01:58',
  '6t1963': '6/6/1963 17:14',
  '6k1963': '22/6/1963 10:04',
  '7t1963': '8/7/1963 03:38',
  '7k1963': '23/7/1963 20:59',
  '8t1963': '8/8/1963 13:25',
  '8k1963': '24/8/1963 03:58',
  '9t1963': '8/9/1963 16:12',
  '9k1963': '24/9/1963 01:24',
  '10t1963': '9/10/1963 07:36',
  '10k1963': '24/10/1963 10:29',
  '11t1963': '8/11/1963 10:32',
  '11k1963': '23/11/1963 07:49',
  '12t1963': '8/12/1963 03:13',
  '12k1963': '22/12/1963 21:02',
  '1t1964': '6/1/1964 14:22',
  '1k1964': '21/1/1964 07:41',
  '2t1964': '5/2/1964 02:05',
  '2k1964': '19/2/1964 21:57',
  '3t1964': '5/3/1964 20:16',
  '3k1964': '20/3/1964 21:10',
  '4t1964': '5/4/1964 01:18',
  '4k1964': '20/4/1964 08:27',
  '5t1964': '5/5/1964 18:51',
  '5k1964': '21/5/1964 07:50',
  '6t1964': '5/6/1964 23:12',
  '6k1964': '21/6/1964 15:57',
  '7t1964': '7/7/1964 09:32',
  '7k1964': '23/7/1964 02:53',
  '8t1964': '7/8/1964 19:16',
  '8k1964': '23/8/1964 09:51',
  '9t1964': '7/9/1964 21:59',
  '9k1964': '23/9/1964 07:17',
  '10t1964': '8/10/1964 13:22',
  '10k1964': '23/10/1964 16:21',
  '11t1964': '7/11/1964 16:15',
  '11k1964': '22/11/1964 13:39',
  '12t1964': '7/12/1964 08:53',
  '12k1964': '22/12/1964 02:50',
  '1t1965': '5/1/1965 20:02',
  '1k1965': '20/1/1965 13:29',
  '2t1965': '4/2/1965 07:46',
  '2k1965': '19/2/1965 03:48',
  '3t1965': '6/3/1965 02:01',
  '3k1965': '21/3/1965 03:05',
  '4t1965': '5/4/1965 07:07',
  '4k1965': '20/4/1965 14:26',
  '5t1965': '6/5/1965 00:42',
  '5k1965': '21/5/1965 13:50',
  '6t1965': '6/6/1965 05:02',
  '6k1965': '21/6/1965 21:56',
  '7t1965': '7/7/1965 15:21',
  '7k1965': '23/7/1965 08:48',
  '8t1965': '8/8/1965 01:05',
  '8k1965': '23/8/1965 15:43',
  '9t1965': '8/9/1965 03:48',
  '9k1965': '23/9/1965 13:06',
  '10t1965': '8/10/1965 19:11',
  '10k1965': '23/10/1965 22:10',
  '11t1965': '7/11/1965 22:07',
  '11k1965': '22/11/1965 19:29',
  '12t1965': '7/12/1965 14:46',
  '12k1965': '22/12/1965 08:40',
  '1t1966': '6/1/1966 01:54',
  '1k1966': '20/1/1966 19:20',
  '2t1966': '4/2/1966 13:38',
  '2k1966': '19/2/1966 09:38',
  '3t1966': '6/3/1966 07:51',
  '3k1966': '21/3/1966 08:53',
  '4t1966': '5/4/1966 12:57',
  '4k1966': '20/4/1966 20:12',
  '5t1966': '6/5/1966 06:30',
  '5k1966': '21/5/1966 19:32',
  '6t1966': '6/6/1966 10:50',
  '6k1966': '22/6/1966 03:33',
  '7t1966': '7/7/1966 21:07',
  '7k1966': '23/7/1966 14:23',
  '8t1966': '8/8/1966 06:49',
  '8k1966': '23/8/1966 21:18',
  '9t1966': '8/9/1966 09:32',
  '9k1966': '23/9/1966 18:43',
  '10t1966': '9/10/1966 00:57',
  '10k1966': '24/10/1966 03:51',
  '11t1966': '8/11/1966 03:55',
  '11k1966': '23/11/1966 01:14',
  '12t1966': '7/12/1966 20:38',
  '12k1966': '22/12/1966 14:28',
  '1t1967': '6/1/1967 07:48',
  '1k1967': '21/1/1967 01:08',
  '2t1967': '4/2/1967 19:31',
  '2k1967': '19/2/1967 15:24',
  '3t1967': '6/3/1967 13:42',
  '3k1967': '21/3/1967 14:37',
  '4t1967': '5/4/1967 18:45',
  '4k1967': '21/4/1967 01:55',
  '5t1967': '6/5/1967 12:17',
  '5k1967': '22/5/1967 01:18',
  '6t1967': '6/6/1967 16:36',
  '6k1967': '22/6/1967 09:23',
  '7t1967': '8/7/1967 02:53',
  '7k1967': '23/7/1967 20:16',
  '8t1967': '8/8/1967 12:35',
  '8k1967': '24/8/1967 03:12',
  '9t1967': '8/9/1967 15:18',
  '9k1967': '24/9/1967 00:38',
  '10t1967': '9/10/1967 06:41',
  '10k1967': '24/10/1967 09:44',
  '11t1967': '8/11/1967 09:37',
  '11k1967': '23/11/1967 07:04',
  '12t1967': '8/12/1967 02:18',
  '12k1967': '22/12/1967 20:16',
  '1t1968': '6/1/1968 13:26',
  '1k1968': '21/1/1968 06:54',
  '2t1968': '5/2/1968 01:07',
  '2k1968': '19/2/1968 21:09',
  '3t1968': '5/3/1968 19:18',
  '3k1968': '20/3/1968 20:22',
  '4t1968': '5/4/1968 00:21',
  '4k1968': '20/4/1968 07:41',
  '5t1968': '5/5/1968 17:56',
  '5k1968': '21/5/1968 07:06',
  '6t1968': '5/6/1968 22:19',
  '6k1968': '21/6/1968 15:13',
  '7t1968': '7/7/1968 08:42',
  '7k1968': '23/7/1968 02:07',
  '8t1968': '7/8/1968 18:27',
  '8k1968': '23/8/1968 09:03',
  '9t1968': '7/9/1968 21:11',
  '9k1968': '23/9/1968 06:26',
  '10t1968': '8/10/1968 12:34',
  '10k1968': '23/10/1968 15:30',
  '11t1968': '7/11/1968 15:29',
  '11k1968': '22/11/1968 12:49',
  '12t1968': '7/12/1968 08:08',
  '12k1968': '22/12/1968 02:00',
  '1t1969': '5/1/1969 19:17',
  '1k1969': '20/1/1969 12:38',
  '2t1969': '4/2/1969 06:59',
  '2k1969': '19/2/1969 02:55',
  '3t1969': '6/3/1969 01:11',
  '3k1969': '21/3/1969 02:08',
  '4t1969': '5/4/1969 06:15',
  '4k1969': '20/4/1969 13:27',
  '5t1969': '5/5/1969 23:50',
  '5k1969': '21/5/1969 12:50',
  '6t1969': '6/6/1969 04:12',
  '6k1969': '21/6/1969 20:55',
  '7t1969': '7/7/1969 14:32',
  '7k1969': '23/7/1969 07:48',
  '8t1969': '8/8/1969 00:14',
  '8k1969': '23/8/1969 14:43',
  '9t1969': '8/9/1969 02:55',
  '9k1969': '23/9/1969 12:07',
  '10t1969': '8/10/1969 18:17',
  '10k1969': '23/10/1969 21:11',
  '11t1969': '7/11/1969 21:11',
  '11k1969': '22/11/1969 18:31',
  '12t1969': '7/12/1969 13:51',
  '12k1969': '22/12/1969 07:44',
  '1t1970': '6/1/1970 01:02',
  '1k1970': '20/1/1970 18:24',
  '2t1970': '4/2/1970 12:46',
  '2k1970': '19/2/1970 08:42',
  '3t1970': '6/3/1970 06:59',
  '3k1970': '21/3/1970 07:56',
  '4t1970': '5/4/1970 12:02',
  '4k1970': '20/4/1970 19:15',
  '5t1970': '6/5/1970 05:34',
  '5k1970': '21/5/1970 18:37',
  '6t1970': '6/6/1970 09:52',
  '6k1970': '22/6/1970 02:43',
  '7t1970': '7/7/1970 20:11',
  '7k1970': '23/7/1970 13:37',
  '8t1970': '8/8/1970 05:54',
  '8k1970': '23/8/1970 20:34',
  '9t1970': '8/9/1970 08:38',
  '9k1970': '23/9/1970 17:59',
  '10t1970': '9/10/1970 00:02',
  '10k1970': '24/10/1970 03:04',
  '11t1970': '8/11/1970 02:58',
  '11k1970': '23/11/1970 00:25',
  '12t1970': '7/12/1970 19:37',
  '12k1970': '22/12/1970 13:36',
  '1t1971': '6/1/1971 06:45',
  '1k1971': '21/1/1971 00:13',
  '2t1971': '4/2/1971 18:25',
  '2k1971': '19/2/1971 14:27',
  '3t1971': '6/3/1971 12:35',
  '3k1971': '21/3/1971 13:38',
  '4t1971': '5/4/1971 17:36',
  '4k1971': '21/4/1971 00:54',
  '5t1971': '6/5/1971 11:08',
  '5k1971': '22/5/1971 00:15',
  '6t1971': '6/6/1971 15:29',
  '6k1971': '22/6/1971 08:20',
  '7t1971': '8/7/1971 01:51',
  '7k1971': '23/7/1971 19:15',
  '8t1971': '8/8/1971 11:40',
  '8k1971': '24/8/1971 02:15',
  '9t1971': '8/9/1971 14:30',
  '9k1971': '23/9/1971 23:45',
  '10t1971': '9/10/1971 05:59',
  '10k1971': '24/10/1971 08:53',
  '11t1971': '8/11/1971 08:57',
  '11k1971': '23/11/1971 06:14',
  '12t1971': '8/12/1971 01:36',
  '12k1971': '22/12/1971 19:24',
  '1t1972': '6/1/1972 12:42',
  '1k1972': '21/1/1972 05:59',
  '2t1972': '5/2/1972 00:20',
  '2k1972': '19/2/1972 20:11',
  '3t1972': '5/3/1972 18:28',
  '3k1972': '20/3/1972 19:21',
  '4t1972': '4/4/1972 23:29',
  '4k1972': '20/4/1972 06:38',
  '5t1972': '5/5/1972 17:01',
  '5k1972': '21/5/1972 06:00',
  '6t1972': '5/6/1972 21:22',
  '6k1972': '21/6/1972 14:06',
  '7t1972': '7/7/1972 07:43',
  '7k1972': '23/7/1972 01:03',
  '8t1972': '7/8/1972 17:29',
  '8k1972': '23/8/1972 08:03',
  '9t1972': '7/9/1972 20:15',
  '9k1972': '23/9/1972 05:33',
  '10t1972': '8/10/1972 11:42',
  '10k1972': '23/10/1972 14:41',
  '11t1972': '7/11/1972 14:39',
  '11k1972': '22/11/1972 12:03',
  '12t1972': '7/12/1972 07:19',
  '12k1972': '22/12/1972 01:13',
  '1t1973': '5/1/1973 18:25',
  '1k1973': '20/1/1973 11:48',
  '2t1973': '4/2/1973 06:04',
  '2k1973': '19/2/1973 02:01',
  '3t1973': '6/3/1973 00:13',
  '3k1973': '21/3/1973 01:12',
  '4t1973': '5/4/1973 05:14',
  '4k1973': '20/4/1973 12:30',
  '5t1973': '5/5/1973 22:46',
  '5k1973': '21/5/1973 11:54',
  '6t1973': '6/6/1973 03:07',
  '6k1973': '21/6/1973 20:01',
  '7t1973': '7/7/1973 13:27',
  '7k1973': '23/7/1973 06:56',
  '8t1973': '7/8/1973 23:13',
  '8k1973': '23/8/1973 13:53',
  '9t1973': '8/9/1973 01:59',
  '9k1973': '23/9/1973 11:21',
  '10t1973': '8/10/1973 17:27',
  '10k1973': '23/10/1973 20:30',
  '11t1973': '7/11/1973 20:28',
  '11k1973': '22/11/1973 17:54',
  '12t1973': '7/12/1973 13:10',
  '12k1973': '22/12/1973 07:08',
  '1t1974': '6/1/1974 00:20',
  '1k1974': '20/1/1974 17:46',
  '2t1974': '4/2/1974 12:00',
  '2k1974': '19/2/1974 07:59',
  '3t1974': '6/3/1974 06:07',
  '3k1974': '21/3/1974 07:07',
  '4t1974': '5/4/1974 11:05',
  '4k1974': '20/4/1974 18:19',
  '5t1974': '6/5/1974 04:34',
  '5k1974': '21/5/1974 17:36',
  '6t1974': '6/6/1974 08:52',
  '6k1974': '22/6/1974 01:38',
  '7t1974': '7/7/1974 19:11',
  '7k1974': '23/7/1974 12:30',
  '8t1974': '8/8/1974 04:57',
  '8k1974': '23/8/1974 19:29',
  '9t1974': '8/9/1974 07:45',
  '9k1974': '23/9/1974 16:58',
  '10t1974': '8/10/1974 23:15',
  '10k1974': '24/10/1974 02:11',
  '11t1974': '8/11/1974 02:18',
  '11k1974': '22/11/1974 23:38',
  '12t1974': '7/12/1974 19:05',
  '12k1974': '22/12/1974 12:56',
  '1t1975': '6/1/1975 06:18',
  '1k1975': '20/1/1975 23:36',
  '2t1975': '4/2/1975 17:59',
  '2k1975': '19/2/1975 13:50',
  '3t1975': '6/3/1975 12:06',
  '3k1975': '21/3/1975 12:57',
  '4t1975': '5/4/1975 17:02',
  '4k1975': '21/4/1975 00:07',
  '5t1975': '6/5/1975 10:27',
  '5k1975': '21/5/1975 23:24',
  '6t1975': '6/6/1975 14:42',
  '6k1975': '22/6/1975 07:26',
  '7t1975': '8/7/1975 00:59',
  '7k1975': '23/7/1975 18:22',
  '8t1975': '8/8/1975 10:45',
  '8k1975': '24/8/1975 01:24',
  '9t1975': '8/9/1975 13:33',
  '9k1975': '23/9/1975 22:55',
  '10t1975': '9/10/1975 05:02',
  '10k1975': '24/10/1975 08:06',
  '11t1975': '8/11/1975 08:03',
  '11k1975': '23/11/1975 05:31',
  '12t1975': '8/12/1975 00:46',
  '12k1975': '22/12/1975 18:46',
  '1t1976': '6/1/1976 11:57',
  '1k1976': '21/1/1976 05:25',
  '2t1976': '4/2/1976 23:39',
  '2k1976': '19/2/1976 19:40',
  '3t1976': '5/3/1976 17:48',
  '3k1976': '20/3/1976 18:50',
  '4t1976': '4/4/1976 22:46',
  '4k1976': '20/4/1976 06:03',
  '5t1976': '5/5/1976 16:14',
  '5k1976': '21/5/1976 05:21',
  '6t1976': '5/6/1976 20:31',
  '6k1976': '21/6/1976 13:24',
  '7t1976': '7/7/1976 06:51',
  '7k1976': '23/7/1976 00:18',
  '8t1976': '7/8/1976 16:38',
  '8k1976': '23/8/1976 07:18',
  '9t1976': '7/9/1976 19:28',
  '9k1976': '23/9/1976 04:48',
  '10t1976': '8/10/1976 10:58',
  '10k1976': '23/10/1976 13:58',
  '11t1976': '7/11/1976 13:59',
  '11k1976': '22/11/1976 11:22',
  '12t1976': '7/12/1976 06:41',
  '12k1976': '22/12/1976 00:35',
  '1t1977': '5/1/1977 17:51',
  '1k1977': '20/1/1977 11:14',
  '2t1977': '4/2/1977 05:33',
  '2k1977': '19/2/1977 01:30',
  '3t1977': '5/3/1977 23:44',
  '3k1977': '21/3/1977 00:42',
  '4t1977': '5/4/1977 04:46',
  '4k1977': '20/4/1977 11:57',
  '5t1977': '5/5/1977 22:16',
  '5k1977': '21/5/1977 11:14',
  '6t1977': '6/6/1977 02:32',
  '6k1977': '21/6/1977 19:14',
  '7t1977': '7/7/1977 12:48',
  '7k1977': '23/7/1977 06:04',
  '8t1977': '7/8/1977 22:30',
  '8k1977': '23/8/1977 13:00',
  '9t1977': '8/9/1977 01:16',
  '9k1977': '23/9/1977 10:29',
  '10t1977': '8/10/1977 16:44',
  '10k1977': '23/10/1977 19:41',
  '11t1977': '7/11/1977 19:46',
  '11k1977': '22/11/1977 17:07',
  '12t1977': '7/12/1977 12:31',
  '12k1977': '22/12/1977 06:23',
  '1t1978': '5/1/1978 23:43',
  '1k1978': '20/1/1978 17:04',
  '2t1978': '4/2/1978 11:27',
  '2k1978': '19/2/1978 07:21',
  '3t1978': '6/3/1978 05:38',
  '3k1978': '21/3/1978 06:34',
  '4t1978': '5/4/1978 10:39',
  '4k1978': '20/4/1978 17:50',
  '5t1978': '6/5/1978 04:09',
  '5k1978': '21/5/1978 17:08',
  '6t1978': '6/6/1978 08:23',
  '6k1978': '22/6/1978 01:10',
  '7t1978': '7/7/1978 18:37',
  '7k1978': '23/7/1978 12:00',
  '8t1978': '8/8/1978 04:18',
  '8k1978': '23/8/1978 18:57',
  '9t1978': '8/9/1978 07:02',
  '9k1978': '23/9/1978 16:25',
  '10t1978': '8/10/1978 22:31',
  '10k1978': '24/10/1978 01:37',
  '11t1978': '8/11/1978 01:34',
  '11k1978': '22/11/1978 23:05',
  '12t1978': '7/12/1978 18:20',
  '12k1978': '22/12/1978 12:21',
  '1t1979': '6/1/1979 05:32',
  '1k1979': '20/1/1979 23:00',
  '2t1979': '4/2/1979 17:12',
  '2k1979': '19/2/1979 13:13',
  '3t1979': '6/3/1979 11:20',
  '3k1979': '21/3/1979 12:22',
  '4t1979': '5/4/1979 16:18',
  '4k1979': '20/4/1979 23:35',
  '5t1979': '6/5/1979 09:47',
  '5k1979': '21/5/1979 22:54',
  '6t1979': '6/6/1979 14:05',
  '6k1979': '22/6/1979 06:56',
  '7t1979': '8/7/1979 00:25',
  '7k1979': '23/7/1979 17:49',
  '8t1979': '8/8/1979 10:11',
  '8k1979': '24/8/1979 00:47',
  '9t1979': '8/9/1979 13:00',
  '9k1979': '23/9/1979 22:16',
  '10t1979': '9/10/1979 04:30',
  '10k1979': '24/10/1979 07:28',
  '11t1979': '8/11/1979 07:33',
  '11k1979': '23/11/1979 04:54',
  '12t1979': '8/12/1979 00:18',
  '12k1979': '22/12/1979 18:10',
  '1t1980': '6/1/1980 11:29',
  '1k1980': '21/1/1980 04:49',
  '2t1980': '4/2/1980 23:09',
  '2k1980': '19/2/1980 19:02',
  '3t1980': '5/3/1980 17:17',
  '3k1980': '20/3/1980 18:10',
  '4t1980': '4/4/1980 22:15',
  '4k1980': '20/4/1980 05:23',
  '5t1980': '5/5/1980 15:45',
  '5k1980': '21/5/1980 04:42',
  '6t1980': '5/6/1980 20:04',
  '6k1980': '21/6/1980 12:47',
  '7t1980': '7/7/1980 06:24',
  '7k1980': '22/7/1980 23:42',
  '8t1980': '7/8/1980 16:09',
  '8k1980': '23/8/1980 06:41',
  '9t1980': '7/9/1980 18:53',
  '9k1980': '23/9/1980 04:09',
  '10t1980': '8/10/1980 10:19',
  '10k1980': '23/10/1980 13:18',
  '11t1980': '7/11/1980 13:18',
  '11k1980': '22/11/1980 10:41',
  '12t1980': '7/12/1980 06:01',
  '12k1980': '21/12/1980 23:56',
  '1t1981': '5/1/1981 17:13',
  '1k1981': '20/1/1981 10:36',
  '2t1981': '4/2/1981 04:55',
  '2k1981': '19/2/1981 00:52',
  '3t1981': '5/3/1981 23:05',
  '3k1981': '21/3/1981 00:03',
  '4t1981': '5/4/1981 04:05',
  '4k1981': '20/4/1981 11:19',
  '5t1981': '5/5/1981 21:35',
  '5k1981': '21/5/1981 10:39',
  '6t1981': '6/6/1981 01:53',
  '6k1981': '21/6/1981 18:45',
  '7t1981': '7/7/1981 12:12',
  '7k1981': '23/7/1981 05:40',
  '8t1981': '7/8/1981 21:57',
  '8k1981': '23/8/1981 12:38',
  '9t1981': '8/9/1981 00:43',
  '9k1981': '23/9/1981 10:05',
  '10t1981': '8/10/1981 16:10',
  '10k1981': '23/10/1981 19:13',
  '11t1981': '7/11/1981 19:09',
  '11k1981': '22/11/1981 16:36',
  '12t1981': '7/12/1981 11:51',
  '12k1981': '22/12/1981 05:51',
  '1t1982': '5/1/1982 23:03',
  '1k1982': '20/1/1982 16:31',
  '2t1982': '4/2/1982 10:45',
  '2k1982': '19/2/1982 06:47',
  '3t1982': '6/3/1982 04:55',
  '3k1982': '21/3/1982 05:56',
  '4t1982': '5/4/1982 09:53',
  '4k1982': '20/4/1982 17:07',
  '5t1982': '6/5/1982 03:20',
  '5k1982': '21/5/1982 16:23',
  '6t1982': '6/6/1982 07:36',
  '6k1982': '22/6/1982 00:23',
  '7t1982': '7/7/1982 17:55',
  '7k1982': '23/7/1982 11:15',
  '8t1982': '8/8/1982 03:42',
  '8k1982': '23/8/1982 18:15',
  '9t1982': '8/9/1982 06:32',
  '9k1982': '23/9/1982 15:46',
  '10t1982': '8/10/1982 22:02',
  '10k1982': '24/10/1982 00:58',
  '11t1982': '8/11/1982 01:04',
  '11k1982': '22/11/1982 22:23',
  '12t1982': '7/12/1982 17:48',
  '12k1982': '22/12/1982 11:38',
  '1t1983': '6/1/1983 04:59',
  '1k1983': '20/1/1983 22:17',
  '2t1983': '4/2/1983 16:40',
  '2k1983': '19/2/1983 12:31',
  '3t1983': '6/3/1983 10:47',
  '3k1983': '21/3/1983 11:39',
  '4t1983': '5/4/1983 15:44',
  '4k1983': '20/4/1983 22:50',
  '5t1983': '6/5/1983 09:11',
  '5k1983': '21/5/1983 22:06',
  '6t1983': '6/6/1983 13:26',
  '6k1983': '22/6/1983 06:09',
  '7t1983': '7/7/1983 23:43',
  '7k1983': '23/7/1983 17:04',
  '8t1983': '8/8/1983 09:30',
  '8k1983': '24/8/1983 00:08',
  '9t1983': '8/9/1983 12:20',
  '9k1983': '23/9/1983 21:42',
  '10t1983': '9/10/1983 03:51',
  '10k1983': '24/10/1983 06:54',
  '11t1983': '8/11/1983 06:52',
  '11k1983': '23/11/1983 04:18',
  '12t1983': '7/12/1983 23:34',
  '12k1983': '22/12/1983 17:30',
  '1t1984': '6/1/1984 10:41',
  '1k1984': '21/1/1984 04:05',
  '2t1984': '4/2/1984 22:19',
  '2k1984': '19/2/1984 18:16',
  '3t1984': '5/3/1984 16:25',
  '3k1984': '20/3/1984 17:24',
  '4t1984': '4/4/1984 21:22',
  '4k1984': '20/4/1984 04:38',
  '5t1984': '5/5/1984 14:51',
  '5k1984': '21/5/1984 03:58',
  '6t1984': '5/6/1984 19:09',
  '6k1984': '21/6/1984 12:02',
  '7t1984': '7/7/1984 05:29',
  '7k1984': '22/7/1984 22:58',
  '8t1984': '7/8/1984 15:18',
  '8k1984': '23/8/1984 06:00',
  '9t1984': '7/9/1984 18:10',
  '9k1984': '23/9/1984 03:33',
  '10t1984': '8/10/1984 09:43',
  '10k1984': '23/10/1984 12:46',
  '11t1984': '7/11/1984 12:46',
  '11k1984': '22/11/1984 10:11',
  '12t1984': '7/12/1984 05:28',
  '12k1984': '21/12/1984 23:23',
  '1t1985': '5/1/1985 16:35',
  '1k1985': '20/1/1985 09:58',
  '2t1985': '4/2/1985 04:12',
  '2k1985': '19/2/1985 00:07',
  '3t1985': '5/3/1985 22:16',
  '3k1985': '20/3/1985 23:14',
  '4t1985': '5/4/1985 03:14',
  '4k1985': '20/4/1985 10:26',
  '5t1985': '5/5/1985 20:43',
  '5k1985': '21/5/1985 09:43',
  '6t1985': '6/6/1985 01:00',
  '6k1985': '21/6/1985 17:44',
  '7t1985': '7/7/1985 11:19',
  '7k1985': '23/7/1985 04:36',
  '8t1985': '7/8/1985 21:04',
  '8k1985': '23/8/1985 11:36',
  '9t1985': '7/9/1985 23:53',
  '9k1985': '23/9/1985 09:07',
  '10t1985': '8/10/1985 15:25',
  '10k1985': '23/10/1985 18:22',
  '11t1985': '7/11/1985 18:30',
  '11k1985': '22/11/1985 15:51',
  '12t1985': '7/12/1985 11:16',
  '12k1985': '22/12/1985 05:08',
  '1t1986': '5/1/1986 22:28',
  '1k1986': '20/1/1986 15:46',
  '2t1986': '4/2/1986 10:08',
  '2k1986': '19/2/1986 05:58',
  '3t1986': '6/3/1986 04:12',
  '3k1986': '21/3/1986 05:03',
  '4t1986': '5/4/1986 09:06',
  '4k1986': '20/4/1986 16:12',
  '5t1986': '6/5/1986 02:31',
  '5k1986': '21/5/1986 15:28',
  '6t1986': '6/6/1986 06:44',
  '6k1986': '21/6/1986 23:30',
  '7t1986': '7/7/1986 17:01',
  '7k1986': '23/7/1986 10:24',
  '8t1986': '8/8/1986 02:46',
  '8k1986': '23/8/1986 17:26',
  '9t1986': '8/9/1986 05:35',
  '9k1986': '23/9/1986 14:59',
  '10t1986': '8/10/1986 21:07',
  '10k1986': '24/10/1986 00:14',
  '11t1986': '8/11/1986 00:13',
  '11k1986': '22/11/1986 21:44',
  '12t1986': '7/12/1986 17:01',
  '12k1986': '22/12/1986 11:02',
  '1t1987': '6/1/1987 04:13',
  '1k1987': '20/1/1987 21:40',
  '2t1987': '4/2/1987 15:52',
  '2k1987': '19/2/1987 11:50',
  '3t1987': '6/3/1987 09:54',
  '3k1987': '21/3/1987 10:52',
  '4t1987': '5/4/1987 14:44',
  '4k1987': '20/4/1987 21:58',
  '5t1987': '6/5/1987 08:06',
  '5k1987': '21/5/1987 21:10',
  '6t1987': '6/6/1987 12:19',
  '6k1987': '22/6/1987 05:11',
  '7t1987': '7/7/1987 22:39',
  '7k1987': '23/7/1987 16:06',
  '8t1987': '8/8/1987 08:29',
  '8k1987': '23/8/1987 23:10',
  '9t1987': '8/9/1987 11:24',
  '9k1987': '23/9/1987 20:45',
  '10t1987': '9/10/1987 03:00',
  '10k1987': '24/10/1987 06:01',
  '11t1987': '8/11/1987 06:06',
  '11k1987': '23/11/1987 03:29',
  '12t1987': '7/12/1987 22:52',
  '12k1987': '22/12/1987 16:46',
  '1t1988': '6/1/1988 10:04',
  '1k1988': '21/1/1988 03:24',
  '2t1988': '4/2/1988 21:43',
  '2k1988': '19/2/1988 17:35',
  '3t1988': '5/3/1988 15:47',
  '3k1988': '20/3/1988 16:39',
  '4t1988': '4/4/1988 20:39',
  '4k1988': '20/4/1988 03:45',
  '5t1988': '5/5/1988 14:02',
  '5k1988': '21/5/1988 02:57',
  '6t1988': '5/6/1988 18:15',
  '6k1988': '21/6/1988 10:57',
  '7t1988': '7/7/1988 04:33',
  '7k1988': '22/7/1988 21:51',
  '8t1988': '7/8/1988 14:20',
  '8k1988': '23/8/1988 04:54',
  '9t1988': '7/9/1988 17:12',
  '9k1988': '23/9/1988 02:29',
  '10t1988': '8/10/1988 08:45',
  '10k1988': '23/10/1988 11:44',
  '11t1988': '7/11/1988 11:49',
  '11k1988': '22/11/1988 09:12',
  '12t1988': '7/12/1988 04:35',
  '12k1988': '21/12/1988 22:28',
  '1t1989': '5/1/1989 15:46',
  '1k1989': '20/1/1989 09:07',
  '2t1989': '4/2/1989 03:27',
  '2k1989': '18/2/1989 23:21',
  '3t1989': '5/3/1989 21:34',
  '3k1989': '20/3/1989 22:28',
  '4t1989': '5/4/1989 02:30',
  '4k1989': '20/4/1989 09:39',
  '5t1989': '5/5/1989 19:54',
  '5k1989': '21/5/1989 08:54',
  '6t1989': '6/6/1989 00:05',
  '6k1989': '21/6/1989 16:53',
  '7t1989': '7/7/1989 10:19',
  '7k1989': '23/7/1989 03:45',
  '8t1989': '7/8/1989 20:04',
  '8k1989': '23/8/1989 10:46',
  '9t1989': '7/9/1989 22:54',
  '9k1989': '23/9/1989 08:20',
  '10t1989': '8/10/1989 14:27',
  '10k1989': '23/10/1989 17:35',
  '11t1989': '7/11/1989 17:34',
  '11k1989': '22/11/1989 15:05',
  '12t1989': '7/12/1989 10:21',
  '12k1989': '22/12/1989 04:22',
  '1t1990': '5/1/1990 21:33',
  '1k1990': '20/1/1990 15:02',
  '2t1990': '4/2/1990 09:14',
  '2k1990': '19/2/1990 05:14',
  '3t1990': '6/3/1990 03:19',
  '3k1990': '21/3/1990 04:19',
  '4t1990': '5/4/1990 08:13',
  '4k1990': '20/4/1990 15:27',
  '5t1990': '6/5/1990 01:35',
  '5k1990': '21/5/1990 14:37',
  '6t1990': '6/6/1990 05:46',
  '6k1990': '21/6/1990 22:33',
  '7t1990': '7/7/1990 16:00',
  '7k1990': '23/7/1990 09:22',
  '8t1990': '8/8/1990 01:46',
  '8k1990': '23/8/1990 16:21',
  '9t1990': '8/9/1990 04:37',
  '9k1990': '23/9/1990 13:56',
  '10t1990': '8/10/1990 20:14',
  '10k1990': '23/10/1990 23:14',
  '11t1990': '7/11/1990 23:23',
  '11k1990': '22/11/1990 20:47',
  '12t1990': '7/12/1990 16:14',
  '12k1990': '22/12/1990 10:07',
  '1t1991': '6/1/1991 03:28',
  '1k1991': '20/1/1991 20:47',
  '2t1991': '4/2/1991 15:08',
  '2k1991': '19/2/1991 10:58',
  '3t1991': '6/3/1991 09:12',
  '3k1991': '21/3/1991 10:02',
  '4t1991': '5/4/1991 14:05',
  '4k1991': '20/4/1991 21:08',
  '5t1991': '6/5/1991 07:27',
  '5k1991': '21/5/1991 20:20',
  '6t1991': '6/6/1991 11:38',
  '6k1991': '22/6/1991 04:19',
  '7t1991': '7/7/1991 21:53',
  '7k1991': '23/7/1991 15:11',
  '8t1991': '8/8/1991 07:37',
  '8k1991': '23/8/1991 22:13',
  '9t1991': '8/9/1991 10:27',
  '9k1991': '23/9/1991 19:48',
  '10t1991': '9/10/1991 02:01',
  '10k1991': '24/10/1991 05:05',
  '11t1991': '8/11/1991 05:08',
  '11k1991': '23/11/1991 02:36',
  '12t1991': '7/12/1991 21:56',
  '12k1991': '22/12/1991 15:54',
  '1t1992': '6/1/1992 09:09',
  '1k1992': '21/1/1992 02:33',
  '2t1992': '4/2/1992 20:48',
  '2k1992': '19/2/1992 16:44',
  '3t1992': '5/3/1992 14:52',
  '3k1992': '20/3/1992 15:48',
  '4t1992': '4/4/1992 19:45',
  '4k1992': '20/4/1992 02:57',
  '5t1992': '5/5/1992 13:09',
  '5k1992': '21/5/1992 02:12',
  '6t1992': '5/6/1992 17:22',
  '6k1992': '21/6/1992 10:14',
  '7t1992': '7/7/1992 03:40',
  '7k1992': '22/7/1992 21:09',
  '8t1992': '7/8/1992 13:27',
  '8k1992': '23/8/1992 04:10',
  '9t1992': '7/9/1992 16:18',
  '9k1992': '23/9/1992 01:43',
  '10t1992': '8/10/1992 07:51',
  '10k1992': '23/10/1992 10:57',
  '11t1992': '7/11/1992 10:57',
  '11k1992': '22/11/1992 08:26',
  '12t1992': '7/12/1992 03:44',
  '12k1992': '21/12/1992 21:43',
  '1t1993': '5/1/1993 14:57',
  '1k1993': '20/1/1993 08:23',
  '2t1993': '4/2/1993 02:37',
  '2k1993': '18/2/1993 22:35',
  '3t1993': '5/3/1993 20:43',
  '3k1993': '20/3/1993 21:41',
  '4t1993': '5/4/1993 01:37',
  '4k1993': '20/4/1993 08:49',
  '5t1993': '5/5/1993 19:02',
  '5k1993': '21/5/1993 08:02',
  '6t1993': '5/6/1993 23:15',
  '6k1993': '21/6/1993 16:00',
  '7t1993': '7/7/1993 09:32',
  '7k1993': '23/7/1993 02:51',
  '8t1993': '7/8/1993 19:18',
  '8k1993': '23/8/1993 09:50',
  '9t1993': '7/9/1993 22:08',
  '9k1993': '23/9/1993 07:22',
  '10t1993': '8/10/1993 13:40',
  '10k1993': '23/10/1993 16:37',
  '11t1993': '7/11/1993 16:46',
  '11k1993': '22/11/1993 14:07',
  '12t1993': '7/12/1993 09:34',
  '12k1993': '22/12/1993 03:26',
  '1t1994': '5/1/1994 20:48',
  '1k1994': '20/1/1994 14:07',
  '2t1994': '4/2/1994 08:31',
  '2k1994': '19/2/1994 04:22',
  '3t1994': '6/3/1994 02:38',
  '3k1994': '21/3/1994 03:28',
  '4t1994': '5/4/1994 07:32',
  '4k1994': '20/4/1994 14:36',
  '5t1994': '6/5/1994 00:54',
  '5k1994': '21/5/1994 13:48',
  '6t1994': '6/6/1994 05:05',
  '6k1994': '21/6/1994 21:48',
  '7t1994': '7/7/1994 15:19',
  '7k1994': '23/7/1994 08:41',
  '8t1994': '8/8/1994 01:04',
  '8k1994': '23/8/1994 15:44',
  '9t1994': '8/9/1994 03:55',
  '9k1994': '23/9/1994 13:19',
  '10t1994': '8/10/1994 19:29',
  '10k1994': '23/10/1994 22:36',
  '11t1994': '7/11/1994 22:36',
  '11k1994': '22/11/1994 20:06',
  '12t1994': '7/12/1994 15:23',
  '12k1994': '22/12/1994 09:23',
  '1t1995': '6/1/1995 02:34',
  '1k1995': '20/1/1995 20:00',
  '2t1995': '4/2/1995 14:13',
  '2k1995': '19/2/1995 10:11',
  '3t1995': '6/3/1995 08:16',
  '3k1995': '21/3/1995 09:14',
  '4t1995': '5/4/1995 13:08',
  '4k1995': '20/4/1995 20:21',
  '5t1995': '6/5/1995 06:30',
  '5k1995': '21/5/1995 19:34',
  '6t1995': '6/6/1995 10:42',
  '6k1995': '22/6/1995 03:34',
  '7t1995': '7/7/1995 21:01',
  '7k1995': '23/7/1995 14:30',
  '8t1995': '8/8/1995 06:52',
  '8k1995': '23/8/1995 21:35',
  '9t1995': '8/9/1995 09:49',
  '9k1995': '23/9/1995 19:13',
  '10t1995': '9/10/1995 01:27',
  '10k1995': '24/10/1995 04:32',
  '11t1995': '8/11/1995 04:36',
  '11k1995': '23/11/1995 02:01',
  '12t1995': '7/12/1995 21:22',
  '12k1995': '22/12/1995 15:17',
  '1t1996': '6/1/1996 08:31',
  '1k1996': '21/1/1996 01:53',
  '2t1996': '4/2/1996 20:08',
  '2k1996': '19/2/1996 16:01',
  '3t1996': '5/3/1996 14:10',
  '3k1996': '20/3/1996 15:03',
  '4t1996': '4/4/1996 19:02',
  '4k1996': '20/4/1996 02:10',
  '5t1996': '5/5/1996 12:26',
  '5k1996': '21/5/1996 01:23',
  '6t1996': '5/6/1996 16:41',
  '6k1996': '21/6/1996 09:24',
  '7t1996': '7/7/1996 03:00',
  '7k1996': '22/7/1996 20:19',
  '8t1996': '7/8/1996 12:49',
  '8k1996': '23/8/1996 03:23',
  '9t1996': '7/9/1996 15:42',
  '9k1996': '23/9/1996 01:00',
  '10t1996': '8/10/1996 07:19',
  '10k1996': '23/10/1996 10:19',
  '11t1996': '7/11/1996 10:27',
  '11k1996': '22/11/1996 07:49',
  '12t1996': '7/12/1996 03:14',
  '12k1996': '21/12/1996 21:06',
  '1t1997': '5/1/1997 14:24',
  '1k1997': '20/1/1997 07:43',
  '2t1997': '4/2/1997 02:02',
  '2k1997': '18/2/1997 21:51',
  '3t1997': '5/3/1997 20:04',
  '3k1997': '20/3/1997 20:55',
  '4t1997': '5/4/1997 00:56',
  '4k1997': '20/4/1997 08:03',
  '5t1997': '5/5/1997 18:19',
  '5k1997': '21/5/1997 07:18',
  '6t1997': '5/6/1997 22:33',
  '6k1997': '21/6/1997 15:20',
  '7t1997': '7/7/1997 08:49',
  '7k1997': '23/7/1997 02:15',
  '8t1997': '7/8/1997 18:36',
  '8k1997': '23/8/1997 09:19',
  '9t1997': '7/9/1997 21:29',
  '9k1997': '23/9/1997 06:56',
  '10t1997': '8/10/1997 13:05',
  '10k1997': '23/10/1997 16:15',
  '11t1997': '7/11/1997 16:15',
  '11k1997': '22/11/1997 13:48',
  '12t1997': '7/12/1997 09:05',
  '12k1997': '22/12/1997 03:07',
  '1t1998': '5/1/1998 20:18',
  '1k1998': '20/1/1998 13:46',
  '2t1998': '4/2/1998 07:57',
  '2k1998': '19/2/1998 03:55',
  '3t1998': '6/3/1998 01:57',
  '3k1998': '21/3/1998 02:55',
  '4t1998': '5/4/1998 06:45',
  '4k1998': '20/4/1998 13:57',
  '5t1998': '6/5/1998 00:03',
  '5k1998': '21/5/1998 13:05',
  '6t1998': '6/6/1998 04:13',
  '6k1998': '21/6/1998 21:03',
  '7t1998': '7/7/1998 14:30',
  '7k1998': '23/7/1998 07:55',
  '8t1998': '8/8/1998 00:20',
  '8k1998': '23/8/1998 14:59',
  '9t1998': '8/9/1998 03:16',
  '9k1998': '23/9/1998 12:37',
  '10t1998': '8/10/1998 18:56',
  '10k1998': '23/10/1998 21:59',
  '11t1998': '7/11/1998 22:08',
  '11k1998': '22/11/1998 19:34',
  '12t1998': '7/12/1998 15:02',
  '12k1998': '22/12/1998 08:56',
  '1t1999': '6/1/1999 02:17',
  '1k1999': '20/1/1999 19:37',
  '2t1999': '4/2/1999 13:57',
  '2k1999': '19/2/1999 09:47',
  '3t1999': '6/3/1999 07:58',
  '3k1999': '21/3/1999 08:46',
  '4t1999': '5/4/1999 12:45',
  '4k1999': '20/4/1999 19:46',
  '5t1999': '6/5/1999 06:01',
  '5k1999': '21/5/1999 18:52',
  '6t1999': '6/6/1999 10:09',
  '6k1999': '22/6/1999 02:49',
  '7t1999': '7/7/1999 20:25',
  '7k1999': '23/7/1999 13:44',
  '8t1999': '8/8/1999 06:14',
  '8k1999': '23/8/1999 20:51',
  '9t1999': '8/9/1999 09:10',
  '9k1999': '23/9/1999 18:32',
  '10t1999': '9/10/1999 00:48',
  '10k1999': '24/10/1999 03:52',
  '11t1999': '8/11/1999 03:58',
  '11k1999': '23/11/1999 01:25',
  '12t1999': '7/12/1999 20:47',
  '12k1999': '22/12/1999 14:44',
  '1t2000': '6/1/2000 08:01',
  '1k2000': '21/1/2000 01:23',
  '2t2000': '4/2/2000 19:40',
  '2k2000': '19/2/2000 15:33',
  '3t2000': '5/3/2000 13:43',
  '3k2000': '20/3/2000 14:35',
  '4t2000': '4/4/2000 18:32',
  '4k2000': '20/4/2000 01:40',
  '5t2000': '5/5/2000 11:50',
  '5k2000': '21/5/2000 00:49',
  '6t2000': '5/6/2000 15:59',
  '6k2000': '21/6/2000 08:48',
  '7t2000': '7/7/2000 02:14',
  '7k2000': '22/7/2000 19:43',
  '8t2000': '7/8/2000 12:03',
  '8k2000': '23/8/2000 02:49',
  '9t2000': '7/9/2000 14:59',
  '9k2000': '23/9/2000 00:28',
  '10t2000': '8/10/2000 06:38',
  '10k2000': '23/10/2000 09:47',
  '11t2000': '7/11/2000 09:48',
  '11k2000': '22/11/2000 07:19',
  '12t2000': '7/12/2000 02:37',
  '12k2000': '21/12/2000 20:37',
  '1t2001': '5/1/2001 13:49',
  '1k2001': '20/1/2001 07:16',
  '2t2001': '4/2/2001 01:29',
  '2k2001': '18/2/2001 21:27',
  '3t2001': '5/3/2001 19:32',
  '3k2001': '20/3/2001 20:31',
  '4t2001': '5/4/2001 00:24',
  '4k2001': '20/4/2001 07:36',
  '5t2001': '5/5/2001 17:45',
  '5k2001': '21/5/2001 06:44',
  '6t2001': '5/6/2001 21:54',
  '6k2001': '21/6/2001 14:38',
  '7t2001': '7/7/2001 08:07',
  '7k2001': '23/7/2001 01:26',
  '8t2001': '7/8/2001 17:52',
  '8k2001': '23/8/2001 08:27',
  '9t2001': '7/9/2001 20:46',
  '9k2001': '23/9/2001 06:04',
  '10t2001': '8/10/2001 12:25',
  '10k2001': '23/10/2001 15:26',
  '11t2001': '7/11/2001 15:37',
  '11k2001': '22/11/2001 13:00',
  '12t2001': '7/12/2001 08:29',
  '12k2001': '22/12/2001 02:22',
  '1t2002': '5/1/2002 19:44',
  '1k2002': '20/1/2002 13:02',
  '2t2002': '4/2/2002 07:24',
  '2k2002': '19/2/2002 03:13',
  '3t2002': '6/3/2002 01:28',
  '3k2002': '21/3/2002 02:16',
  '4t2002': '5/4/2002 06:18',
  '4k2002': '20/4/2002 13:20',
  '5t2002': '5/5/2002 23:37',
  '5k2002': '21/5/2002 12:29',
  '6t2002': '6/6/2002 03:45',
  '6k2002': '21/6/2002 20:24',
  '7t2002': '7/7/2002 13:56',
  '7k2002': '23/7/2002 07:15',
  '8t2002': '7/8/2002 23:39',
  '8k2002': '23/8/2002 14:17',
  '9t2002': '8/9/2002 02:31',
  '9k2002': '23/9/2002 11:55',
  '10t2002': '8/10/2002 18:09',
  '10k2002': '23/10/2002 21:18',
  '11t2002': '7/11/2002 21:22',
  '11k2002': '22/11/2002 18:54',
  '12t2002': '7/12/2002 14:14',
  '12k2002': '22/12/2002 08:14',
  '1t2003': '6/1/2003 01:28',
  '1k2003': '20/1/2003 18:53',
  '2t2003': '4/2/2003 13:05',
  '2k2003': '19/2/2003 09:00',
  '3t2003': '6/3/2003 07:05',
  '3k2003': '21/3/2003 08:00',
  '4t2003': '5/4/2003 11:53',
  '4k2003': '20/4/2003 19:03',
  '5t2003': '6/5/2003 05:11',
  '5k2003': '21/5/2003 18:12',
  '6t2003': '6/6/2003 09:20',
  '6k2003': '22/6/2003 02:10',
  '7t2003': '7/7/2003 19:36',
  '7k2003': '23/7/2003 13:04',
  '8t2003': '8/8/2003 05:24',
  '8k2003': '23/8/2003 20:08',
  '9t2003': '8/9/2003 08:20',
  '9k2003': '23/9/2003 17:47',
  '10t2003': '9/10/2003 00:01',
  '10k2003': '24/10/2003 03:08',
  '11t2003': '8/11/2003 03:13',
  '11k2003': '23/11/2003 00:43',
  '12t2003': '7/12/2003 20:05',
  '12k2003': '22/12/2003 14:04',
  '1t2004': '6/1/2004 07:19',
  '1k2004': '21/1/2004 00:42',
  '2t2004': '4/2/2004 18:56',
  '2k2004': '19/2/2004 14:50',
  '3t2004': '5/3/2004 12:56',
  '3k2004': '20/3/2004 13:49',
  '4t2004': '4/4/2004 17:43',
  '4k2004': '20/4/2004 00:50',
  '5t2004': '5/5/2004 11:02',
  '5k2004': '20/5/2004 23:59',
  '6t2004': '5/6/2004 15:14',
  '6k2004': '21/6/2004 07:57',
  '7t2004': '7/7/2004 01:31',
  '7k2004': '22/7/2004 18:50',
  '8t2004': '7/8/2004 11:20',
  '8k2004': '23/8/2004 01:53',
  '9t2004': '7/9/2004 14:13',
  '9k2004': '22/9/2004 23:30',
  '10t2004': '8/10/2004 05:49',
  '10k2004': '23/10/2004 08:49',
  '11t2004': '7/11/2004 08:59',
  '11k2004': '22/11/2004 06:22',
  '12t2004': '7/12/2004 01:49',
  '12k2004': '21/12/2004 19:42',
  '1t2005': '5/1/2005 13:03',
  '1k2005': '20/1/2005 06:22',
  '2t2005': '4/2/2005 00:43',
  '2k2005': '18/2/2005 20:32',
  '3t2005': '5/3/2005 18:45',
  '3k2005': '20/3/2005 19:33',
  '4t2005': '4/4/2005 23:34',
  '4k2005': '20/4/2005 06:37',
  '5t2005': '5/5/2005 16:53',
  '5k2005': '21/5/2005 05:47',
  '6t2005': '5/6/2005 21:02',
  '6k2005': '21/6/2005 13:46',
  '7t2005': '7/7/2005 07:17',
  '7k2005': '23/7/2005 00:41',
  '8t2005': '7/8/2005 17:03',
  '8k2005': '23/8/2005 07:45',
  '9t2005': '7/9/2005 19:57',
  '9k2005': '23/9/2005 05:23',
  '10t2005': '8/10/2005 11:33',
  '10k2005': '23/10/2005 14:42',
  '11t2005': '7/11/2005 14:42',
  '11k2005': '22/11/2005 12:15',
  '12t2005': '7/12/2005 07:33',
  '12k2005': '22/12/2005 01:35',
  '1t2006': '5/1/2006 18:47',
  '1k2006': '20/1/2006 12:15',
  '2t2006': '4/2/2006 06:27',
  '2k2006': '19/2/2006 02:26',
  '3t2006': '6/3/2006 00:29',
  '3k2006': '21/3/2006 01:26',
  '4t2006': '5/4/2006 05:15',
  '4k2006': '20/4/2006 12:26',
  '5t2006': '5/5/2006 22:31',
  '5k2006': '21/5/2006 11:32',
  '6t2006': '6/6/2006 02:37',
  '6k2006': '21/6/2006 19:26',
  '7t2006': '7/7/2006 12:51',
  '7k2006': '23/7/2006 06:18',
  '8t2006': '7/8/2006 22:41',
  '8k2006': '23/8/2006 13:23',
  '9t2006': '8/9/2006 01:39',
  '9k2006': '23/9/2006 11:03',
  '10t2006': '8/10/2006 17:21',
  '10k2006': '23/10/2006 20:26',
  '11t2006': '7/11/2006 20:35',
  '11k2006': '22/11/2006 18:02',
  '12t2006': '7/12/2006 13:27',
  '12k2006': '22/12/2006 07:22',
  '1t2007': '6/1/2007 00:40',
  '1k2007': '20/1/2007 18:01',
  '2t2007': '4/2/2007 12:18',
  '2k2007': '19/2/2007 08:09',
  '3t2007': '6/3/2007 06:18',
  '3k2007': '21/3/2007 07:07',
  '4t2007': '5/4/2007 11:05',
  '4k2007': '20/4/2007 18:07',
  '5t2007': '6/5/2007 04:20',
  '5k2007': '21/5/2007 17:12',
  '6t2007': '6/6/2007 08:27',
  '6k2007': '22/6/2007 01:06',
  '7t2007': '7/7/2007 18:42',
  '7k2007': '23/7/2007 12:00',
  '8t2007': '8/8/2007 04:31',
  '8k2007': '23/8/2007 19:08',
  '9t2007': '8/9/2007 07:29',
  '9k2007': '23/9/2007 16:51',
  '10t2007': '8/10/2007 23:11',
  '10k2007': '24/10/2007 02:15',
  '11t2007': '8/11/2007 02:24',
  '11k2007': '22/11/2007 23:50',
  '12t2007': '7/12/2007 19:14',
  '12k2007': '22/12/2007 13:08',
  '1t2008': '6/1/2008 06:25',
  '1k2008': '20/1/2008 23:44',
  '2t2008': '4/2/2008 18:00',
  '2k2008': '19/2/2008 13:50',
  '3t2008': '5/3/2008 11:59',
  '3k2008': '20/3/2008 12:48',
  '4t2008': '4/4/2008 16:46',
  '4k2008': '19/4/2008 23:51',
  '5t2008': '5/5/2008 10:03',
  '5k2008': '20/5/2008 23:01',
  '6t2008': '5/6/2008 14:12',
  '6k2008': '21/6/2008 06:59',
  '7t2008': '7/7/2008 00:27',
  '7k2008': '22/7/2008 17:55',
  '8t2008': '7/8/2008 10:16',
  '8k2008': '23/8/2008 01:02',
  '9t2008': '7/9/2008 13:14',
  '9k2008': '22/9/2008 22:44',
  '10t2008': '8/10/2008 04:57',
  '10k2008': '23/10/2008 08:09',
  '11t2008': '7/11/2008 08:11',
  '11k2008': '22/11/2008 05:44',
  '12t2008': '7/12/2008 01:02',
  '12k2008': '21/12/2008 19:04',
  '1t2009': '5/1/2009 12:14',
  '1k2009': '20/1/2009 05:40',
  '2t2009': '3/2/2009 23:50',
  '2k2009': '18/2/2009 19:46',
  '3t2009': '5/3/2009 17:48',
  '3k2009': '20/3/2009 18:44',
  '4t2009': '4/4/2009 22:34',
  '4k2009': '20/4/2009 05:44',
  '5t2009': '5/5/2009 15:51',
  '5k2009': '21/5/2009 04:51',
  '6t2009': '5/6/2009 19:59',
  '6k2009': '21/6/2009 12:46',
  '7t2009': '7/7/2009 06:13',
  '7k2009': '22/7/2009 23:36',
  '8t2009': '7/8/2009 16:01',
  '8k2009': '23/8/2009 06:39',
  '9t2009': '7/9/2009 18:58',
  '9k2009': '23/9/2009 04:19',
  '10t2009': '8/10/2009 10:40',
  '10k2009': '23/10/2009 13:43',
  '11t2009': '7/11/2009 13:56',
  '11k2009': '22/11/2009 11:23',
  '12t2009': '7/12/2009 06:52',
  '12k2009': '22/12/2009 00:47',
  '1t2010': '5/1/2010 18:09',
  '1k2010': '20/1/2010 11:28',
  '2t2010': '4/2/2010 05:48',
  '2k2010': '19/2/2010 01:36',
  '3t2010': '5/3/2010 23:46',
  '3k2010': '21/3/2010 00:32',
  '4t2010': '5/4/2010 04:30',
  '4k2010': '20/4/2010 11:30',
  '5t2010': '5/5/2010 21:44',
  '5k2010': '21/5/2010 10:34',
  '6t2010': '6/6/2010 01:49',
  '6k2010': '21/6/2010 18:28',
  '7t2010': '7/7/2010 12:02',
  '7k2010': '23/7/2010 05:21',
  '8t2010': '7/8/2010 21:49',
  '8k2010': '23/8/2010 12:27',
  '9t2010': '8/9/2010 00:45',
  '9k2010': '23/9/2010 10:09',
  '10t2010': '8/10/2010 16:26',
  '10k2010': '23/10/2010 19:35',
  '11t2010': '7/11/2010 19:42',
  '11k2010': '22/11/2010 17:15',
  '12t2010': '7/12/2010 12:38',
  '12k2010': '22/12/2010 06:38',
  '1t2011': '5/1/2011 23:55',
  '1k2011': '20/1/2011 17:19',
  '2t2011': '4/2/2011 11:33',
  '2k2011': '19/2/2011 07:25',
  '3t2011': '6/3/2011 05:30',
  '3k2011': '21/3/2011 06:21',
  '4t2011': '5/4/2011 10:12',
  '4k2011': '20/4/2011 17:17',
  '5t2011': '6/5/2011 03:23',
  '5k2011': '21/5/2011 16:21',
  '6t2011': '6/6/2011 07:27',
  '6k2011': '22/6/2011 00:17',
  '7t2011': '7/7/2011 17:42',
  '7k2011': '23/7/2011 11:12',
  '8t2011': '8/8/2011 03:33',
  '8k2011': '23/8/2011 18:21',
  '9t2011': '8/9/2011 06:34',
  '9k2011': '23/9/2011 16:05',
  '10t2011': '8/10/2011 22:19',
  '10k2011': '24/10/2011 01:30',
  '11t2011': '8/11/2011 01:35',
  '11k2011': '22/11/2011 23:08',
  '12t2011': '7/12/2011 18:29',
  '12k2011': '22/12/2011 12:30',
  '1t2012': '6/1/2012 05:44',
  '1k2012': '20/1/2012 23:10',
  '2t2012': '4/2/2012 17:22',
  '2k2012': '19/2/2012 13:18',
  '3t2012': '5/3/2012 11:21',
  '3k2012': '20/3/2012 12:14',
  '4t2012': '4/4/2012 16:06',
  '4k2012': '19/4/2012 23:12',
  '5t2012': '5/5/2012 09:20',
  '5k2012': '20/5/2012 22:16',
  '6t2012': '5/6/2012 13:26',
  '6k2012': '21/6/2012 06:09',
  '7t2012': '6/7/2012 23:41',
  '7k2012': '22/7/2012 17:01',
  '8t2012': '7/8/2012 09:31',
  '8k2012': '23/8/2012 00:07',
  '9t2012': '7/9/2012 12:29',
  '9k2012': '22/9/2012 21:49',
  '10t2012': '8/10/2012 04:12',
  '10k2012': '23/10/2012 07:14',
  '11t2012': '7/11/2012 07:26',
  '11k2012': '22/11/2012 04:50',
  '12t2012': '7/12/2012 00:19',
  '12k2012': '21/12/2012 18:12',
  '1t2013': '5/1/2013 11:34',
  '1k2013': '20/1/2013 04:52',
  '2t2013': '3/2/2013 23:13',
  '2k2013': '18/2/2013 19:02',
  '3t2013': '5/3/2013 17:15',
  '3k2013': '20/3/2013 18:02',
  '4t2013': '4/4/2013 22:02',
  '4k2013': '20/4/2013 05:03',
  '5t2013': '5/5/2013 15:18',
  '5k2013': '21/5/2013 04:09',
  '6t2013': '5/6/2013 19:23',
  '6k2013': '21/6/2013 12:04',
  '7t2013': '7/7/2013 05:35',
  '7k2013': '22/7/2013 22:56',
  '8t2013': '7/8/2013 15:20',
  '8k2013': '23/8/2013 06:02',
  '9t2013': '7/9/2013 18:16',
  '9k2013': '23/9/2013 03:44',
  '10t2013': '8/10/2013 09:58',
  '10k2013': '23/10/2013 13:10',
  '11t2013': '7/11/2013 13:14',
  '11k2013': '22/11/2013 10:48',
  '12t2013': '7/12/2013 06:08',
  '12k2013': '22/12/2013 00:11',
  '1t2014': '5/1/2014 17:24',
  '1k2014': '20/1/2014 10:51',
  '2t2014': '4/2/2014 05:03',
  '2k2014': '19/2/2014 00:59',
  '3t2014': '5/3/2014 23:02',
  '3k2014': '20/3/2014 23:57',
  '4t2014': '5/4/2014 03:47',
  '4k2014': '20/4/2014 10:55',
  '5t2014': '5/5/2014 20:59',
  '5k2014': '21/5/2014 09:59',
  '6t2014': '6/6/2014 01:03',
  '6k2014': '21/6/2014 17:51',
  '7t2014': '7/7/2014 11:15',
  '7k2014': '23/7/2014 04:41',
  '8t2014': '7/8/2014 21:02',
  '8k2014': '23/8/2014 11:46',
  '9t2014': '8/9/2014 00:01',
  '9k2014': '23/9/2014 09:29',
  '10t2014': '8/10/2014 15:47',
  '10k2014': '23/10/2014 18:57',
  '11t2014': '7/11/2014 19:07',
  '11k2014': '22/11/2014 16:38',
  '12t2014': '7/12/2014 12:04',
  '12k2014': '22/12/2014 06:03',
  '1t2015': '5/1/2015 23:20',
  '1k2015': '20/1/2015 16:43',
  '2t2015': '4/2/2015 10:58',
  '2k2015': '19/2/2015 06:50',
  '3t2015': '6/3/2015 04:56',
  '3k2015': '21/3/2015 05:45',
  '4t2015': '5/4/2015 09:39',
  '4k2015': '20/4/2015 16:42',
  '5t2015': '6/5/2015 02:52',
  '5k2015': '21/5/2015 15:45',
  '6t2015': '6/6/2015 06:58',
  '6k2015': '21/6/2015 23:38',
  '7t2015': '7/7/2015 17:12',
  '7k2015': '23/7/2015 10:30',
  '8t2015': '8/8/2015 03:01',
  '8k2015': '23/8/2015 17:37',
  '9t2015': '8/9/2015 05:59',
  '9k2015': '23/9/2015 15:20',
  '10t2015': '8/10/2015 21:43',
  '10k2015': '24/10/2015 00:47',
  '11t2015': '8/11/2015 00:59',
  '11k2015': '22/11/2015 22:25',
  '12t2015': '7/12/2015 17:53',
  '12k2015': '22/12/2015 11:48',
  '1t2016': '6/1/2016 05:08',
  '1k2016': '20/1/2016 22:27',
  '2t2016': '4/2/2016 16:46',
  '2k2016': '19/2/2016 12:34',
  '3t2016': '5/3/2016 10:43',
  '3k2016': '20/3/2016 11:30',
  '4t2016': '4/4/2016 15:27',
  '4k2016': '19/4/2016 22:29',
  '5t2016': '5/5/2016 08:42',
  '5k2016': '20/5/2016 21:36',
  '6t2016': '5/6/2016 12:48',
  '6k2016': '21/6/2016 05:34',
  '7t2016': '6/7/2016 23:03',
  '7k2016': '22/7/2016 16:30',
  '8t2016': '7/8/2016 08:53',
  '8k2016': '22/8/2016 23:38',
  '9t2016': '7/9/2016 11:51',
  '9k2016': '22/9/2016 21:21',
  '10t2016': '8/10/2016 03:33',
  '10k2016': '23/10/2016 06:45',
  '11t2016': '7/11/2016 06:48',
  '11k2016': '22/11/2016 04:22',
  '12t2016': '6/12/2016 23:41',
  '12k2016': '21/12/2016 17:44',
  '1t2017': '5/1/2017 10:56',
  '1k2017': '20/1/2017 04:23',
  '2t2017': '3/2/2017 22:34',
  '2k2017': '18/2/2017 18:31',
  '3t2017': '5/3/2017 16:33',
  '3k2017': '20/3/2017 17:28',
  '4t2017': '4/4/2017 21:17',
  '4k2017': '20/4/2017 04:27',
  '5t2017': '5/5/2017 14:31',
  '5k2017': '21/5/2017 03:31',
  '6t2017': '5/6/2017 18:36',
  '6k2017': '21/6/2017 11:24',
  '7t2017': '7/7/2017 04:51',
  '7k2017': '22/7/2017 22:15',
  '8t2017': '7/8/2017 14:40',
  '8k2017': '23/8/2017 05:20',
  '9t2017': '7/9/2017 17:38',
  '9k2017': '23/9/2017 03:02',
  '10t2017': '8/10/2017 09:22',
  '10k2017': '23/10/2017 12:27',
  '11t2017': '7/11/2017 12:38',
  '11k2017': '22/11/2017 10:04',
  '12t2017': '7/12/2017 05:32',
  '12k2017': '21/12/2017 23:28',
  '1t2018': '5/1/2018 16:49',
  '1k2018': '20/1/2018 10:09',
  '2t2018': '4/2/2018 04:28',
  '2k2018': '19/2/2018 00:18',
  '3t2018': '5/3/2018 22:28',
  '3k2018': '20/3/2018 23:15',
  '4t2018': '5/4/2018 03:13',
  '4k2018': '20/4/2018 10:12',
  '5t2018': '5/5/2018 20:25',
  '5k2018': '21/5/2018 09:14',
  '6t2018': '6/6/2018 00:29',
  '6k2018': '21/6/2018 17:07',
  '7t2018': '7/7/2018 10:42',
  '7k2018': '23/7/2018 04:00',
  '8t2018': '7/8/2018 20:30',
  '8k2018': '23/8/2018 11:08',
  '9t2018': '7/9/2018 23:29',
  '9k2018': '23/9/2018 08:54',
  '10t2018': '8/10/2018 15:15',
  '10k2018': '23/10/2018 18:22',
  '11t2018': '7/11/2018 18:32',
  '11k2018': '22/11/2018 16:01',
  '12t2018': '7/12/2018 11:26',
  '12k2018': '22/12/2018 05:23',
  '1t2019': '5/1/2019 22:39',
  '1k2019': '20/1/2019 15:59',
  '2t2019': '4/2/2019 10:14',
  '2k2019': '19/2/2019 06:04',
  '3t2019': '6/3/2019 04:10',
  '3k2019': '21/3/2019 04:58',
  '4t2019': '5/4/2019 08:51',
  '4k2019': '20/4/2019 15:55',
  '5t2019': '6/5/2019 02:03',
  '5k2019': '21/5/2019 14:59',
  '6t2019': '6/6/2019 06:06',
  '6k2019': '21/6/2019 22:54',
  '7t2019': '7/7/2019 16:20',
  '7k2019': '23/7/2019 09:50',
  '8t2019': '8/8/2019 02:13',
  '8k2019': '23/8/2019 17:02',
  '9t2019': '8/9/2019 05:17',
  '9k2019': '23/9/2019 14:50',
  '10t2019': '8/10/2019 21:05',
  '10k2019': '24/10/2019 00:20',
  '11t2019': '8/11/2019 00:24',
  '11k2019': '22/11/2019 21:59',
  '12t2019': '7/12/2019 17:18',
  '12k2019': '22/12/2019 11:19',
  '1t2020': '6/1/2020 04:30',
  '1k2020': '20/1/2020 21:54',
  '2t2020': '4/2/2020 16:03',
  '2k2020': '19/2/2020 11:57',
  '3t2020': '5/3/2020 09:57',
  '3k2020': '20/3/2020 10:49',
  '4t2020': '4/4/2020 14:38',
  '4k2020': '19/4/2020 21:45',
  '5t2020': '5/5/2020 07:51',
  '5k2020': '20/5/2020 20:49',
  '6t2020': '5/6/2020 11:58',
  '6k2020': '21/6/2020 04:43',
  '7t2020': '6/7/2020 22:14',
  '7k2020': '22/7/2020 15:37',
  '8t2020': '7/8/2020 08:06',
  '8k2020': '22/8/2020 22:45',
  '9t2020': '7/9/2020 11:08',
  '9k2020': '22/9/2020 20:30',
  '10t2020': '8/10/2020 02:55',
  '10k2020': '23/10/2020 05:59',
  '11t2020': '7/11/2020 06:14',
  '11k2020': '22/11/2020 03:40',
  '12t2020': '6/12/2020 23:09',
  '12k2020': '21/12/2020 17:02',
  '1t2021': '5/1/2021 10:23',
  '1k2021': '20/1/2021 03:40',
  '2t2021': '3/2/2021 21:59',
  '2k2021': '18/2/2021 17:44',
  '3t2021': '5/3/2021 15:53',
  '3k2021': '20/3/2021 16:37',
  '4t2021': '4/4/2021 20:35',
  '4k2021': '20/4/2021 03:33',
  '5t2021': '5/5/2021 13:47',
  '5k2021': '21/5/2021 02:37',
  '6t2021': '5/6/2021 17:52',
  '6k2021': '21/6/2021 10:32',
  '7t2021': '7/7/2021 04:05',
  '7k2021': '22/7/2021 21:26',
  '8t2021': '7/8/2021 13:54',
  '8k2021': '23/8/2021 04:35',
  '9t2021': '7/9/2021 16:53',
  '9k2021': '23/9/2021 02:21',
  '10t2021': '8/10/2021 08:39',
  '10k2021': '23/10/2021 11:51',
  '11t2021': '7/11/2021 11:58',
  '11k2021': '22/11/2021 09:33',
  '12t2021': '7/12/2021 04:57',
  '12k2021': '21/12/2021 22:59',
  '1t2022': '5/1/2022 16:14',
  '1k2022': '20/1/2022 09:39',
  '2t2022': '4/2/2022 03:50',
  '2k2022': '18/2/2022 23:43',
  '3t2022': '5/3/2022 21:43',
  '3k2022': '20/3/2022 22:33',
  '4t2022': '5/4/2022 02:20',
  '4k2022': '20/4/2022 09:24',
  '5t2022': '5/5/2022 19:26',
  '5k2022': '21/5/2022 08:22',
  '6t2022': '5/6/2022 23:26',
  '6k2022': '21/6/2022 16:14',
  '7t2022': '7/7/2022 09:38',
  '7k2022': '23/7/2022 03:07',
  '8t2022': '7/8/2022 19:29',
  '8k2022': '23/8/2022 10:16',
  '9t2022': '7/9/2022 22:32',
  '9k2022': '23/9/2022 08:03',
  '10t2022': '8/10/2022 14:22',
  '10k2022': '23/10/2022 17:35',
  '11t2022': '7/11/2022 17:45',
  '11k2022': '22/11/2022 15:20',
  '12t2022': '7/12/2022 10:46',
  '12k2022': '22/12/2022 04:48',
  '1t2023': '5/1/2023 22:05',
  '1k2023': '20/1/2023 15:29',
  '2t2023': '4/2/2023 09:42',
  '2k2023': '19/2/2023 05:34',
  '3t2023': '6/3/2023 03:36',
  '3k2023': '21/3/2023 04:24',
  '4t2023': '5/4/2023 08:13',
  '4k2023': '20/4/2023 15:13',
  '5t2023': '6/5/2023 01:18',
  '5k2023': '21/5/2023 14:09',
  '6t2023': '6/6/2023 05:18',
  '6k2023': '21/6/2023 21:58',
  '7t2023': '7/7/2023 15:30',
  '7k2023': '23/7/2023 08:50',
  '8t2023': '8/8/2023 01:23',
  '8k2023': '23/8/2023 16:01',
  '9t2023': '8/9/2023 04:26',
  '9k2023': '23/9/2023 13:50',
  '10t2023': '8/10/2023 20:15',
  '10k2023': '23/10/2023 23:21',
  '11t2023': '7/11/2023 23:35',
  '11k2023': '22/11/2023 21:02',
  '12t2023': '7/12/2023 16:33',
  '12k2023': '22/12/2023 10:27',
  '1t2024': '6/1/2024 03:49',
  '1k2024': '20/1/2024 21:07',
  '2t2024': '4/2/2024 15:27',
  '2k2024': '19/2/2024 11:13',
  '3t2024': '5/3/2024 09:22',
  '3k2024': '20/3/2024 10:06',
  '4t2024': '4/4/2024 14:02',
  '4k2024': '19/4/2024 20:59',
  '5t2024': '5/5/2024 07:10',
  '5k2024': '20/5/2024 19:59',
  '6t2024': '5/6/2024 11:10',
  '6k2024': '21/6/2024 03:51',
  '7t2024': '6/7/2024 21:20',
  '7k2024': '22/7/2024 14:44',
  '8t2024': '7/8/2024 07:09',
  '8k2024': '22/8/2024 21:55',
  '9t2024': '7/9/2024 10:11',
  '9k2024': '22/9/2024 19:43',
  '10t2024': '8/10/2024 02:00',
  '10k2024': '23/10/2024 05:14',
  '11t2024': '7/11/2024 05:20',
  '11k2024': '22/11/2024 02:56',
  '12t2024': '6/12/2024 22:17',
  '12k2024': '21/12/2024 16:20',
  '1t2025': '5/1/2025 09:32',
  '1k2025': '20/1/2025 03:00',
  '2t2025': '3/2/2025 21:10',
  '2k2025': '18/2/2025 17:06',
  '3t2025': '5/3/2025 15:07',
  '3k2025': '20/3/2025 16:01',
  '4t2025': '4/4/2025 19:48',
  '4k2025': '20/4/2025 02:56',
  '5t2025': '5/5/2025 12:57',
  '5k2025': '21/5/2025 01:54',
  '6t2025': '5/6/2025 16:56',
  '6k2025': '21/6/2025 09:42',
  '7t2025': '7/7/2025 03:05',
  '7k2025': '22/7/2025 20:29',
  '8t2025': '7/8/2025 12:51',
  '8k2025': '23/8/2025 03:33',
  '9t2025': '7/9/2025 15:52',
  '9k2025': '23/9/2025 01:19',
  '10t2025': '8/10/2025 07:41',
  '10k2025': '23/10/2025 10:51',
  '11t2025': '7/11/2025 11:04',
  '11k2025': '22/11/2025 08:35',
  '12t2025': '7/12/2025 04:04',
  '12k2025': '21/12/2025 22:03',
  '1t2026': '5/1/2026 15:23',
  '1k2026': '20/1/2026 08:45',
  '2t2026': '4/2/2026 03:02',
  '2k2026': '18/2/2026 22:52',
  '3t2026': '5/3/2026 20:59',
  '3k2026': '20/3/2026 21:46',
  '4t2026': '5/4/2026 01:40',
  '4k2026': '20/4/2026 08:39',
  '5t2026': '5/5/2026 18:48',
  '5k2026': '21/5/2026 07:36',
  '6t2026': '5/6/2026 22:48',
  '6k2026': '21/6/2026 15:24',
  '7t2026': '7/7/2026 08:57',
  '7k2026': '23/7/2026 02:13',
  '8t2026': '7/8/2026 18:42',
  '8k2026': '23/8/2026 09:18',
  '9t2026': '7/9/2026 21:41',
  '9k2026': '23/9/2026 07:05',
  '10t2026': '8/10/2026 13:29',
  '10k2026': '23/10/2026 16:38',
  '11t2026': '7/11/2026 16:52',
  '11k2026': '22/11/2026 14:23',
  '12t2026': '7/12/2026 09:52',
  '12k2026': '22/12/2026 03:50',
  '1t2027': '5/1/2027 21:10',
  '1k2027': '20/1/2027 14:29',
  '2t2027': '4/2/2027 08:46',
  '2k2027': '19/2/2027 04:33',
  '3t2027': '6/3/2027 02:39',
  '3k2027': '21/3/2027 03:24',
  '4t2027': '5/4/2027 07:17',
  '4k2027': '20/4/2027 14:17',
  '5t2027': '6/5/2027 00:25',
  '5k2027': '21/5/2027 13:18',
  '6t2027': '6/6/2027 04:25',
  '6k2027': '21/6/2027 21:10',
  '7t2027': '7/7/2027 14:37',
  '7k2027': '23/7/2027 08:04',
  '8t2027': '8/8/2027 00:26',
  '8k2027': '23/8/2027 15:14',
  '9t2027': '8/9/2027 03:28',
  '9k2027': '23/9/2027 13:01',
  '10t2027': '8/10/2027 19:17',
  '10k2027': '23/10/2027 22:32',
  '11t2027': '7/11/2027 22:38',
  '11k2027': '22/11/2027 20:16',
  '12t2027': '7/12/2027 15:37',
  '12k2027': '22/12/2027 09:42',
  '1t2028': '6/1/2028 02:54',
  '1k2028': '20/1/2028 20:21',
  '2t2028': '4/2/2028 14:31',
  '2k2028': '19/2/2028 10:26',
  '3t2028': '5/3/2028 08:24',
  '3k2028': '20/3/2028 09:17',
  '4t2028': '4/4/2028 13:03',
  '4k2028': '19/4/2028 20:09',
  '5t2028': '5/5/2028 06:12',
  '5k2028': '20/5/2028 19:09',
  '6t2028': '5/6/2028 10:16',
  '6k2028': '21/6/2028 03:02',
  '7t2028': '6/7/2028 20:30',
  '7k2028': '22/7/2028 13:54',
  '8t2028': '7/8/2028 06:21',
  '8k2028': '22/8/2028 21:00',
  '9t2028': '7/9/2028 09:22',
  '9k2028': '22/9/2028 18:45',
  '10t2028': '8/10/2028 01:08',
  '10k2028': '23/10/2028 04:13',
  '11t2028': '7/11/2028 04:27',
  '11k2028': '22/11/2028 01:54',
  '12t2028': '6/12/2028 21:24',
  '12k2028': '21/12/2028 15:19',
  '1t2029': '5/1/2029 08:41',
  '1k2029': '20/1/2029 02:00',
  '2t2029': '3/2/2029 20:20',
  '2k2029': '18/2/2029 16:07',
  '3t2029': '5/3/2029 14:17',
  '3k2029': '20/3/2029 15:01',
  '4t2029': '4/4/2029 18:58',
  '4k2029': '20/4/2029 01:55',
  '5t2029': '5/5/2029 12:07',
  '5k2029': '21/5/2029 00:55',
  '6t2029': '5/6/2029 16:09',
  '6k2029': '21/6/2029 08:48',
  '7t2029': '7/7/2029 02:22',
  '7k2029': '22/7/2029 19:42',
  '8t2029': '7/8/2029 12:11',
  '8k2029': '23/8/2029 02:51',
  '9t2029': '7/9/2029 15:11',
  '9k2029': '23/9/2029 00:38',
  '10t2029': '8/10/2029 06:58',
  '10k2029': '23/10/2029 10:08',
  '11t2029': '7/11/2029 10:16',
  '11k2029': '22/11/2029 07:49',
  '12t2029': '7/12/2029 03:13',
  '12k2029': '21/12/2029 21:14',
  '1t2030': '5/1/2030 14:30',
  '1k2030': '20/1/2030 07:54',
  '2t2030': '4/2/2030 02:08',
  '2k2030': '18/2/2030 21:59',
  '3t2030': '5/3/2030 20:03',
  '3k2030': '20/3/2030 20:52',
  '4t2030': '5/4/2030 00:40',
  '4k2030': '20/4/2030 07:43',
  '5t2030': '5/5/2030 17:46',
  '5k2030': '21/5/2030 06:41',
  '6t2030': '5/6/2030 21:44',
  '6k2030': '21/6/2030 14:31',
  '7t2030': '7/7/2030 07:55',
  '7k2030': '23/7/2030 01:24',
  '8t2030': '7/8/2030 17:47',
  '8k2030': '23/8/2030 08:36',
  '9t2030': '7/9/2030 20:52',
  '9k2030': '23/9/2030 06:26',
  '10t2030': '8/10/2030 12:45',
  '10k2030': '23/10/2030 16:00',
  '11t2030': '7/11/2030 16:08',
  '11k2030': '22/11/2030 13:44',
  '12t2030': '7/12/2030 09:07',
  '12k2030': '22/12/2030 03:09',
  '1t2031': '5/1/2031 20:23',
  '1k2031': '20/1/2031 13:47',
  '2t2031': '4/2/2031 07:58',
  '2k2031': '19/2/2031 03:50',
  '3t2031': '6/3/2031 01:50',
  '3k2031': '21/3/2031 02:40',
  '4t2031': '5/4/2031 06:28',
  '4k2031': '20/4/2031 13:31',
  '5t2031': '5/5/2031 23:35',
  '5k2031': '21/5/2031 12:27',
  '6t2031': '6/6/2031 03:35',
  '6k2031': '21/6/2031 20:17',
  '7t2031': '7/7/2031 13:48',
  '7k2031': '23/7/2031 07:10',
  '8t2031': '7/8/2031 23:42',
  '8k2031': '23/8/2031 14:23',
  '9t2031': '8/9/2031 02:50',
  '9k2031': '23/9/2031 12:15',
  '10t2031': '8/10/2031 18:42',
  '10k2031': '23/10/2031 21:49',
  '11t2031': '7/11/2031 22:05',
  '11k2031': '22/11/2031 19:32',
  '12t2031': '7/12/2031 15:02',
  '12k2031': '22/12/2031 08:55',
  '1t2032': '6/1/2032 02:16',
  '1k2032': '20/1/2032 19:31',
  '2t2032': '4/2/2032 13:48',
  '2k2032': '19/2/2032 09:32',
  '3t2032': '5/3/2032 07:40',
  '3k2032': '20/3/2032 08:21',
  '4t2032': '4/4/2032 12:17',
  '4k2032': '19/4/2032 19:14',
  '5t2032': '5/5/2032 05:25',
  '5k2032': '20/5/2032 18:14',
  '6t2032': '5/6/2032 09:27',
  '6k2032': '21/6/2032 02:08',
  '7t2032': '6/7/2032 19:40',
  '7k2032': '22/7/2032 13:04',
  '8t2032': '7/8/2032 05:32',
  '8k2032': '22/8/2032 20:18',
  '9t2032': '7/9/2032 08:37',
  '9k2032': '22/9/2032 18:10',
  '10t2032': '8/10/2032 00:30',
  '10k2032': '23/10/2032 03:46',
  '11t2032': '7/11/2032 03:54',
  '11k2032': '22/11/2032 01:31',
  '12t2032': '6/12/2032 20:53',
  '12k2032': '21/12/2032 14:55',
  '1t2033': '5/1/2033 08:08',
  '1k2033': '20/1/2033 01:32',
  '2t2033': '3/2/2033 19:41',
  '2k2033': '18/2/2033 15:33',
  '3t2033': '5/3/2033 13:32',
  '3k2033': '20/3/2033 14:22',
  '4t2033': '4/4/2033 18:08',
  '4k2033': '20/4/2033 01:13',
  '5t2033': '5/5/2033 11:13',
  '5k2033': '21/5/2033 00:10',
  '6t2033': '5/6/2033 15:13',
  '6k2033': '21/6/2033 08:01',
  '7t2033': '7/7/2033 01:24',
  '7k2033': '22/7/2033 18:52',
  '8t2033': '7/8/2033 11:15',
  '8k2033': '23/8/2033 02:01',
  '9t2033': '7/9/2033 14:20',
  '9k2033': '22/9/2033 23:51',
  '10t2033': '8/10/2033 06:13',
  '10k2033': '23/10/2033 09:27',
  '11t2033': '7/11/2033 09:40',
  '11k2033': '22/11/2033 07:16',
  '12t2033': '7/12/2033 02:44',
  '12k2033': '21/12/2033 20:45',
  '1t2034': '5/1/2034 14:04',
  '1k2034': '20/1/2034 07:27',
  '2t2034': '4/2/2034 01:41',
  '2k2034': '18/2/2034 21:30',
  '3t2034': '5/3/2034 19:32',
  '3k2034': '20/3/2034 20:17',
  '4t2034': '5/4/2034 00:06',
  '4k2034': '20/4/2034 07:03',
  '5t2034': '5/5/2034 17:09',
  '5k2034': '21/5/2034 05:56',
  '6t2034': '5/6/2034 21:06',
  '6k2034': '21/6/2034 13:44',
  '7t2034': '7/7/2034 07:17',
  '7k2034': '23/7/2034 00:36',
  '8t2034': '7/8/2034 17:08',
  '8k2034': '23/8/2034 07:47',
  '9t2034': '7/9/2034 20:13',
  '9k2034': '23/9/2034 05:39',
  '10t2034': '8/10/2034 12:06',
  '10k2034': '23/10/2034 15:16',
  '11t2034': '7/11/2034 15:33',
  '11k2034': '22/11/2034 13:04',
  '12t2034': '7/12/2034 08:36',
  '12k2034': '22/12/2034 02:33',
  '1t2035': '5/1/2035 19:55',
  '1k2035': '20/1/2035 13:14',
  '2t2035': '4/2/2035 07:31',
  '2k2035': '19/2/2035 03:16',
  '3t2035': '6/3/2035 01:21',
  '3k2035': '21/3/2035 02:02',
  '4t2035': '5/4/2035 05:53',
  '4k2035': '20/4/2035 12:48',
  '5t2035': '5/5/2035 22:54',
  '5k2035': '21/5/2035 11:43',
  '6t2035': '6/6/2035 02:50',
  '6k2035': '21/6/2035 19:32',
  '7t2035': '7/7/2035 13:00',
  '7k2035': '23/7/2035 06:28',
  '8t2035': '7/8/2035 22:54',
  '8k2035': '23/8/2035 13:43',
  '9t2035': '8/9/2035 02:02',
  '9k2035': '23/9/2035 11:38',
  '10t2035': '8/10/2035 17:57',
  '10k2035': '23/10/2035 21:16',
  '11t2035': '7/11/2035 21:23',
  '11k2035': '22/11/2035 19:03',
  '12t2035': '7/12/2035 14:25',
  '12k2035': '22/12/2035 08:30',
  '1t2036': '6/1/2036 01:43',
  '1k2036': '20/1/2036 19:10',
  '2t2036': '4/2/2036 13:19',
  '2k2036': '19/2/2036 09:14',
  '3t2036': '5/3/2036 07:11',
  '3k2036': '20/3/2036 08:02',
  '4t2036': '4/4/2036 11:46',
  '4k2036': '19/4/2036 18:50',
  '5t2036': '5/5/2036 04:49',
  '5k2036': '20/5/2036 17:44',
  '6t2036': '5/6/2036 08:46',
  '6k2036': '21/6/2036 01:32',
  '7t2036': '6/7/2036 18:57',
  '7k2036': '22/7/2036 12:22',
  '8t2036': '7/8/2036 04:48',
  '8k2036': '22/8/2036 19:32',
  '9t2036': '7/9/2036 07:54',
  '9k2036': '22/9/2036 17:23',
  '10t2036': '7/10/2036 23:48',
  '10k2036': '23/10/2036 02:58',
  '11t2036': '7/11/2036 03:14',
  '11k2036': '22/11/2036 00:45',
  '12t2036': '6/12/2036 20:15',
  '12k2036': '21/12/2036 14:12',
  '1t2037': '5/1/2037 07:33',
  '1k2037': '20/1/2037 00:53',
  '2t2037': '3/2/2037 19:11',
  '2k2037': '18/2/2037 14:58',
  '3t2037': '5/3/2037 13:05',
  '3k2037': '20/3/2037 13:50',
  '4t2037': '4/4/2037 17:43',
  '4k2037': '20/4/2037 00:40',
  '5t2037': '5/5/2037 10:49',
  '5k2037': '20/5/2037 23:35',
  '6t2037': '5/6/2037 14:46',
  '6k2037': '21/6/2037 07:22',
  '7t2037': '7/7/2037 00:54',
  '7k2037': '22/7/2037 18:12',
  '8t2037': '7/8/2037 10:42',
  '8k2037': '23/8/2037 01:21',
  '9t2037': '7/9/2037 13:45',
  '9k2037': '22/9/2037 23:12',
  '10t2037': '8/10/2037 05:37',
  '10k2037': '23/10/2037 08:49',
  '11t2037': '7/11/2037 09:03',
  '11k2037': '22/11/2037 06:38',
  '12t2037': '7/12/2037 02:07',
  '12k2037': '21/12/2037 20:07',
  '1t2038': '5/1/2038 13:26',
  '1k2038': '20/1/2038 06:48',
  '2t2038': '4/2/2038 01:03',
  '2k2038': '18/2/2038 20:51',
  '3t2038': '5/3/2038 18:55',
  '3k2038': '20/3/2038 19:40',
  '4t2038': '4/4/2038 23:29',
  '4k2038': '20/4/2038 06:28',
  '5t2038': '5/5/2038 16:30',
  '5k2038': '21/5/2038 05:22',
  '6t2038': '5/6/2038 20:25',
  '6k2038': '21/6/2038 13:09',
  '7t2038': '7/7/2038 06:32',
  '7k2038': '22/7/2038 23:59',
  '8t2038': '7/8/2038 16:21',
  '8k2038': '23/8/2038 07:09',
  '9t2038': '7/9/2038 19:26',
  '9k2038': '23/9/2038 05:02',
  '10t2038': '8/10/2038 11:21',
  '10k2038': '23/10/2038 14:40',
  '11t2038': '7/11/2038 14:50',
  '11k2038': '22/11/2038 12:31',
  '12t2038': '7/12/2038 07:56',
  '12k2038': '22/12/2038 02:02',
  '1t2039': '5/1/2039 19:16',
  '1k2039': '20/1/2039 12:43',
  '2t2039': '4/2/2039 06:52',
  '2k2039': '19/2/2039 02:45',
  '3t2039': '6/3/2039 00:42',
  '3k2039': '21/3/2039 01:31',
  '4t2039': '5/4/2039 05:15',
  '4k2039': '20/4/2039 12:17',
  '5t2039': '5/5/2039 22:17',
  '5k2039': '21/5/2039 11:10',
  '6t2039': '6/6/2039 02:15',
  '6k2039': '21/6/2039 18:57',
  '7t2039': '7/7/2039 12:25',
  '7k2039': '23/7/2039 05:47',
  '8t2039': '7/8/2039 22:17',
  '8k2039': '23/8/2039 12:58',
  '9t2039': '8/9/2039 01:23',
  '9k2039': '23/9/2039 10:49',
  '10t2039': '8/10/2039 17:17',
  '10k2039': '23/10/2039 20:24',
  '11t2039': '7/11/2039 20:42',
  '11k2039': '22/11/2039 18:11',
  '12t2039': '7/12/2039 13:44',
  '12k2039': '22/12/2039 07:40',
  '1t2040': '6/1/2040 01:03',
  '1k2040': '20/1/2040 18:20',
  '2t2040': '4/2/2040 12:39',
  '2k2040': '19/2/2040 08:23',
  '3t2040': '5/3/2040 06:30',
  '3k2040': '20/3/2040 07:11',
  '4t2040': '4/4/2040 11:05',
  '4k2040': '19/4/2040 17:59',
  '5t2040': '5/5/2040 04:09',
  '5k2040': '20/5/2040 16:55',
  '6t2040': '5/6/2040 08:07',
  '6k2040': '21/6/2040 00:46',
  '7t2040': '6/7/2040 18:18',
  '7k2040': '22/7/2040 11:40',
  '8t2040': '7/8/2040 04:09',
  '8k2040': '22/8/2040 18:53',
  '9t2040': '7/9/2040 07:13',
  '9k2040': '22/9/2040 16:44',
  '10t2040': '7/10/2040 23:05',
  '10k2040': '23/10/2040 02:19',
  '11t2040': '7/11/2040 02:29',
  '11k2040': '22/11/2040 00:05',
  '12t2040': '6/12/2040 19:29',
  '12k2040': '21/12/2040 13:32',
  '1t2041': '5/1/2041 06:47',
  '1k2041': '20/1/2041 00:13',
  '2t2041': '3/2/2041 18:24',
  '2k2041': '18/2/2041 14:16',
  '3t2041': '5/3/2041 12:17',
  '3k2041': '20/3/2041 13:06',
  '4t2041': '4/4/2041 16:52',
  '4k2041': '19/4/2041 23:54',
  '5t2041': '5/5/2041 09:54',
  '5k2041': '20/5/2041 22:48',
  '6t2041': '5/6/2041 13:49',
  '6k2041': '21/6/2041 06:35',
  '7t2041': '6/7/2041 23:58',
  '7k2041': '22/7/2041 17:26',
  '8t2041': '7/8/2041 09:48',
  '8k2041': '23/8/2041 00:35',
  '9t2041': '7/9/2041 12:53',
  '9k2041': '22/9/2041 22:26',
  '10t2041': '8/10/2041 04:46',
  '10k2041': '23/10/2041 08:01',
  '11t2041': '7/11/2041 08:12',
  '11k2041': '22/11/2041 05:48',
  '12t2041': '7/12/2041 01:15',
  '12k2041': '21/12/2041 19:18',
  '1t2042': '5/1/2042 12:34',
  '1k2042': '20/1/2042 05:59',
  '2t2042': '4/2/2042 00:12',
  '2k2042': '18/2/2042 20:04',
  '3t2042': '5/3/2042 18:05',
  '3k2042': '20/3/2042 18:52',
  '4t2042': '4/4/2042 22:40',
  '4k2042': '20/4/2042 05:39',
  '5t2042': '5/5/2042 15:42',
  '5k2042': '21/5/2042 04:30',
  '6t2042': '5/6/2042 19:37',
  '6k2042': '21/6/2042 12:15',
  '7t2042': '7/7/2042 05:46',
  '7k2042': '22/7/2042 23:05',
  '8t2042': '7/8/2042 15:38',
  '8k2042': '23/8/2042 06:17',
  '9t2042': '7/9/2042 18:45',
  '9k2042': '23/9/2042 04:11',
  '10t2042': '8/10/2042 10:40',
  '10k2042': '23/10/2042 13:49',
  '11t2042': '7/11/2042 14:07',
  '11k2042': '22/11/2042 11:37',
  '12t2042': '7/12/2042 07:08',
  '12k2042': '22/12/2042 01:03',
  '1t2043': '5/1/2043 18:25',
  '1k2043': '20/1/2043 11:41',
  '2t2043': '4/2/2043 05:58',
  '2k2043': '19/2/2043 01:41',
  '3t2043': '5/3/2043 23:47',
  '3k2043': '21/3/2043 00:27',
  '4t2043': '5/4/2043 04:19',
  '4k2043': '20/4/2043 11:14',
  '5t2043': '5/5/2043 21:21',
  '5k2043': '21/5/2043 10:08',
  '6t2043': '6/6/2043 01:17',
  '6k2043': '21/6/2043 17:58',
  '7t2043': '7/7/2043 11:27',
  '7k2043': '23/7/2043 04:53',
  '8t2043': '7/8/2043 21:20',
  '8k2043': '23/8/2043 12:09',
  '9t2043': '8/9/2043 00:29',
  '9k2043': '23/9/2043 10:06',
  '10t2043': '8/10/2043 16:27',
  '10k2043': '23/10/2043 19:46',
  '11t2043': '7/11/2043 19:55',
  '11k2043': '22/11/2043 17:34',
  '12t2043': '7/12/2043 12:57',
  '12k2043': '22/12/2043 07:00',
  '1t2044': '6/1/2044 00:12',
  '1k2044': '20/1/2044 17:37',
  '2t2044': '4/2/2044 11:43',
  '2k2044': '19/2/2044 07:35',
  '3t2044': '5/3/2044 05:31',
  '3k2044': '20/3/2044 06:20',
  '4t2044': '4/4/2044 10:02',
  '4k2044': '19/4/2044 17:06',
  '5t2044': '5/5/2044 03:05',
  '5k2044': '20/5/2044 16:01',
  '6t2044': '5/6/2044 07:03',
  '6k2044': '20/6/2044 23:50',
  '7t2044': '6/7/2044 17:15',
  '7k2044': '22/7/2044 10:42',
  '8t2044': '7/8/2044 03:08',
  '8k2044': '22/8/2044 17:54',
  '9t2044': '7/9/2044 06:16',
  '9k2044': '22/9/2044 15:47',
  '10t2044': '7/10/2044 22:12',
  '10k2044': '23/10/2044 01:25',
  '11t2044': '7/11/2044 01:41',
  '11k2044': '21/11/2044 23:14',
  '12t2044': '6/12/2044 18:44',
  '12k2044': '21/12/2044 12:43',
  '1t2045': '5/1/2045 06:02',
  '1k2045': '19/1/2045 23:21',
  '2t2045': '3/2/2045 17:35',
  '2k2045': '18/2/2045 13:21',
  '3t2045': '5/3/2045 11:24',
  '3k2045': '20/3/2045 12:07',
  '4t2045': '4/4/2045 15:56',
  '4k2045': '19/4/2045 22:52',
  '5t2045': '5/5/2045 08:59',
  '5k2045': '20/5/2045 21:45',
  '6t2045': '5/6/2045 12:56',
  '6k2045': '21/6/2045 05:33',
  '7t2045': '6/7/2045 23:07',
  '7k2045': '22/7/2045 16:26',
  '8t2045': '7/8/2045 08:59',
  '8k2045': '22/8/2045 23:38',
  '9t2045': '7/9/2045 12:05',
  '9k2045': '22/9/2045 21:32',
  '10t2045': '8/10/2045 04:00',
  '10k2045': '23/10/2045 07:12',
  '11t2045': '7/11/2045 07:29',
  '11k2045': '22/11/2045 05:03',
  '12t2045': '7/12/2045 00:35',
  '12k2045': '21/12/2045 18:34',
  '1t2046': '5/1/2046 11:55',
  '1k2046': '20/1/2046 05:15',
  '2t2046': '3/2/2046 23:30',
  '2k2046': '18/2/2046 19:15',
  '3t2046': '5/3/2046 17:17',
  '3k2046': '20/3/2046 17:57',
  '4t2046': '4/4/2046 21:44',
  '4k2046': '20/4/2046 04:38',
  '5t2046': '5/5/2046 14:40',
  '5k2046': '21/5/2046 03:28',
  '6t2046': '5/6/2046 18:31',
  '6k2046': '21/6/2046 11:14',
  '7t2046': '7/7/2046 04:39',
  '7k2046': '22/7/2046 22:08',
  '8t2046': '7/8/2046 14:32',
  '8k2046': '23/8/2046 05:24',
  '9t2046': '7/9/2046 17:42',
  '9k2046': '23/9/2046 03:21',
  '10t2046': '8/10/2046 09:41',
  '10k2046': '23/10/2046 13:03',
  '11t2046': '7/11/2046 13:13',
  '11k2046': '22/11/2046 10:55',
  '12t2046': '7/12/2046 06:20',
  '12k2046': '22/12/2046 00:28',
  '1t2047': '5/1/2047 17:41',
  '1k2047': '20/1/2047 11:09',
  '2t2047': '4/2/2047 05:17',
  '2k2047': '19/2/2047 01:09',
  '3t2047': '5/3/2047 23:04',
  '3k2047': '20/3/2047 23:52',
  '4t2047': '5/4/2047 03:32',
  '4k2047': '20/4/2047 10:32',
  '5t2047': '5/5/2047 20:28',
  '5k2047': '21/5/2047 09:19',
  '6t2047': '6/6/2047 00:20',
  '6k2047': '21/6/2047 17:03',
  '7t2047': '7/7/2047 10:30',
  '7k2047': '23/7/2047 03:55',
  '8t2047': '7/8/2047 20:25',
  '8k2047': '23/8/2047 11:10',
  '9t2047': '7/9/2047 23:37',
  '9k2047': '23/9/2047 09:07',
  '10t2047': '8/10/2047 15:37',
  '10k2047': '23/10/2047 18:48',
  '11t2047': '7/11/2047 19:06',
  '11k2047': '22/11/2047 16:37',
  '12t2047': '7/12/2047 12:10',
  '12k2047': '22/12/2047 06:06',
  '1t2048': '5/1/2048 23:28',
  '1k2048': '20/1/2048 16:46',
  '2t2048': '4/2/2048 11:04',
  '2k2048': '19/2/2048 06:48',
  '3t2048': '5/3/2048 04:53',
  '3k2048': '20/3/2048 05:33',
  '4t2048': '4/4/2048 09:24',
  '4k2048': '19/4/2048 16:17',
  '5t2048': '5/5/2048 02:24',
  '5k2048': '20/5/2048 15:07',
  '6t2048': '5/6/2048 06:17',
  '6k2048': '20/6/2048 22:53',
  '7t2048': '6/7/2048 16:26',
  '7k2048': '22/7/2048 09:46',
  '8t2048': '7/8/2048 02:18',
  '8k2048': '22/8/2048 17:02',
  '9t2048': '7/9/2048 05:27',
  '9k2048': '22/9/2048 15:00',
  '10t2048': '7/10/2048 21:26',
  '10k2048': '23/10/2048 00:42',
  '11t2048': '7/11/2048 00:56',
  '11k2048': '21/11/2048 22:33',
  '12t2048': '6/12/2048 18:00',
  '12k2048': '21/12/2048 12:01',
  '1t2049': '5/1/2049 05:18',
  '1k2049': '19/1/2049 22:40',
  '2t2049': '3/2/2049 16:52',
  '2k2049': '18/2/2049 12:41',
  '3t2049': '5/3/2049 10:42',
  '3k2049': '20/3/2049 11:28',
  '4t2049': '4/4/2049 15:13',
  '4k2049': '19/4/2049 22:13',
  '5t2049': '5/5/2049 08:12',
  '5k2049': '20/5/2049 21:03',
  '6t2049': '5/6/2049 12:03',
  '6k2049': '21/6/2049 04:46',
  '7t2049': '6/7/2049 22:08',
  '7k2049': '22/7/2049 15:35',
  '8t2049': '7/8/2049 07:57',
  '8k2049': '22/8/2049 22:46',
  '9t2049': '7/9/2049 11:05',
  '9k2049': '22/9/2049 20:42',
  '10t2049': '8/10/2049 03:04',
  '10k2049': '23/10/2049 06:24',
  '11t2049': '7/11/2049 06:37',
  '11k2049': '22/11/2049 04:18',
  '12t2049': '6/12/2049 23:46',
  '12k2049': '21/12/2049 17:51',
  '1t2050': '5/1/2050 11:07',
  '1k2050': '20/1/2050 04:33',
  '2t2050': '3/2/2050 22:43',
  '2k2050': '18/2/2050 18:34',
  '3t2050': '5/3/2050 16:32',
  '3k2050': '20/3/2050 17:19',
  '4t2050': '4/4/2050 21:02',
  '4k2050': '20/4/2050 04:01',
  '5t2050': '5/5/2050 14:01',
  '5k2050': '21/5/2050 02:50',
  '6t2050': '5/6/2050 17:54',
  '6k2050': '21/6/2050 10:32',
  '7t2050': '7/7/2050 04:01',
  '7k2050': '22/7/2050 21:20',
  '8t2050': '7/8/2050 13:52',
  '8k2050': '23/8/2050 04:32',
  '9t2050': '7/9/2050 17:00',
  '9k2050': '23/9/2050 02:28',
  '10t2050': '8/10/2050 08:59',
  '10k2050': '23/10/2050 12:11',
  '11t2050': '7/11/2050 12:33',
  '11k2050': '22/11/2050 10:05',
  '12t2050': '7/12/2050 05:41',
  '12k2050': '21/12/2050 23:38',
  '1t2051': '5/1/2051 17:01',
  '1k2051': '20/1/2051 10:18',
  '2t2051': '4/2/2051 04:35',
  '2k2051': '19/2/2051 00:16',
  '3t2051': '5/3/2051 22:21',
  '3k2051': '20/3/2051 22:58',
  '4t2051': '5/4/2051 02:49',
  '4k2051': '20/4/2051 09:40',
  '5t2051': '5/5/2051 19:46',
  '5k2051': '21/5/2051 08:30',
  '6t2051': '5/6/2051 23:40',
  '6k2051': '21/6/2051 16:18',
  '7t2051': '7/7/2051 09:49',
  '7k2051': '23/7/2051 03:12',
  '8t2051': '7/8/2051 19:41',
  '8k2051': '23/8/2051 10:28',
  '9t2051': '7/9/2051 22:50',
  '9k2051': '23/9/2051 08:26',
  '10t2051': '8/10/2051 14:49',
  '10k2051': '23/10/2051 18:09',
  '11t2051': '7/11/2051 18:21',
  '11k2051': '22/11/2051 16:02',
  '12t2051': '7/12/2051 11:28',
  '12k2051': '22/12/2051 05:33',
  '1t2052': '5/1/2052 22:48',
  '1k2052': '20/1/2052 16:13',
  '2t2052': '4/2/2052 10:22',
  '2k2052': '19/2/2052 06:13',
  '3t2052': '5/3/2052 04:09',
  '3k2052': '20/3/2052 04:55',
  '4t2052': '4/4/2052 08:36',
  '4k2052': '19/4/2052 15:37',
  '5t2052': '5/5/2052 01:34',
  '5k2052': '20/5/2052 14:28',
  '6t2052': '5/6/2052 05:29',
  '6k2052': '20/6/2052 22:15',
  '7t2052': '6/7/2052 15:39',
  '7k2052': '22/7/2052 09:08',
  '8t2052': '7/8/2052 01:32',
  '8k2052': '22/8/2052 16:21',
  '9t2052': '7/9/2052 04:41',
  '9k2052': '22/9/2052 14:15',
  '10t2052': '7/10/2052 20:39',
  '10k2052': '22/10/2052 23:54',
  '11t2052': '7/11/2052 00:09',
  '11k2052': '21/11/2052 21:45',
  '12t2052': '6/12/2052 17:15',
  '12k2052': '21/12/2052 11:16',
  '1t2053': '5/1/2053 04:35',
  '1k2053': '19/1/2053 21:58',
  '2t2053': '3/2/2053 16:12',
  '2k2053': '18/2/2053 12:01',
  '3t2053': '5/3/2053 10:02',
  '3k2053': '20/3/2053 10:46',
  '4t2053': '4/4/2053 14:34',
  '4k2053': '19/4/2053 21:29',
  '5t2053': '5/5/2053 07:33',
  '5k2053': '20/5/2053 20:19',
  '6t2053': '5/6/2053 11:27',
  '6k2053': '21/6/2053 04:03',
  '7t2053': '6/7/2053 21:36',
  '7k2053': '22/7/2053 14:55',
  '8t2053': '7/8/2053 07:29',
  '8k2053': '22/8/2053 22:09',
  '9t2053': '7/9/2053 10:38',
  '9k2053': '22/9/2053 20:05',
  '10t2053': '8/10/2053 02:35',
  '10k2053': '23/10/2053 05:46',
  '11t2053': '7/11/2053 06:05',
  '11k2053': '22/11/2053 03:38',
  '12t2053': '6/12/2053 23:11',
  '12k2053': '21/12/2053 17:09',
  '1t2054': '5/1/2054 10:31',
  '1k2054': '20/1/2054 03:50',
  '2t2054': '3/2/2054 22:07',
  '2k2054': '18/2/2054 17:51',
  '3t2054': '5/3/2054 15:55',
  '3k2054': '20/3/2054 16:34',
  '4t2054': '4/4/2054 20:22',
  '4k2054': '20/4/2054 03:14',
  '5t2054': '5/5/2054 13:17',
  '5k2054': '21/5/2054 02:02',
  '6t2054': '5/6/2054 17:07',
  '6k2054': '21/6/2054 09:46',
  '7t2054': '7/7/2054 03:13',
  '7k2054': '22/7/2054 20:40',
  '8t2054': '7/8/2054 13:06',
  '8k2054': '23/8/2054 03:57',
  '9t2054': '7/9/2054 16:19',
  '9k2054': '23/9/2054 01:59',
  '10t2054': '8/10/2054 08:21',
  '10k2054': '23/10/2054 11:44',
  '11t2054': '7/11/2054 11:55',
  '11k2054': '22/11/2054 09:38',
  '12t2054': '7/12/2054 05:02',
  '12k2054': '21/12/2054 23:09',
  '1t2055': '5/1/2055 16:22',
  '1k2055': '20/1/2055 09:48',
  '2t2055': '4/2/2055 03:55',
  '2k2055': '18/2/2055 23:46',
  '3t2055': '5/3/2055 21:40',
  '3k2055': '20/3/2055 22:28',
  '4t2055': '5/4/2055 02:07',
  '4k2055': '20/4/2055 09:08',
  '5t2055': '5/5/2055 19:03',
  '5k2055': '21/5/2055 07:55',
  '6t2055': '5/6/2055 22:55',
  '6k2055': '21/6/2055 15:39',
  '7t2055': '7/7/2055 09:04',
  '7k2055': '23/7/2055 02:31',
  '8t2055': '7/8/2055 19:00',
  '8k2055': '23/8/2055 09:48',
  '9t2055': '7/9/2055 22:15',
  '9k2055': '23/9/2055 07:48',
  '10t2055': '8/10/2055 14:18',
  '10k2055': '23/10/2055 17:32',
  '11t2055': '7/11/2055 17:52',
  '11k2055': '22/11/2055 15:25',
  '12t2055': '7/12/2055 10:57',
  '12k2055': '22/12/2055 04:55',
  '1t2056': '5/1/2056 22:15',
  '1k2056': '20/1/2056 15:32',
  '2t2056': '4/2/2056 09:46',
  '2k2056': '19/2/2056 05:29',
  '3t2056': '5/3/2056 03:31',
  '3k2056': '20/3/2056 04:10',
  '4t2056': '4/4/2056 07:59',
  '4k2056': '19/4/2056 14:51',
  '5t2056': '5/5/2056 00:57',
  '5k2056': '20/5/2056 13:41',
  '6t2056': '5/6/2056 04:51',
  '6k2056': '20/6/2056 21:27',
  '7t2056': '6/7/2056 15:01',
  '7k2056': '22/7/2056 08:21',
  '8t2056': '7/8/2056 00:55',
  '8k2056': '22/8/2056 15:38',
  '9t2056': '7/9/2056 04:06',
  '9k2056': '22/9/2056 13:39',
  '10t2056': '7/10/2056 20:08',
  '10k2056': '22/10/2056 23:24',
  '11t2056': '6/11/2056 23:42',
  '11k2056': '21/11/2056 21:19',
  '12t2056': '6/12/2056 16:50',
  '12k2056': '21/12/2056 10:51',
  '1t2057': '5/1/2057 04:09',
  '1k2057': '19/1/2057 21:29',
  '2t2057': '3/2/2057 15:42',
  '2k2057': '18/2/2057 11:26',
  '3t2057': '5/3/2057 09:26',
  '3k2057': '20/3/2057 10:07',
  '4t2057': '4/4/2057 13:52',
  '4k2057': '19/4/2057 20:47',
  '5t2057': '5/5/2057 06:46',
  '5k2057': '20/5/2057 19:34',
  '6t2057': '5/6/2057 10:35',
  '6k2057': '21/6/2057 03:18',
  '7t2057': '6/7/2057 20:41',
  '7k2057': '22/7/2057 14:10',
  '8t2057': '7/8/2057 06:33',
  '8k2057': '22/8/2057 21:24',
  '9t2057': '7/9/2057 09:43',
  '9k2057': '22/9/2057 19:22',
  '10t2057': '8/10/2057 01:45',
  '10k2057': '23/10/2057 05:08',
  '11t2057': '7/11/2057 05:22',
  '11k2057': '22/11/2057 03:06',
  '12t2057': '6/12/2057 22:34',
  '12k2057': '21/12/2057 16:42',
  '1t2058': '5/1/2058 09:58',
  '1k2058': '20/1/2058 03:25',
  '2t2058': '3/2/2058 21:34',
  '2k2058': '18/2/2058 17:25',
  '3t2058': '5/3/2058 15:19',
  '3k2058': '20/3/2058 16:04',
  '4t2058': '4/4/2058 19:43',
  '4k2058': '20/4/2058 02:40',
  '5t2058': '5/5/2058 12:35',
  '5k2058': '21/5/2058 01:23',
  '6t2058': '5/6/2058 16:24',
  '6k2058': '21/6/2058 09:03',
  '7t2058': '7/7/2058 02:31',
  '7k2058': '22/7/2058 19:53',
  '8t2058': '7/8/2058 12:24',
  '8k2058': '23/8/2058 03:08',
  '9t2058': '7/9/2058 15:37',
  '9k2058': '23/9/2058 01:07',
  '10t2058': '8/10/2058 07:40',
  '10k2058': '23/10/2058 10:53',
  '11t2058': '7/11/2058 11:16',
  '11k2058': '22/11/2058 08:50',
  '12t2058': '7/12/2058 04:26',
  '12k2058': '21/12/2058 22:24',
  '1t2059': '5/1/2059 15:48',
  '1k2059': '20/1/2059 09:06',
  '2t2059': '4/2/2059 03:23',
  '2k2059': '18/2/2059 23:04',
  '3t2059': '5/3/2059 21:08',
  '3k2059': '20/3/2059 21:43',
  '4t2059': '5/4/2059 01:31',
  '4k2059': '20/4/2059 08:19',
  '5t2059': '5/5/2059 18:23',
  '5k2059': '21/5/2059 07:04',
  '6t2059': '5/6/2059 22:11',
  '6k2059': '21/6/2059 14:46',
  '7t2059': '7/7/2059 08:18',
  '7k2059': '23/7/2059 01:40',
  '8t2059': '7/8/2059 18:12',
  '8k2059': '23/8/2059 08:59',
  '9t2059': '7/9/2059 21:26',
  '9k2059': '23/9/2059 07:03',
  '10t2059': '8/10/2059 13:30',
  '10k2059': '23/10/2059 16:50',
  '11t2059': '7/11/2059 17:05',
  '11k2059': '22/11/2059 14:45',
  '12t2059': '7/12/2059 10:13',
  '12k2059': '22/12/2059 04:17',
  '1t2060': '5/1/2060 21:33',
  '1k2060': '20/1/2060 14:57',
  '2t2060': '4/2/2060 09:07',
  '2k2060': '19/2/2060 04:56',
  '3t2060': '5/3/2060 02:53',
  '3k2060': '20/3/2060 03:38',
  '4t2060': '4/4/2060 07:19',
  '4k2060': '19/4/2060 14:16',
  '5t2060': '5/5/2060 00:12',
  '5k2060': '20/5/2060 13:03',
  '6t2060': '5/6/2060 04:01',
  '6k2060': '20/6/2060 20:45',
  '7t2060': '6/7/2060 14:06',
  '7k2060': '22/7/2060 07:35',
  '8t2060': '6/8/2060 23:58',
  '8k2060': '22/8/2060 14:49',
  '9t2060': '7/9/2060 03:10',
  '9k2060': '22/9/2060 12:47',
  '10t2060': '7/10/2060 19:13',
  '10k2060': '22/10/2060 22:32',
  '11t2060': '6/11/2060 22:48',
  '11k2060': '21/11/2060 20:28',
  '12t2060': '6/12/2060 15:57',
  '12k2060': '21/12/2060 10:00',
  '1t2061': '5/1/2061 03:17',
  '1k2061': '19/1/2061 20:42',
  '2t2061': '3/2/2061 14:53',
  '2k2061': '18/2/2061 10:42',
  '3t2061': '5/3/2061 08:41',
  '3k2061': '20/3/2061 09:25',
  '4t2061': '4/4/2061 13:09',
  '4k2061': '19/4/2061 20:06',
  '5t2061': '5/5/2061 06:06',
  '5k2061': '20/5/2061 18:51',
  '6t2061': '5/6/2061 09:56',
  '6k2061': '21/6/2061 02:31',
  '7t2061': '6/7/2061 20:01',
  '7k2061': '22/7/2061 13:19',
  '8t2061': '7/8/2061 05:52',
  '8k2061': '22/8/2061 20:32',
  '9t2061': '7/9/2061 09:02',
  '9k2061': '22/9/2061 18:30',
  '10t2061': '8/10/2061 01:03',
  '10k2061': '23/10/2061 04:16',
  '11t2061': '7/11/2061 04:39',
  '11k2061': '22/11/2061 02:13',
  '12t2061': '6/12/2061 21:49',
  '12k2061': '21/12/2061 15:48',
  '1t2062': '5/1/2062 09:12',
  '1k2062': '20/1/2062 02:29',
  '2t2062': '3/2/2062 20:46',
  '2k2062': '18/2/2062 16:27',
  '3t2062': '5/3/2062 14:30',
  '3k2062': '20/3/2062 15:07',
  '4t2062': '4/4/2062 18:54',
  '4k2062': '20/4/2062 01:44',
  '5t2062': '5/5/2062 11:46',
  '5k2062': '21/5/2062 00:29',
  '6t2062': '5/6/2062 15:34',
  '6k2062': '21/6/2062 08:10',
  '7t2062': '7/7/2062 01:37',
  '7k2062': '22/7/2062 19:01',
  '8t2062': '7/8/2062 11:28',
  '8k2062': '23/8/2062 02:17',
  '9t2062': '7/9/2062 14:39',
  '9k2062': '23/9/2062 00:19',
  '10t2062': '8/10/2062 06:44',
  '10k2062': '23/10/2062 10:07',
  '11t2062': '7/11/2062 10:22',
  '11k2062': '22/11/2062 08:06',
  '12t2062': '7/12/2062 03:33',
  '12k2062': '21/12/2062 21:42',
  '1t2063': '5/1/2063 14:56',
  '1k2063': '20/1/2063 08:23',
  '2t2063': '4/2/2063 02:30',
  '2k2063': '18/2/2063 22:20',
  '3t2063': '5/3/2063 20:13',
  '3k2063': '20/3/2063 20:58',
  '4t2063': '5/4/2063 00:36',
  '4k2063': '20/4/2063 07:34',
  '5t2063': '5/5/2063 17:27',
  '5k2063': '21/5/2063 06:19',
  '6t2063': '5/6/2063 21:17',
  '6k2063': '21/6/2063 14:01',
  '7t2063': '7/7/2063 07:24',
  '7k2063': '23/7/2063 00:52',
  '8t2063': '7/8/2063 17:19',
  '8k2063': '23/8/2063 08:08',
  '9t2063': '7/9/2063 20:33',
  '9k2063': '23/9/2063 06:07',
  '10t2063': '8/10/2063 12:36',
  '10k2063': '23/10/2063 15:52',
  '11t2063': '7/11/2063 16:11',
  '11k2063': '22/11/2063 13:47',
  '12t2063': '7/12/2063 09:20',
  '12k2063': '22/12/2063 03:20',
  '1t2064': '5/1/2064 20:40',
  '1k2064': '20/1/2064 14:00',
  '2t2064': '4/2/2064 08:14',
  '2k2064': '19/2/2064 03:58',
  '3t2064': '5/3/2064 01:58',
  '3k2064': '20/3/2064 02:38',
  '4t2064': '4/4/2064 06:23',
  '4k2064': '19/4/2064 13:15',
  '5t2064': '4/5/2064 23:18',
  '5k2064': '20/5/2064 12:01',
  '6t2064': '5/6/2064 03:09',
  '6k2064': '20/6/2064 19:45',
  '7t2064': '6/7/2064 13:19',
  '7k2064': '22/7/2064 06:38',
  '8t2064': '6/8/2064 23:13',
  '8k2064': '22/8/2064 13:56',
  '9t2064': '7/9/2064 02:25',
  '9k2064': '22/9/2064 11:56',
  '10t2064': '7/10/2064 18:27',
  '10k2064': '22/10/2064 21:41',
  '11t2064': '6/11/2064 22:01',
  '11k2064': '21/11/2064 19:36',
  '12t2064': '6/12/2064 15:08',
  '12k2064': '21/12/2064 09:08',
  '1t2065': '5/1/2065 02:29',
  '1k2065': '19/1/2065 19:48',
  '2t2065': '3/2/2065 14:03',
  '2k2065': '18/2/2065 09:47',
  '3t2065': '5/3/2065 07:48',
  '3k2065': '20/3/2065 08:27',
  '4t2065': '4/4/2065 12:13',
  '4k2065': '19/4/2065 19:05',
  '5t2065': '5/5/2065 05:04',
  '5k2065': '20/5/2065 17:50',
  '6t2065': '5/6/2065 08:51',
  '6k2065': '21/6/2065 01:32',
  '7t2065': '6/7/2065 18:56',
  '7k2065': '22/7/2065 12:23',
  '8t2065': '7/8/2065 04:48',
  '8k2065': '22/8/2065 19:40',
  '9t2065': '7/9/2065 08:01',
  '9k2065': '22/9/2065 17:42',
  '10t2065': '8/10/2065 00:05',
  '10k2065': '23/10/2065 03:29',
  '11t2065': '7/11/2065 03:42',
  '11k2065': '22/11/2065 01:26',
  '12t2065': '6/12/2065 20:52',
  '12k2065': '21/12/2065 15:00',
  '1t2066': '5/1/2066 08:14',
  '1k2066': '20/1/2066 01:41',
  '2t2066': '3/2/2066 19:48',
  '2k2066': '18/2/2066 15:40',
  '3t2066': '5/3/2066 13:33',
  '3k2066': '20/3/2066 14:19',
  '4t2066': '4/4/2066 17:57',
  '4k2066': '20/4/2066 00:54',
  '5t2066': '5/5/2066 10:48',
  '5k2066': '20/5/2066 23:36',
  '6t2066': '5/6/2066 14:35',
  '6k2066': '21/6/2066 07:15',
  '7t2066': '7/7/2066 00:41',
  '7k2066': '22/7/2066 18:05',
  '8t2066': '7/8/2066 10:36',
  '8k2066': '23/8/2066 01:23',
  '9t2066': '7/9/2066 13:52',
  '9k2066': '22/9/2066 23:26',
  '10t2066': '8/10/2066 06:00',
  '10k2066': '23/10/2066 09:15',
  '11t2066': '7/11/2066 09:38',
  '11k2066': '22/11/2066 07:13',
  '12t2066': '7/12/2066 02:48',
  '12k2066': '21/12/2066 20:45',
  '1t2067': '5/1/2067 14:06',
  '1k2067': '20/1/2067 07:22',
  '2t2067': '4/2/2067 01:36',
  '2k2067': '18/2/2067 21:16',
  '3t2067': '5/3/2067 19:18',
  '3k2067': '20/3/2067 19:53',
  '4t2067': '4/4/2067 23:40',
  '4k2067': '20/4/2067 06:28',
  '5t2067': '5/5/2067 16:31',
  '5k2067': '21/5/2067 05:12',
  '6t2067': '5/6/2067 20:20',
  '6k2067': '21/6/2067 12:55',
  '7t2067': '7/7/2067 06:28',
  '7k2067': '22/7/2067 23:50',
  '8t2067': '7/8/2067 16:24',
  '8k2067': '23/8/2067 07:11',
  '9t2067': '7/9/2067 19:41',
  '9k2067': '23/9/2067 05:19',
  '10t2067': '8/10/2067 11:50',
  '10k2067': '23/10/2067 15:11',
  '11t2067': '7/11/2067 15:29',
  '11k2067': '22/11/2067 13:10',
  '12t2067': '7/12/2067 08:40',
  '12k2067': '22/12/2067 02:42',
  '1t2068': '5/1/2068 19:58',
  '1k2068': '20/1/2068 13:19',
  '2t2068': '4/2/2068 07:28',
  '2k2068': '19/2/2068 03:12',
  '3t2068': '5/3/2068 01:08',
  '3k2068': '20/3/2068 01:48',
  '4t2068': '4/4/2068 05:29',
  '4k2068': '19/4/2068 12:23',
  '5t2068': '4/5/2068 22:20',
  '5k2068': '20/5/2068 11:09',
  '6t2068': '5/6/2068 02:09',
  '6k2068': '20/6/2068 18:53',
  '7t2068': '6/7/2068 12:16',
  '7k2068': '22/7/2068 05:46',
  '8t2068': '6/8/2068 22:10',
  '8k2068': '22/8/2068 13:03',
  '9t2068': '7/9/2068 01:25',
  '9k2068': '22/9/2068 11:06',
  '10t2068': '7/10/2068 17:32',
  '10k2068': '22/10/2068 20:56',
  '11t2068': '6/11/2068 21:12',
  '11k2068': '21/11/2068 18:56',
  '12t2068': '6/12/2068 14:25',
  '12k2068': '21/12/2068 08:32',
  '1t2069': '5/1/2069 01:47',
  '1k2069': '19/1/2069 19:12',
  '2t2069': '3/2/2069 13:20',
  '2k2069': '18/2/2069 09:08',
  '3t2069': '5/3/2069 07:02',
  '3k2069': '20/3/2069 07:44',
  '4t2069': '4/4/2069 11:23',
  '4k2069': '19/4/2069 18:18',
  '5t2069': '5/5/2069 04:14',
  '5k2069': '20/5/2069 17:00',
  '6t2069': '5/6/2069 08:02',
  '6k2069': '21/6/2069 00:40',
  '7t2069': '6/7/2069 18:10',
  '7k2069': '22/7/2069 11:31',
  '8t2069': '7/8/2069 04:05',
  '8k2069': '22/8/2069 18:48',
  '9t2069': '7/9/2069 07:20',
  '9k2069': '22/9/2069 16:51',
  '10t2069': '7/10/2069 23:26',
  '10k2069': '23/10/2069 02:41',
  '11t2069': '7/11/2069 03:06',
  '11k2069': '22/11/2069 00:43',
  '12t2069': '6/12/2069 20:21',
  '12k2069': '21/12/2069 14:21',
  '1t2070': '5/1/2070 07:47',
  '1k2070': '20/1/2070 01:04',
  '2t2070': '3/2/2070 19:21',
  '2k2070': '18/2/2070 15:00',
  '3t2070': '5/3/2070 13:01',
  '3k2070': '20/3/2070 13:34',
  '4t2070': '4/4/2070 17:19',
  '4k2070': '20/4/2070 00:04',
  '5t2070': '5/5/2070 10:04',
  '5k2070': '20/5/2070 22:42',
  '6t2070': '5/6/2070 13:47',
  '6k2070': '21/6/2070 06:22',
  '7t2070': '6/7/2070 23:51',
  '7k2070': '22/7/2070 17:15',
  '8t2070': '7/8/2070 09:46',
  '8k2070': '23/8/2070 00:36',
  '9t2070': '7/9/2070 13:03',
  '9k2070': '22/9/2070 22:44',
  '10t2070': '8/10/2070 05:12',
  '10k2070': '23/10/2070 08:37',
  '11t2070': '7/11/2070 08:55',
  '11k2070': '22/11/2070 06:40',
  '12t2070': '7/12/2070 02:10',
  '12k2070': '21/12/2070 20:18',
  '1t2071': '5/1/2071 13:35',
  '1k2071': '20/1/2071 07:01',
  '2t2071': '4/2/2071 01:10',
  '2k2071': '18/2/2071 20:59',
  '3t2071': '5/3/2071 18:52',
  '3k2071': '20/3/2071 19:34',
  '4t2071': '4/4/2071 23:10',
  '4k2071': '20/4/2071 06:04',
  '5t2071': '5/5/2071 15:54',
  '5k2071': '21/5/2071 04:42',
  '6t2071': '5/6/2071 19:37',
  '6k2071': '21/6/2071 12:20',
  '7t2071': '7/7/2071 05:42',
  '7k2071': '22/7/2071 23:11',
  '8t2071': '7/8/2071 15:38',
  '8k2071': '23/8/2071 06:31',
  '9t2071': '7/9/2071 18:57',
  '9k2071': '23/9/2071 04:37',
  '10t2071': '8/10/2071 11:07',
  '10k2071': '23/10/2071 14:28',
  '11t2071': '7/11/2071 14:48',
  '11k2071': '22/11/2071 12:28',
  '12t2071': '7/12/2071 08:00',
  '12k2071': '22/12/2071 02:03',
  '1t2072': '5/1/2072 19:22',
  '1k2072': '20/1/2072 12:44',
  '2t2072': '4/2/2072 06:56',
  '2k2072': '19/2/2072 02:42',
  '3t2072': '5/3/2072 00:40',
  '3k2072': '20/3/2072 01:20',
  '4t2072': '4/4/2072 05:03',
  '4k2072': '19/4/2072 11:54',
  '5t2072': '4/5/2072 21:53',
  '5k2072': '20/5/2072 10:35',
  '6t2072': '5/6/2072 01:39',
  '6k2072': '20/6/2072 18:13',
  '7t2072': '6/7/2072 11:44',
  '7k2072': '22/7/2072 05:03',
  '8t2072': '6/8/2072 21:38',
  '8k2072': '22/8/2072 12:21',
  '9t2072': '7/9/2072 00:54',
  '9k2072': '22/9/2072 10:27',
  '10t2072': '7/10/2072 17:02',
  '10k2072': '22/10/2072 20:19',
  '11t2072': '6/11/2072 20:43',
  '11k2072': '21/11/2072 18:19',
  '12t2072': '6/12/2072 13:56',
  '12k2072': '21/12/2072 07:55',
  '1t2073': '5/1/2073 01:18',
  '1k2073': '19/1/2073 18:36',
  '2t2073': '3/2/2073 12:52',
  '2k2073': '18/2/2073 08:34',
  '3t2073': '5/3/2073 06:36',
  '3k2073': '20/3/2073 07:12',
  '4t2073': '4/4/2073 10:58',
  '4k2073': '19/4/2073 17:47',
  '5t2073': '5/5/2073 03:47',
  '5k2073': '20/5/2073 16:28',
  '6t2073': '5/6/2073 07:30',
  '6k2073': '21/6/2073 00:06',
  '7t2073': '6/7/2073 17:30',
  '7k2073': '22/7/2073 10:54',
  '8t2073': '7/8/2073 03:19',
  '8k2073': '22/8/2073 18:10',
  '9t2073': '7/9/2073 06:32',
  '9k2073': '22/9/2073 16:14',
  '10t2073': '7/10/2073 22:40',
  '10k2073': '23/10/2073 02:07',
  '11t2073': '7/11/2073 02:23',
  '11k2073': '22/11/2073 00:10',
  '12t2073': '6/12/2073 19:39',
  '12k2073': '21/12/2073 13:50',
  '1t2074': '5/1/2074 07:05',
  '1k2074': '20/1/2074 00:33',
  '2t2074': '3/2/2074 18:40',
  '2k2074': '18/2/2074 14:31',
  '3t2074': '5/3/2074 12:23',
  '3k2074': '20/3/2074 13:08',
  '4t2074': '4/4/2074 16:44',
  '4k2074': '19/4/2074 23:41',
  '5t2074': '5/5/2074 09:32',
  '5k2074': '20/5/2074 22:21',
  '6t2074': '5/6/2074 13:17',
  '6k2074': '21/6/2074 05:57',
  '7t2074': '6/7/2074 23:20',
  '7k2074': '22/7/2074 16:45',
  '8t2074': '7/8/2074 09:12',
  '8k2074': '23/8/2074 00:00',
  '9t2074': '7/9/2074 12:27',
  '9k2074': '22/9/2074 22:03',
  '10t2074': '8/10/2074 04:36',
  '10k2074': '23/10/2074 07:55',
  '11t2074': '7/11/2074 08:19',
  '11k2074': '22/11/2074 05:57',
  '12t2074': '7/12/2074 01:33',
  '12k2074': '21/12/2074 19:34',
  '1t2075': '5/1/2075 12:57',
  '1k2075': '20/1/2075 06:16',
  '2t2075': '4/2/2075 00:30',
  '2k2075': '18/2/2075 20:11',
  '3t2075': '5/3/2075 18:10',
  '3k2075': '20/3/2075 18:46',
  '4t2075': '4/4/2075 22:30',
  '4k2075': '20/4/2075 05:17',
  '5t2075': '5/5/2075 15:19',
  '5k2075': '21/5/2075 03:59',
  '6t2075': '5/6/2075 19:06',
  '6k2075': '21/6/2075 11:39',
  '7t2075': '7/7/2075 05:12',
  '7k2075': '22/7/2075 22:32',
  '8t2075': '7/8/2075 15:07',
  '8k2075': '23/8/2075 05:52',
  '9t2075': '7/9/2075 18:23',
  '9k2075': '23/9/2075 03:58',
  '10t2075': '8/10/2075 10:30',
  '10k2075': '23/10/2075 13:50',
  '11t2075': '7/11/2075 14:11',
  '11k2075': '22/11/2075 11:50',
  '12t2075': '7/12/2075 07:23',
  '12k2075': '22/12/2075 01:26',
  '1t2076': '5/1/2076 18:46',
  '1k2076': '20/1/2076 12:07',
  '2t2076': '4/2/2076 06:19',
  '2k2076': '19/2/2076 02:02',
  '3t2076': '5/3/2076 00:00',
  '3k2076': '20/3/2076 00:38',
  '4t2076': '4/4/2076 04:19',
  '4k2076': '19/4/2076 11:11',
  '5t2076': '4/5/2076 21:07',
  '5k2076': '20/5/2076 09:54',
  '6t2076': '5/6/2076 00:54',
  '6k2076': '20/6/2076 17:36',
  '7t2076': '6/7/2076 10:59',
  '7k2076': '22/7/2076 04:29',
  '8t2076': '6/8/2076 20:54',
  '8k2076': '22/8/2076 11:47',
  '9t2076': '7/9/2076 00:08',
  '9k2076': '22/9/2076 09:49',
  '10t2076': '7/10/2076 16:14',
  '10k2076': '22/10/2076 19:38',
  '11t2076': '6/11/2076 19:53',
  '11k2076': '21/11/2076 17:37',
  '12t2076': '6/12/2076 13:05',
  '12k2076': '21/12/2076 07:12',
  '1t2077': '5/1/2077 00:28',
  '1k2077': '19/1/2077 17:54',
  '2t2077': '3/2/2077 12:02',
  '2k2077': '18/2/2077 07:53',
  '3t2077': '5/3/2077 05:46',
  '3k2077': '20/3/2077 06:30',
  '4t2077': '4/4/2077 10:08',
  '4k2077': '19/4/2077 17:03',
  '5t2077': '5/5/2077 02:57',
  '5k2077': '20/5/2077 15:44',
  '6t2077': '5/6/2077 06:44',
  '6k2077': '20/6/2077 23:23',
  '7t2077': '6/7/2077 16:50',
  '7k2077': '22/7/2077 10:13',
  '8t2077': '7/8/2077 02:46',
  '8k2077': '22/8/2077 17:31',
  '9t2077': '7/9/2077 06:02',
  '9k2077': '22/9/2077 15:35',
  '10t2077': '7/10/2077 22:10',
  '10k2077': '23/10/2077 01:25',
  '11t2077': '7/11/2077 01:49',
  '11k2077': '21/11/2077 23:24',
  '12t2077': '6/12/2077 19:01',
  '12k2077': '21/12/2077 13:00',
  '1t2078': '5/1/2078 06:24',
  '1k2078': '19/1/2078 23:40',
  '2t2078': '3/2/2078 17:56',
  '2k2078': '18/2/2078 13:36',
  '3t2078': '5/3/2078 11:37',
  '3k2078': '20/3/2078 12:10',
  '4t2078': '4/4/2078 15:55',
  '4k2078': '19/4/2078 22:40',
  '5t2078': '5/5/2078 08:41',
  '5k2078': '20/5/2078 21:18',
  '6t2078': '5/6/2078 12:24',
  '6k2078': '21/6/2078 04:57',
  '7t2078': '6/7/2078 22:28',
  '7k2078': '22/7/2078 15:50',
  '8t2078': '7/8/2078 08:23',
  '8k2078': '22/8/2078 23:13',
  '9t2078': '7/9/2078 11:43',
  '9k2078': '22/9/2078 21:24',
  '10t2078': '8/10/2078 03:55',
  '10k2078': '23/10/2078 07:20',
  '11t2078': '7/11/2078 07:38',
  '11k2078': '22/11/2078 05:22',
  '12t2078': '7/12/2078 00:52',
  '12k2078': '21/12/2078 18:57',
  '1t2079': '5/1/2079 12:13',
  '1k2079': '20/1/2079 05:35',
  '2t2079': '3/2/2079 23:42',
  '2k2079': '18/2/2079 19:27',
  '3t2079': '5/3/2079 17:20',
  '3k2079': '20/3/2079 18:00',
  '4t2079': '4/4/2079 21:36',
  '4k2079': '20/4/2079 04:30',
  '5t2079': '5/5/2079 14:21',
  '5k2079': '21/5/2079 03:09',
  '6t2079': '5/6/2079 18:05',
  '6k2079': '21/6/2079 10:48',
  '7t2079': '7/7/2079 04:11',
  '7k2079': '22/7/2079 21:42',
  '8t2079': '7/8/2079 14:08',
  '8k2079': '23/8/2079 05:03',
  '9t2079': '7/9/2079 17:29',
  '9k2079': '23/9/2079 03:12',
  '10t2079': '8/10/2079 09:42',
  '10k2079': '23/10/2079 13:07',
  '11t2079': '7/11/2079 13:26',
  '11k2079': '22/11/2079 11:09',
  '12t2079': '7/12/2079 06:39',
  '12k2079': '22/12/2079 00:43',
  '1t2080': '5/1/2080 17:59',
  '1k2080': '20/1/2080 11:20',
  '2t2080': '4/2/2080 05:27',
  '2k2080': '19/2/2080 01:11',
  '3t2080': '4/3/2080 23:04',
  '3k2080': '19/3/2080 23:43',
  '4t2080': '4/4/2080 03:22',
  '4k2080': '19/4/2080 10:13',
  '5t2080': '4/5/2080 20:10',
  '5k2080': '20/5/2080 08:54',
  '6t2080': '4/6/2080 23:57',
  '6k2080': '20/6/2080 16:33',
  '7t2080': '6/7/2080 10:05',
  '7k2080': '22/7/2080 03:26',
  '8t2080': '6/8/2080 20:02',
  '8k2080': '22/8/2080 10:47',
  '9t2080': '6/9/2080 23:22',
  '9k2080': '22/9/2080 08:55',
  '10t2080': '7/10/2080 15:33',
  '10k2080': '22/10/2080 18:51',
  '11t2080': '6/11/2080 19:18',
  '11k2080': '21/11/2080 16:55',
  '12t2080': '6/12/2080 12:33',
  '12k2080': '21/12/2080 06:32',
  '1t2081': '4/1/2081 23:55',
  '1k2081': '19/1/2081 17:11',
  '2t2081': '3/2/2081 11:25',
  '2k2081': '18/2/2081 07:03',
  '3t2081': '5/3/2081 05:02',
  '3k2081': '20/3/2081 05:33',
  '4t2081': '4/4/2081 09:16',
  '4k2081': '19/4/2081 16:01',
  '5t2081': '5/5/2081 01:59',
  '5k2081': '20/5/2081 14:38',
  '6t2081': '5/6/2081 05:40',
  '6k2081': '20/6/2081 22:15',
  '7t2081': '6/7/2081 15:43',
  '7k2081': '22/7/2081 09:07',
  '8t2081': '7/8/2081 01:36',
  '8k2081': '22/8/2081 16:28',
  '9t2081': '7/9/2081 04:54',
  '9k2081': '22/9/2081 14:37',
  '10t2081': '7/10/2081 21:06',
  '10k2081': '23/10/2081 00:34',
  '11t2081': '7/11/2081 00:52',
  '11k2081': '21/11/2081 22:40',
  '12t2081': '6/12/2081 18:11',
  '12k2081': '21/12/2081 12:22',
  '1t2082': '5/1/2082 05:38',
  '1k2082': '19/1/2082 23:05',
  '2t2082': '3/2/2082 17:11',
  '2k2082': '18/2/2082 12:59',
  '3t2082': '5/3/2082 10:49',
  '3k2082': '20/3/2082 11:30',
  '4t2082': '4/4/2082 15:02',
  '4k2082': '19/4/2082 21:54',
  '5t2082': '5/5/2082 07:42',
  '5k2082': '20/5/2082 20:28',
  '6t2082': '5/6/2082 11:21',
  '6k2082': '21/6/2082 04:02',
  '7t2082': '6/7/2082 21:24',
  '7k2082': '22/7/2082 14:52',
  '8t2082': '7/8/2082 07:20',
  '8k2082': '22/8/2082 22:13',
  '9t2082': '7/9/2082 10:42',
  '9k2082': '22/9/2082 20:22',
  '10t2082': '8/10/2082 02:57',
  '10k2082': '23/10/2082 06:19',
  '11t2082': '7/11/2082 06:43',
  '11k2082': '22/11/2082 04:25',
  '12t2082': '7/12/2082 00:01',
  '12k2082': '21/12/2082 18:04',
  '1t2083': '5/1/2083 11:25',
  '1k2083': '20/1/2083 04:45',
  '2t2083': '3/2/2083 22:57',
  '2k2083': '18/2/2083 18:39',
  '3t2083': '5/3/2083 16:35',
  '3k2083': '20/3/2083 17:10',
  '4t2083': '4/4/2083 20:49',
  '4k2083': '20/4/2083 03:35',
  '5t2083': '5/5/2083 13:31',
  '5k2083': '21/5/2083 02:08',
  '6t2083': '5/6/2083 17:11',
  '6k2083': '21/6/2083 09:43',
  '7t2083': '7/7/2083 03:15',
  '7k2083': '22/7/2083 20:35',
  '8t2083': '7/8/2083 13:12',
  '8k2083': '23/8/2083 03:58',
  '9t2083': '7/9/2083 16:34',
  '9k2083': '23/9/2083 02:11',
  '10t2083': '8/10/2083 08:49',
  '10k2083': '23/10/2083 12:09',
  '11t2083': '7/11/2083 12:35',
  '11k2083': '22/11/2083 10:15',
  '12t2083': '7/12/2083 05:51',
  '12k2083': '21/12/2083 23:52',
  '1t2084': '5/1/2084 17:14',
  '1k2084': '20/1/2084 10:33',
  '2t2084': '4/2/2084 04:46',
  '2k2084': '19/2/2084 00:27',
  '3t2084': '4/3/2084 22:24',
  '3k2084': '19/3/2084 22:59',
  '4t2084': '4/4/2084 02:40',
  '4k2084': '19/4/2084 09:27',
  '5t2084': '4/5/2084 19:22',
  '5k2084': '20/5/2084 08:04',
  '6t2084': '4/6/2084 23:02',
  '6k2084': '20/6/2084 15:40',
  '7t2084': '6/7/2084 09:03',
  '7k2084': '22/7/2084 02:30',
  '8t2084': '6/8/2084 18:55',
  '8k2084': '22/8/2084 09:50',
  '9t2084': '6/9/2084 22:13',
  '9k2084': '22/9/2084 07:58',
  '10t2084': '7/10/2084 14:26',
  '10k2084': '22/10/2084 17:55',
  '11t2084': '6/11/2084 18:13',
  '11k2084': '21/11/2084 16:01',
  '12t2084': '6/12/2084 11:30',
  '12k2084': '21/12/2084 05:40',
  '1t2085': '4/1/2085 22:55',
  '1k2085': '19/1/2085 16:23',
  '2t2085': '3/2/2085 10:29',
  '2k2085': '18/2/2085 06:19',
  '3t2085': '5/3/2085 04:10',
  '3k2085': '20/3/2085 04:53',
  '4t2085': '4/4/2085 08:27',
  '4k2085': '19/4/2085 15:22',
  '5t2085': '5/5/2085 01:12',
  '5k2085': '20/5/2085 13:58',
  '6t2085': '5/6/2085 04:54',
  '6k2085': '20/6/2085 21:32',
  '7t2085': '6/7/2085 14:55',
  '7k2085': '22/7/2085 08:19',
  '8t2085': '7/8/2085 00:49',
  '8k2085': '22/8/2085 15:36',
  '9t2085': '7/9/2085 04:07',
  '9k2085': '22/9/2085 13:43',
  '10t2085': '7/10/2085 20:20',
  '10k2085': '22/10/2085 23:39',
  '11t2085': '7/11/2085 00:07',
  '11k2085': '21/11/2085 21:46',
  '12t2085': '6/12/2085 17:26',
  '12k2085': '21/12/2085 11:28',
  '1t2086': '5/1/2086 04:53',
  '1k2086': '19/1/2086 22:11',
  '2t2086': '3/2/2086 16:26',
  '2k2086': '18/2/2086 12:04',
  '3t2086': '5/3/2086 10:03',
  '3k2086': '20/3/2086 10:34',
  '4t2086': '4/4/2086 14:17',
  '4k2086': '19/4/2086 21:00',
  '5t2086': '5/5/2086 06:58',
  '5k2086': '20/5/2086 19:34',
  '6t2086': '5/6/2086 10:38',
  '6k2086': '21/6/2086 03:09',
  '7t2086': '6/7/2086 20:39',
  '7k2086': '22/7/2086 13:59',
  '8t2086': '7/8/2086 06:33',
  '8k2086': '22/8/2086 21:20',
  '9t2086': '7/9/2086 09:52',
  '9k2086': '22/9/2086 19:31',
  '10t2086': '8/10/2086 02:06',
  '10k2086': '23/10/2086 05:31',
  '11t2086': '7/11/2086 05:55',
  '11k2086': '22/11/2086 03:40',
  '12t2086': '6/12/2086 23:15',
  '12k2086': '21/12/2086 17:22',
  '1t2087': '5/1/2087 10:42',
  '1k2087': '20/1/2087 04:04',
  '2t2087': '3/2/2087 22:14',
  '2k2087': '18/2/2087 17:58',
  '3t2087': '5/3/2087 15:51',
  '3k2087': '20/3/2087 16:27',
  '4t2087': '4/4/2087 20:04',
  '4k2087': '20/4/2087 02:53',
  '5t2087': '5/5/2087 12:44',
  '5k2087': '21/5/2087 01:28',
  '6t2087': '5/6/2087 16:24',
  '6k2087': '21/6/2087 09:05',
  '7t2087': '7/7/2087 02:27',
  '7k2087': '22/7/2087 19:57',
  '8t2087': '7/8/2087 12:23',
  '8k2087': '23/8/2087 03:19',
  '9t2087': '7/9/2087 15:43',
  '9k2087': '23/9/2087 01:27',
  '10t2087': '8/10/2087 07:57',
  '10k2087': '23/10/2087 11:23',
  '11t2087': '7/11/2087 11:42',
  '11k2087': '22/11/2087 09:28',
  '12t2087': '7/12/2087 04:59',
  '12k2087': '21/12/2087 23:08',
  '1t2088': '5/1/2088 16:24',
  '1k2088': '20/1/2088 09:50',
  '2t2088': '4/2/2088 03:57',
  '2k2088': '18/2/2088 23:44',
  '3t2088': '4/3/2088 21:36',
  '3k2088': '19/3/2088 22:16',
  '4t2088': '4/4/2088 01:52',
  '4k2088': '19/4/2088 08:43',
  '5t2088': '4/5/2088 18:36',
  '5k2088': '20/5/2088 07:19',
  '6t2088': '4/6/2088 22:19',
  '6k2088': '20/6/2088 14:56',
  '7t2088': '6/7/2088 08:25',
  '7k2088': '22/7/2088 01:47',
  '8t2088': '6/8/2088 18:23',
  '8k2088': '22/8/2088 09:09',
  '9t2088': '6/9/2088 21:43',
  '9k2088': '22/9/2088 07:17',
  '10t2088': '7/10/2088 13:55',
  '10k2088': '22/10/2088 17:13',
  '11t2088': '6/11/2088 17:40',
  '11k2088': '21/11/2088 15:17',
  '12t2088': '6/12/2088 10:56',
  '12k2088': '21/12/2088 04:55',
  '1t2089': '4/1/2089 22:20',
  '1k2089': '19/1/2089 15:37',
  '2t2089': '3/2/2089 09:54',
  '2k2089': '18/2/2089 05:33',
  '3t2089': '5/3/2089 03:34',
  '3k2089': '20/3/2089 04:06',
  '4t2089': '4/4/2089 07:50',
  '4k2089': '19/4/2089 14:33',
  '5t2089': '5/5/2089 00:31',
  '5k2089': '20/5/2089 13:07',
  '6t2089': '5/6/2089 04:10',
  '6k2089': '20/6/2089 20:42',
  '7t2089': '6/7/2089 14:10',
  '7k2089': '22/7/2089 07:33',
  '8t2089': '7/8/2089 00:04',
  '8k2089': '22/8/2089 14:55',
  '9t2089': '7/9/2089 03:23',
  '9k2089': '22/9/2089 13:06',
  '10t2089': '7/10/2089 19:37',
  '10k2089': '22/10/2089 23:05',
  '11t2089': '6/11/2089 23:24',
  '11k2089': '21/11/2089 21:11',
  '12t2089': '6/12/2089 16:42',
  '12k2089': '21/12/2089 10:51',
  '1t2090': '5/1/2090 04:08',
  '1k2090': '19/1/2090 21:34',
  '2t2090': '3/2/2090 15:41',
  '2k2090': '18/2/2090 11:29',
  '3t2090': '5/3/2090 09:21',
  '3k2090': '20/3/2090 10:01',
  '4t2090': '4/4/2090 13:35',
  '4k2090': '19/4/2090 20:28',
  '5t2090': '5/5/2090 06:16',
  '5k2090': '20/5/2090 19:01',
  '6t2090': '5/6/2090 09:54',
  '6k2090': '21/6/2090 02:35',
  '7t2090': '6/7/2090 19:56',
  '7k2090': '22/7/2090 13:25',
  '8t2090': '7/8/2090 05:52',
  '8k2090': '22/8/2090 20:46',
  '9t2090': '7/9/2090 09:15',
  '9k2090': '22/9/2090 18:59',
  '10t2090': '8/10/2090 01:33',
  '10k2090': '23/10/2090 04:59',
  '11t2090': '7/11/2090 05:22',
  '11k2090': '22/11/2090 03:05',
  '12t2090': '6/12/2090 22:39',
  '12k2090': '21/12/2090 16:43',
  '1t2091': '5/1/2091 10:01',
  '1k2091': '20/1/2091 03:21',
  '2t2091': '3/2/2091 21:30',
  '2k2091': '18/2/2091 17:12',
  '3t2091': '5/3/2091 15:05',
  '3k2091': '20/3/2091 15:41',
  '4t2091': '4/4/2091 19:19',
  '4k2091': '20/4/2091 02:07',
  '5t2091': '5/5/2091 12:02',
  '5k2091': '21/5/2091 00:42',
  '6t2091': '5/6/2091 15:45',
  '6k2091': '21/6/2091 08:18',
  '7t2091': '7/7/2091 01:50',
  '7k2091': '22/7/2091 19:11',
  '8t2091': '7/8/2091 11:49',
  '8k2091': '23/8/2091 02:35',
  '9t2091': '7/9/2091 15:13',
  '9k2091': '23/9/2091 00:50',
  '10t2091': '8/10/2091 07:31',
  '10k2091': '23/10/2091 10:52',
  '11t2091': '7/11/2091 11:20',
  '11k2091': '22/11/2091 09:00',
  '12t2091': '7/12/2091 04:38',
  '12k2091': '21/12/2091 22:38',
  '1t2092': '5/1/2092 16:00',
  '1k2092': '20/1/2092 09:16',
  '2t2092': '4/2/2092 03:28',
  '2k2092': '18/2/2092 23:05',
  '3t2092': '4/3/2092 21:02',
  '3k2092': '19/3/2092 21:33',
  '4t2092': '4/4/2092 01:14',
  '4k2092': '19/4/2092 07:59',
  '5t2092': '4/5/2092 17:55',
  '5k2092': '20/5/2092 06:36',
  '6t2092': '4/6/2092 21:37',
  '6k2092': '20/6/2092 14:14',
  '7t2092': '6/7/2092 07:40',
  '7k2092': '22/7/2092 01:07',
  '8t2092': '6/8/2092 17:35',
  '8k2092': '22/8/2092 08:29',
  '9t2092': '6/9/2092 20:55',
  '9k2092': '22/9/2092 06:41',
  '10t2092': '7/10/2092 13:11',
  '10k2092': '22/10/2092 16:41',
  '11t2092': '6/11/2092 17:00',
  '11k2092': '21/11/2092 14:50',
  '12t2092': '6/12/2092 10:20',
  '12k2092': '21/12/2092 04:31',
  '1t2093': '4/1/2093 21:46',
  '1k2093': '19/1/2093 15:13',
  '2t2093': '3/2/2093 09:18',
  '2k2093': '18/2/2093 05:05',
  '3t2093': '5/3/2093 02:54',
  '3k2093': '20/3/2093 03:34',
  '4t2093': '4/4/2093 07:05',
  '4k2093': '19/4/2093 13:58',
  '5t2093': '4/5/2093 23:45',
  '5k2093': '20/5/2093 12:31',
  '6t2093': '5/6/2093 03:26',
  '6k2093': '20/6/2093 20:06',
  '7t2093': '6/7/2093 13:30',
  '7k2093': '22/7/2093 06:57',
  '8t2093': '6/8/2093 23:27',
  '8k2093': '22/8/2093 14:18',
  '9t2093': '7/9/2093 02:49',
  '9k2093': '22/9/2093 12:28',
  '10t2093': '7/10/2093 19:05',
  '10k2093': '22/10/2093 22:28',
  '11t2093': '6/11/2093 22:55',
  '11k2093': '21/11/2093 20:37',
  '12t2093': '6/12/2093 16:16',
  '12k2093': '21/12/2093 10:20',
  '1t2094': '5/1/2094 03:44',
  '1k2094': '19/1/2094 21:03',
  '2t2094': '3/2/2094 15:16',
  '2k2094': '18/2/2094 10:55',
  '3t2094': '5/3/2094 08:51',
  '3k2094': '20/3/2094 09:21',
  '4t2094': '4/4/2094 12:59',
  '4k2094': '19/4/2094 19:40',
  '5t2094': '5/5/2094 05:35',
  '5k2094': '20/5/2094 18:09',
  '6t2094': '5/6/2094 09:11',
  '6k2094': '21/6/2094 01:42',
  '7t2094': '6/7/2094 19:13',
  '7k2094': '22/7/2094 12:34',
  '8t2094': '7/8/2094 05:11',
  '8k2094': '22/8/2094 19:59',
  '9t2094': '7/9/2094 08:35',
  '9k2094': '22/9/2094 18:16',
  '10t2094': '8/10/2094 00:54',
  '10k2094': '23/10/2094 04:19',
  '11t2094': '7/11/2094 04:46',
  '11k2094': '22/11/2094 02:30',
  '12t2094': '6/12/2094 22:07',
  '12k2094': '21/12/2094 16:13',
  '1t2095': '5/1/2095 09:34',
  '1k2095': '20/1/2095 02:55',
  '2t2095': '3/2/2095 21:06',
  '2k2095': '18/2/2095 16:47',
  '3t2095': '5/3/2095 14:41',
  '3k2095': '20/3/2095 15:14',
  '4t2095': '4/4/2095 18:50',
  '4k2095': '20/4/2095 01:35',
  '5t2095': '5/5/2095 11:25',
  '5k2095': '21/5/2095 00:05',
  '6t2095': '5/6/2095 15:00',
  '6k2095': '21/6/2095 07:38',
  '7t2095': '7/7/2095 01:00',
  '7k2095': '22/7/2095 18:30',
  '8t2095': '7/8/2095 10:58',
  '8k2095': '23/8/2095 01:56',
  '9t2095': '7/9/2095 14:23',
  '9k2095': '23/9/2095 00:10',
  '10t2095': '8/10/2095 06:42',
  '10k2095': '23/10/2095 10:12',
  '11t2095': '7/11/2095 10:32',
  '11k2095': '22/11/2095 08:20',
  '12t2095': '7/12/2095 03:51',
  '12k2095': '21/12/2095 22:00',
  '1t2096': '5/1/2096 15:15',
  '1k2096': '20/1/2096 08:41',
  '2t2096': '4/2/2096 02:46',
  '2k2096': '18/2/2096 22:33',
  '3t2096': '4/3/2096 20:22',
  '3k2096': '19/3/2096 21:02',
  '4t2096': '4/4/2096 00:35',
  '4k2096': '19/4/2096 07:26',
  '5t2096': '4/5/2096 17:15',
  '5k2096': '20/5/2096 05:58',
  '6t2096': '4/6/2096 20:54',
  '6k2096': '20/6/2096 13:30',
  '7t2096': '6/7/2096 06:56',
  '7k2096': '22/7/2096 00:19',
  '8t2096': '6/8/2096 16:53',
  '8k2096': '22/8/2096 07:41',
  '9t2096': '6/9/2096 20:16',
  '9k2096': '22/9/2096 05:54',
  '10t2096': '7/10/2096 12:35',
  '10k2096': '22/10/2096 15:55',
  '11t2096': '6/11/2096 16:25',
  '11k2096': '21/11/2096 14:05',
  '12t2096': '6/12/2096 09:45',
  '12k2096': '21/12/2096 03:45',
  '1t2097': '4/1/2097 21:10',
  '1k2097': '19/1/2097 14:26',
  '2t2097': '3/2/2097 08:41',
  '2k2097': '18/2/2097 04:19',
  '3t2097': '5/3/2097 02:17',
  '3k2097': '20/3/2097 02:48',
  '4t2097': '4/4/2097 06:29',
  '4k2097': '19/4/2097 13:11',
  '5t2097': '4/5/2097 23:07',
  '5k2097': '20/5/2097 11:41',
  '6t2097': '5/6/2097 02:43',
  '6k2097': '20/6/2097 19:13',
  '7t2097': '6/7/2097 12:41',
  '7k2097': '22/7/2097 06:00',
  '8t2097': '6/8/2097 22:32',
  '8k2097': '22/8/2097 13:21',
  '9t2097': '7/9/2097 01:52',
  '9k2097': '22/9/2097 11:35',
  '10t2097': '7/10/2097 18:10',
  '10k2097': '22/10/2097 21:39',
  '11t2097': '6/11/2097 22:03',
  '11k2097': '21/11/2097 19:52',
  '12t2097': '6/12/2097 15:27',
  '12k2097': '21/12/2097 09:37',
  '1t2098': '5/1/2098 02:56',
  '1k2098': '19/1/2098 20:20',
  '2t2098': '3/2/2098 14:28',
  '2k2098': '18/2/2098 10:13',
  '3t2098': '5/3/2098 08:03',
  '3k2098': '20/3/2098 08:40',
  '4t2098': '4/4/2098 12:12',
  '4k2098': '19/4/2098 19:01',
  '5t2098': '5/5/2098 04:48',
  '5k2098': '20/5/2098 17:31',
  '6t2098': '5/6/2098 08:23',
  '6k2098': '21/6/2098 01:02',
  '7t2098': '6/7/2098 18:22',
  '7k2098': '22/7/2098 11:50',
  '8t2098': '7/8/2098 04:16',
  '8k2098': '22/8/2098 19:11',
  '9t2098': '7/9/2098 07:38',
  '9k2098': '22/9/2098 17:23',
  '10t2098': '7/10/2098 23:57',
  '10k2098': '23/10/2098 03:26',
  '11t2098': '7/11/2098 03:50',
  '11k2098': '22/11/2098 01:37',
  '12t2098': '6/12/2098 21:12',
  '12k2098': '21/12/2098 15:20'
}
